var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackimg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1453,
    height: 1453,
    viewBox: "0 0 1453 1453",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_22_220",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1453,
    height: 1453
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1453,
    height: 1453,
    fill: "url(#paint0_radial_22_220)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_22_220)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("path", {
    d: "M713.317 636.661C712.39 636.661 711.421 636.208 710.789 635.439C705.131 627.633 702.582 619.973 700.864 613.558L700.833 612.725C700.833 612.378 700.833 612.093 700.749 611.851L700.19 611.261L700.243 610.913C699.495 608.058 698.863 605.414 698.863 602.622C691.899 557.089 722.725 516.887 724.01 515.285C725.211 513.821 727.034 513.653 728.54 514.653C729.899 515.738 730.142 517.719 729.078 519.152C728.783 519.542 698.547 558.901 705.131 601.579L705.216 602.622C705.216 604.571 705.69 606.594 706.248 608.753C706.975 610.007 707.07 611.155 707.07 612.304C708.724 618.119 710.936 624.851 715.898 631.604C716.962 633.027 716.699 635.018 715.287 636.029C714.676 636.482 714.033 636.661 713.317 636.661Z",
    fill: "url(#paint1_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M739.76 636.661C739.149 636.661 738.538 636.482 737.895 636.071C736.484 635.092 736.231 633.079 737.116 631.678C741.54 625.41 743.837 619.068 745.386 614.19L745.66 612.894C747.335 608.121 747.988 604.044 748.588 599.209C753.393 557.015 724.326 519.542 724.115 519.152C723.03 517.73 723.178 515.739 724.6 514.696C725.885 513.653 727.961 513.821 729.077 515.286C730.31 516.855 760.009 555.066 754.857 599.314C754.225 604.887 753.529 609.449 751.717 614.674L751.612 615.58C749.979 621.017 747.324 628.128 742.362 635.334C741.751 636.208 740.782 636.661 739.749 636.661H739.76Z",
    fill: "url(#paint2_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.814 649.167C678.224 649.167 677.697 649.135 677.265 648.861C671.365 645.616 666.867 641.16 662.526 636.809L661.61 635.903L661.157 634.122C661.157 634.744 661.367 635.092 661.367 635.092C661.188 634.849 661.072 634.744 660.862 634.502C657.427 630.456 653.793 625.789 651.528 620.047C651.233 619.594 651.011 619.141 650.832 618.899L650.221 617.993C631.711 581.805 642.193 538.885 643.658 533.522C643.953 531.952 645.196 530.699 646.766 530.699C648.525 530.699 649.916 531.742 649.916 533.554L649.852 534.987C648.62 539.548 638.369 580.414 655.668 614.727C656.037 615.212 656.342 615.665 656.521 615.949L657.269 617.308C658.734 621.354 661.199 625.22 665.487 630.235C665.971 630.72 666.698 631.383 667.193 632.468C671.597 636.925 675.485 640.623 680.289 643.341C681.837 644.173 682.448 646.122 681.627 647.586C680.984 648.703 679.899 649.188 678.824 649.188L678.814 649.167Z",
    fill: "url(#paint3_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M703.244 638.536H702.58C700.853 638.01 699.778 636.345 700.178 634.596C701.864 627.527 702.075 620.279 700.821 613.241L700.737 611.914L699.883 611.008L700.115 610.134C700.115 608.111 699.609 605.951 698.946 603.444L698.861 602.612C687.989 561.819 646.87 537.883 645.174 536.872L643.942 535.755C642.614 534.607 642.614 532.616 643.773 531.267C645.006 530.045 647.049 530.045 648.303 531.194L648.935 531.784C650.157 532.373 693.51 557.626 705.088 601.252L705.225 601.979C705.751 604.413 706.31 606.752 706.457 609.228C707.068 610.555 707.068 612.009 707.068 612.715C708.448 620.026 708.217 628.107 706.373 636.05C706.046 637.578 704.793 638.526 703.255 638.526L703.244 638.536Z",
    fill: "url(#paint4_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651.137 673.757C650.915 673.757 650.684 673.757 650.473 673.62C641.623 671.702 634.502 668.953 628.138 665.086C624.325 663.306 621.101 660.704 617.898 658.154C581.857 629.835 575.926 581.163 575.715 579.182C575.441 577.402 576.695 575.843 578.507 575.632C580.193 575.421 581.836 576.675 581.973 578.413C582.047 578.866 587.968 626.485 621.638 653.065C624.883 655.573 627.749 657.87 631.183 659.513C637.125 663.137 643.657 665.644 651.853 667.488C653.539 667.878 654.624 669.574 654.223 671.291C653.844 672.756 652.643 673.767 651.137 673.767V673.757Z",
    fill: "url(#paint5_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.607 654.319C669.111 654.319 667.826 653.202 667.51 651.738C666.256 645.501 663.612 639.791 661.463 635.577L661.147 634.808C661.062 634.734 660.883 634.597 660.852 634.492L660.135 633.375C658.481 629.056 655.784 625.01 652.034 621.323L651.128 620.343V619.058C623.473 587.884 578.856 581.921 578.403 581.921C576.676 581.742 575.422 580.109 575.706 578.403C575.917 576.591 577.255 575.516 579.246 575.621C581.216 575.832 626.602 581.858 655.373 614.433C656.005 615.023 656.785 616.213 657.185 617.425C661.052 621.428 663.896 625.79 665.772 630.457C666.383 631.152 667.099 631.995 667.405 633.07C669.67 637.737 672.345 643.763 673.641 650.484C674.063 652.223 672.978 653.824 671.197 654.245C671.018 654.319 670.797 654.319 670.586 654.319H670.607Z",
    fill: "url(#paint6_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.86 708.142C619.984 708.142 617.15 708.005 614.347 707.689H614.21C609.038 707.689 603.654 706.604 597.754 704.381C555.793 692.255 531.794 650.041 530.867 648.26C529.929 646.722 530.551 644.773 532.015 643.941C533.648 643.067 535.513 643.625 536.355 645.195C536.587 645.542 560.144 686.924 599.788 698.281C605.287 700.367 609.891 701.379 614.663 701.379C621.806 702.011 628.254 701.863 634.901 700.715C636.261 700.367 638.209 701.653 638.547 703.328C638.842 705.003 637.704 706.678 635.86 706.983C631.614 707.752 627.306 708.132 622.87 708.132L622.86 708.142Z",
    fill: "url(#paint7_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M646.121 681.942C645.11 681.942 644.088 681.489 643.508 680.583C638.999 674.135 634.575 669.468 630.15 666.297L629.612 666.782L627.537 664.59C624.103 661.282 621.49 659.428 618.709 658.564L616.517 657.869V657.1C579.971 637.42 534.901 649.578 534.406 649.715C532.72 650.136 531.014 649.156 530.561 647.555C530.055 645.848 531.014 644.078 532.72 643.625C534.722 643.172 581.224 630.456 620.173 651.843C620.868 652.053 621.5 652.475 621.953 652.959C625.577 654.424 628.612 656.931 631.014 659.228C632.099 659.439 632.857 660.134 633.352 660.798C638.557 664.422 643.666 669.71 648.765 676.959C649.692 678.423 649.376 680.309 647.996 681.352C647.375 681.731 646.764 681.942 646.132 681.942H646.121Z",
    fill: "url(#paint8_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.001 755.245C549.357 755.245 516.751 730.234 515.286 729.086C513.854 727.969 513.559 725.989 514.644 724.556C515.718 723.197 517.783 722.986 519.142 723.997C519.543 724.345 558.712 754.444 601.58 747.996L602.749 747.849C604.593 747.849 606.584 747.396 608.754 746.88C610.008 746.111 611.23 745.942 612.357 745.942C618.068 744.372 624.863 742.181 631.69 737.198C633.027 736.155 635.103 736.397 636.114 737.925C637.105 739.284 636.789 741.275 635.419 742.276C627.612 747.986 619.985 750.493 613.59 752.2L612.81 752.274H611.852L611.22 753.074L611.03 752.895C608.312 753.527 605.531 754.191 602.739 754.191C598.072 754.96 593.489 755.234 589.001 755.234V755.245Z",
    fill: "url(#paint9_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.192 729.708C516.317 729.708 515.38 729.318 514.758 728.486C513.641 727.127 513.873 725.135 515.295 724.092C516.844 722.765 555.045 693.298 599.324 698.25C604.149 698.671 608.468 699.335 613.209 700.862L613.336 700.725L617.782 702.084C622.796 703.791 629.107 706.267 635.354 710.797C636.819 711.766 637.135 713.726 636.134 715.18C635.122 716.539 633.121 716.886 631.709 716.022C625.767 711.766 619.794 709.47 614.99 707.9L614.758 708.142L612.977 707.415C608.1 705.635 603.833 705.013 599.187 704.486C557.057 699.503 519.551 728.77 519.151 729.086C518.624 729.507 517.919 729.718 517.202 729.718L517.192 729.708Z",
    fill: "url(#paint10_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.645 813.727C549.829 813.727 535.322 809.997 533.478 809.481C532.014 809.165 530.676 807.806 530.676 806.342C530.676 804.666 531.792 803.202 533.562 803.202L535.027 803.339C536.807 803.729 579.422 815.318 614.778 797.45C615.284 797.102 615.716 796.818 616.032 796.681L617.264 795.985C622.111 794.068 626.704 791.076 630.602 787.241C631.371 786.441 631.993 786.093 632.793 785.819C636.733 782.3 640.6 777.77 643.402 773.314C644.361 771.744 646.415 771.291 647.785 772.271C649.249 773.208 649.734 775.168 648.796 776.622C645.467 781.847 640.905 787.241 636.154 791.287L634.774 792.014C630.328 796.333 625.334 799.61 620.056 801.664C619.519 802.085 619.076 802.254 618.771 802.507L617.949 802.96C601.472 811.283 583.689 813.727 568.623 813.727H568.645Z",
    fill: "url(#paint11_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.562 810.25C532.845 810.25 532.098 810.008 531.476 809.481C530.149 808.301 530.043 806.278 531.16 805.025L531.781 804.329C532.392 802.97 557.424 759.629 601.24 747.998C602.915 747.713 604.063 747.408 605.285 747.092C607.603 746.565 610.005 745.944 612.807 745.944C619.982 744.658 628.136 744.932 636.111 746.744C637.818 747.092 638.861 748.83 638.534 750.505C638.134 752.286 636.564 753.497 634.615 752.907C627.525 751.201 620.277 750.99 613.313 752.286C610.785 752.286 608.92 752.739 606.75 753.297C605.422 753.613 604.063 753.929 602.588 754.129C561.501 765.107 537.186 807.501 536.891 807.911L535.964 809.06C535.321 809.829 534.5 810.24 533.562 810.24V810.25Z",
    fill: "url(#paint12_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.863 877.474C577.262 877.474 575.829 876.22 575.713 874.65C575.439 872.87 576.693 871.237 578.505 871.132C578.937 871.058 626.514 865.106 653.073 831.488C655.56 828.348 657.877 825.43 659.605 821.943C663.155 815.948 665.652 809.469 667.517 801.326C667.896 799.693 669.297 798.365 671.267 798.924C673.006 799.303 674.091 801.052 673.669 802.716C671.678 811.534 668.981 818.709 665.146 824.945C663.25 828.917 660.585 832.194 658.056 835.396C629.833 871.216 581.255 877.168 579.19 877.474H578.874H578.863Z",
    fill: "url(#paint13_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.864 877.475H578.411C576.683 877.159 575.43 875.599 575.714 873.893C575.925 871.975 581.867 826.411 614.431 797.776C615.105 797.112 616.296 796.343 617.528 796.069C617.897 795.69 618.382 795.437 618.814 795.269C622.627 791.718 626.894 789.274 630.919 786.946C631.593 786.282 632.204 785.829 633.236 785.798C637.398 783.68 643.634 780.92 650.461 779.455C652.126 779.034 653.822 780.088 654.201 781.857C654.602 783.596 653.474 785.239 651.725 785.587C645.299 787.009 639.452 789.727 635.543 791.718L634.479 792.203C629.897 794.847 625.946 797.155 622.543 800.463L621.605 801.4L619.077 802.096C587.935 829.613 582.014 874.24 581.94 874.651C581.804 876.221 580.371 877.475 578.843 877.475H578.864Z",
    fill: "url(#paint14_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M646.743 922.734C645.606 922.734 644.542 922.144 643.941 921.196C643.088 919.594 643.646 917.677 645.174 916.813C645.606 916.602 686.925 893.056 698.366 853.307C700.41 847.66 701.347 843.098 701.347 838.463C702.074 831.288 701.874 824.873 700.831 818.183C700.568 816.518 701.758 814.875 703.423 814.559C705.424 814.559 706.752 815.57 707.068 817.245C708.216 824.314 708.448 831.352 707.711 838.737C707.711 843.889 706.678 849.114 704.371 855.351C692.319 897.365 650.062 921.396 648.303 922.407C647.818 922.649 647.27 922.723 646.754 922.723L646.743 922.734Z",
    fill: "url(#paint15_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M646.745 922.733C645.312 922.733 644.079 921.796 643.637 920.436C643.205 918.487 630.436 871.88 651.928 832.826C652.139 832.194 652.444 831.604 652.971 831.256C654.414 827.674 656.7 824.809 658.976 822.449L659.102 821.543C659.587 820.5 660.44 819.941 661.283 819.731C665.708 813.42 670.954 808.237 677.065 804.434C678.529 803.349 680.489 803.875 681.416 805.34C682.427 806.836 681.953 808.785 680.489 809.691C674.779 813.42 669.785 818.403 665.708 824.535L664.38 825.862C661.146 829.202 659.418 831.678 658.565 834.427L657.87 836.587H657.101C637.4 873.302 649.663 918.277 649.821 918.688C650.274 920.363 649.262 922.133 647.577 922.659C647.261 922.733 647.04 922.733 646.745 922.733Z",
    fill: "url(#paint16_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M726.593 939.168C725.898 939.168 725.224 938.926 724.613 938.399C723.18 937.356 723.043 935.407 724.023 933.943C724.339 933.521 754.554 894.267 748.001 851.526V850.409C748.001 848.429 747.443 846.406 746.853 844.246C746.126 843.098 746.02 841.844 746.02 840.728C744.419 835.017 742.08 828.222 737.192 821.459C736.233 820.173 736.497 818.077 737.908 817.139C739.299 815.959 741.237 816.265 742.333 817.771C748.012 825.473 750.55 833.1 752.257 839.505L752.32 840.275C752.32 840.696 752.32 840.896 752.352 841.212L753.079 841.844L752.942 842.087C753.606 845.015 754.227 847.586 754.227 850.409C761.265 896.079 730.407 936.145 729.08 937.883C728.437 938.652 727.531 939.168 726.583 939.168H726.593Z",
    fill: "url(#paint17_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M726.593 939.168C725.655 939.168 724.728 938.652 724.022 937.883C722.769 936.345 693.154 897.923 698.264 853.791C698.791 848.629 699.412 844.457 700.877 839.927L700.845 839.748L702.099 835.565C703.774 830.445 706.313 824.24 710.811 817.835C711.728 816.339 713.74 815.949 715.194 817.034C716.627 818.077 716.974 819.963 716.016 821.459C711.728 827.453 709.484 833.406 708.019 838.115L708.167 838.326L707.556 840.201C705.765 844.942 705.154 848.945 704.595 853.928C699.728 896.079 728.805 933.521 729.1 933.943C730.164 935.407 729.922 937.356 728.563 938.399C727.952 938.926 727.236 939.168 726.614 939.168H726.593Z",
    fill: "url(#paint18_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M806.342 922.417C804.667 922.417 803.203 921.301 803.203 919.594L803.34 918.056C803.824 916.212 815.36 873.819 797.482 838.283C797.061 837.799 796.86 837.272 796.65 836.998L795.954 835.702C794.142 830.93 791.077 826.337 787.21 822.46C786.483 821.764 786.062 821.174 785.851 820.268C782.227 816.339 777.697 812.462 773.304 809.68C771.839 808.774 771.355 806.899 772.261 805.329C773.093 803.865 775.253 803.338 776.612 804.423C781.806 807.595 787.136 812.156 791.245 816.792L792.014 818.393C796.365 822.744 799.642 827.727 801.738 833.026C802.086 833.448 802.254 834.006 802.507 834.28L802.992 835.112C821.808 872.112 810.451 916.033 809.471 919.594C809.123 921.09 807.87 922.417 806.332 922.417H806.342Z",
    fill: "url(#paint19_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M807.08 922.734H803.909L803.487 920.858C795.828 916.297 758.755 892.045 748.03 851.885C747.756 850.283 747.472 849.135 747.198 848.081C746.566 845.574 746.018 843.204 746.018 840.275C744.659 833.1 744.87 825.051 746.713 816.971C747.198 815.264 749.042 814.221 750.548 814.674C752.255 814.99 753.298 816.729 752.95 818.467C751.243 825.684 751.106 832.826 752.318 839.748C752.318 842.361 752.771 844.31 753.403 846.469C753.719 847.755 754.035 849.114 754.235 850.515C765.171 891.623 807.533 915.896 807.891 916.107L809.556 917.045V918.267C809.766 918.688 809.977 919.099 809.977 919.594C809.977 921.301 808.797 922.734 807.09 922.734H807.08Z",
    fill: "url(#paint20_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M874.345 877.474C872.68 877.474 871.321 876.22 871.142 874.651C871.037 874.134 865.085 827.211 831.983 800.736C829.128 798.229 824.809 794.952 820.247 792.972C814.642 789.347 808.511 787.641 801.895 785.797L802.031 782.489L803.633 779.666C810.323 781.509 817.423 783.532 823.344 787.367C828.085 789.484 832.889 793.182 836.029 795.827C871.216 823.977 877.168 871.869 877.484 873.892C877.664 875.599 876.399 877.274 874.703 877.474H874.356H874.345Z",
    fill: "url(#paint21_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M874.345 877.474H873.924C871.975 877.158 826.473 871.206 797.775 838.631C797.217 838.041 796.311 837.061 795.963 835.46C795.647 835.112 795.436 834.691 795.299 834.28C791.823 830.624 789.484 826.515 787.145 822.638L786.903 822.154C786.208 821.459 785.86 820.826 785.755 819.857C783.458 815.264 780.814 809.375 779.455 802.653C779.033 801.052 780.182 799.303 781.93 798.924C783.711 798.365 785.238 799.693 785.586 801.4C786.913 807.71 789.558 813.315 791.717 817.561L792.655 819.373C794.983 823.418 797.217 827.285 800.567 830.624L801.747 832.194L802.095 834.006C829.613 865.222 874.24 871.069 874.693 871.142C876.399 871.385 877.653 872.881 877.474 874.661C877.263 876.231 875.946 877.485 874.334 877.485L874.345 877.474Z",
    fill: "url(#paint22_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M919.627 809.543C918.447 809.543 917.468 809.027 916.836 807.911C916.593 807.489 893.016 766.254 853.298 754.718C847.588 752.632 843.058 751.621 838.422 751.621C831.322 751.031 824.8 751.273 818.216 752.285C816.509 752.527 814.834 751.347 814.56 749.672C814.349 747.86 815.498 746.259 817.204 746.016C824.379 744.9 831.353 744.657 838.728 745.426H838.865C843.911 745.426 849.031 746.396 855.31 748.703C897.388 760.829 921.355 803.043 922.409 804.824C923.178 806.362 922.683 808.311 921.155 809.175C920.639 809.385 920.144 809.554 919.627 809.554V809.543Z",
    fill: "url(#paint23_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M885.703 813.725C869.679 813.725 850.241 810.944 832.469 801.052C828.634 799.482 824.873 797.112 820.627 793.561C819.932 793.245 819.3 792.76 818.878 792.023C813.727 787.978 809.228 783.068 804.456 776.136C803.486 774.672 803.834 772.754 805.298 771.753C806.657 770.71 808.638 771.058 809.681 772.522C814.274 779.138 818.531 783.774 823.408 787.567L824.63 788.715C828.423 791.781 831.7 793.909 835.25 795.363C872.46 815.948 918.225 803.412 918.678 803.338C920.458 802.642 922.197 803.822 922.608 805.497C923.092 807.162 922.091 809.016 920.448 809.364C919.268 809.669 904.982 813.715 885.682 813.715L885.703 813.725Z",
    fill: "url(#paint24_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M935.999 729.708C935.304 729.708 934.577 729.497 933.913 729.076C933.565 728.759 894.48 698.555 851.486 705.14H850.369C848.42 705.14 846.502 705.624 844.301 706.109C843.047 706.878 841.867 707.047 840.75 707.047C834.619 708.753 828.14 711.092 821.45 715.896C820.122 716.876 818.036 716.623 817.13 715.232C816.045 713.768 816.361 711.851 817.763 710.776C825.358 705.203 833.017 702.622 839.433 700.778L840.276 700.715H841.214L841.878 700.083L842.088 700.262C845.259 699.387 847.735 698.871 850.379 698.871C896.018 692.044 936.252 722.702 937.885 723.987C939.307 725.104 939.56 727.127 938.443 728.486C937.811 729.318 936.905 729.708 935.999 729.708Z",
    fill: "url(#paint25_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M864.244 755.382C860.83 755.382 857.343 755.245 853.866 754.824C848.504 754.192 844.321 753.676 839.897 752.137L839.76 752.274L835.619 750.978C830.531 749.377 824.294 746.87 817.847 742.413C816.456 741.37 816.066 739.348 817.046 737.915C818.057 736.45 819.933 736.134 821.471 737.083C826.275 740.496 831.363 743.003 838.127 745.089L838.401 744.879L840.213 745.574C844.806 747.354 848.778 747.839 853.94 748.503C857.217 748.924 860.419 749.029 863.559 749.029C901.675 749.029 933.649 724.335 933.934 723.977C935.398 722.965 937.273 723.176 938.464 724.535C939.581 725.968 939.338 727.949 937.905 729.065C936.441 730.214 903.835 755.361 864.265 755.361L864.244 755.382Z",
    fill: "url(#paint26_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M807.077 681.941C806.55 681.941 805.992 681.836 805.444 681.488C803.906 680.582 803.495 678.665 804.359 677.201C808.784 669.921 814.631 664.2 818.782 660.692C822.437 657.553 827.21 653.728 833.025 651.421C833.51 651.147 833.868 650.905 834.174 650.726L835.111 650.199C871.026 631.805 914.009 642.15 919.624 643.615C921.089 643.857 922.406 645.184 922.406 646.712C922.406 648.419 921.363 649.778 919.624 649.778L918.055 649.714C913.556 648.492 872.595 638.431 838.388 655.561C837.829 656.088 837.271 656.33 836.965 656.467L835.743 657.237C831.698 658.701 827.937 661.208 823.027 665.422C816.822 670.711 812.787 675.389 809.753 680.403C809.121 681.415 808.152 681.941 807.067 681.941H807.077Z",
    fill: "url(#paint27_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M830.591 708.006C826.198 708.006 821.604 707.416 817.001 706.373C815.262 705.952 814.283 704.319 814.63 702.57C815.052 700.863 816.927 699.788 818.465 700.136C825.639 701.874 832.919 702.085 839.683 700.726C842.464 700.726 844.382 700.273 846.72 699.715C847.974 699.399 849.196 699.093 850.524 698.883C891.663 687.905 915.873 645.553 916.158 645.195L916.853 644.289L918.317 642.93L919.392 643.246C920.403 643.32 921.236 643.457 921.868 644.015L922.626 644.405L922.7 645.417V646.744H916.463H919.634L919.392 646.986L921.731 648.208C921.52 648.693 896.583 693.215 851.851 705.024C850.46 705.341 849.312 705.614 848.195 705.857C845.719 706.447 843.286 707.079 840.294 707.079C837.228 707.711 833.952 708.016 830.612 708.016L830.591 708.006Z",
    fill: "url(#paint28_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M782.509 654.318C782.267 654.318 782.025 654.318 781.814 654.244C780.139 653.823 779.033 652.158 779.443 650.409C781.603 641.244 784.279 634.206 788.009 628.117L788.778 627.211C790.8 622.965 792.96 619.899 795.425 617.424C823.333 581.931 871.89 575.831 873.912 575.62H874.334C875.935 575.62 877.263 576.768 877.473 578.401C877.652 580.108 876.388 581.752 874.692 581.92C874.134 581.92 826.62 587.873 800.113 621.638C797.848 623.934 796.068 626.579 794.193 630.445L793.255 631.804C789.947 637.24 787.545 643.614 785.596 651.831C785.248 653.296 783.995 654.307 782.53 654.307L782.509 654.318Z",
    fill: "url(#paint29_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M802.02 673.755C800.556 673.755 799.239 672.67 798.955 671.174C798.533 669.394 799.681 667.792 801.43 667.487C807.53 666.233 812.956 663.757 817.56 661.387L819.762 660.133C824.007 658.458 828.084 655.782 831.708 651.947L832.614 651.041H834.037C865.179 623.481 871.036 578.854 871.142 578.401C871.321 576.768 872.68 575.62 874.344 575.62H874.692C876.399 575.831 877.652 577.464 877.473 579.17C877.157 581.162 871.205 626.579 838.662 655.392C838.072 655.982 836.818 656.815 835.638 657.099C831.635 661.039 827.378 663.894 822.638 665.77C821.942 666.359 821.1 667.097 819.92 667.403C815.042 669.805 809.226 672.386 802.642 673.597C802.505 673.734 802.252 673.734 802.01 673.734L802.02 673.755Z",
    fill: "url(#paint30_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M749.208 638.536C747.68 638.536 746.247 637.42 746.005 635.892C744.857 628.791 744.751 621.501 745.373 614.253C745.373 609.164 746.49 603.77 748.713 597.776C760.839 555.804 803.021 531.731 804.802 530.783C806.298 529.908 808.152 530.33 809.121 532.005C809.996 533.501 809.469 535.481 807.868 536.25C807.52 536.524 766.243 560.112 754.781 599.788C752.695 605.329 751.715 609.997 751.715 614.664C751.094 621.733 751.231 628.286 752.305 634.838C752.621 636.545 751.367 638.22 749.661 638.526H749.208V638.536Z",
    fill: "url(#paint31_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M774.367 649.166C773.397 649.166 772.491 648.819 771.859 647.986C770.742 646.459 771.016 644.541 772.491 643.456C780.15 637.957 784.923 633.279 788.031 628.127C791.834 624.229 793.741 621.438 794.615 618.72C815.896 581.341 803.496 534.87 803.359 534.417C802.906 532.679 803.844 530.941 805.519 530.445C807.405 530.066 809.006 530.972 809.417 532.679C810.007 534.733 822.828 582.184 800.431 621.227C799.388 624.398 797.017 627.948 792.972 631.994C789.906 637.251 784.607 642.624 776.252 648.682C775.631 649.029 774.999 649.166 774.377 649.166H774.367Z",
    fill: "url(#paint32_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M726.59 827.527C670.901 827.527 625.674 782.173 625.674 726.579C625.674 670.985 670.912 625.694 726.59 625.694C782.269 625.694 827.528 670.88 827.528 726.579C827.528 782.279 782.248 827.527 726.59 827.527ZM726.59 638.326C677.928 638.326 638.348 677.896 638.348 726.569C638.348 775.241 677.918 814.874 726.59 814.874C775.263 814.874 814.854 775.336 814.854 726.569C814.854 677.801 775.315 638.326 726.59 638.326Z",
    fill: "url(#paint33_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M718.993 532.258C718.466 532.258 717.897 532.153 717.36 531.805C683.205 511.388 664.495 485.819 661.692 455.867C655.793 392.993 721.606 333.838 724.429 331.226C725.757 330.077 727.653 330.141 728.886 331.531C730.108 332.89 730.002 334.839 728.675 335.988C727.959 336.514 662.398 395.659 667.94 455.298C670.605 483.132 688.315 507.058 720.647 526.295C722.112 527.233 722.638 529.224 721.711 530.793C721.174 531.731 720.078 532.258 718.993 532.258Z",
    fill: "url(#paint34_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.081 532.258C733.038 532.258 732.006 531.7 731.395 530.688C730.457 529.224 731.026 527.243 732.49 526.295C765.023 507.205 782.827 483.375 785.545 455.615C791.393 395.943 725.748 336.514 725.031 335.956C723.778 334.839 723.651 332.89 724.8 331.531C725.948 330.141 727.95 330.067 729.277 331.289C732.079 333.828 797.977 393.331 791.877 456.215C788.948 486.135 770.038 511.598 735.704 531.805C735.272 532.153 734.661 532.258 734.071 532.258H734.081Z",
    fill: "url(#paint35_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M727.211 521.385L725.125 519.573C708.859 505.74 699.104 483.237 699.104 459.554C699.104 435.871 708.859 413.326 725.125 399.43L727.211 397.649L729.213 399.43C745.448 413.399 755.267 435.903 755.267 459.554C755.267 483.205 745.448 505.645 729.213 519.573L727.211 521.385ZM727.211 406.078C713.505 418.899 705.425 438.652 705.425 459.554C705.425 480.456 713.505 500.136 727.211 512.925C740.812 500.072 748.893 480.456 748.893 459.554C748.893 438.652 740.812 418.973 727.211 406.078Z",
    fill: "url(#paint36_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M726.728 335.187L725.242 333.933C714.423 324.631 707.996 309.755 707.996 294.047C707.996 278.339 714.254 263.421 725.242 254.056L726.728 252.833L728.139 254.056C739.149 263.421 745.385 277.949 745.385 294.047C745.385 310.145 738.98 324.704 728.139 333.933L726.728 335.187ZM726.728 258.765C717.604 267.298 712.4 280.12 712.4 294.058C712.4 307.996 717.762 320.775 726.728 329.277C735.64 320.775 741.024 307.753 741.024 294.058C741.024 280.362 735.819 267.309 726.728 258.765Z",
    fill: "url(#paint37_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M703.75 342.014C700.231 342.014 696.702 341.593 693.141 340.792C680.098 337.273 669.89 329.435 664.928 319.121L664.074 317.52L665.539 316.435C674.852 309.429 687.936 307.343 700.41 310.619C707.205 312.115 713.895 315.497 720.069 320.617L717.214 324.031C711.535 319.363 705.604 316.361 699.399 314.939C688.79 312.115 677.875 313.548 669.721 318.879C674.462 327.096 683.206 333.47 694.205 336.504C704.898 338.98 716.065 337.136 724.493 331.416L725.031 330.994H725.747L725.821 331.511L727.348 330.046L728.781 331.437V333.143L728.223 334.123C727.823 334.682 727.348 335.166 726.59 335.303C719.942 339.686 712.051 341.993 703.76 341.993L703.75 342.014Z",
    fill: "url(#paint38_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M748.586 342.225C742.613 342.225 736.66 340.834 731.256 338.116L733.152 334.144C740.695 337.874 749.629 338.738 757.33 336.515C768.445 333.828 777.084 327.423 782.13 318.679C780.244 317.594 778.19 316.73 775.925 315.824L775.409 315.55C768.508 313.043 760.017 312.8 752.316 315.034C746.574 316.182 742.55 318.373 738.325 320.712C737.893 321.587 736.861 322.008 735.955 322.008V317.552C735.017 317.552 734.385 318.458 734.385 319.153V317.868L735.502 317.236C740 314.654 744.646 312.042 751.304 310.683C759.806 308.312 769.035 308.523 777.01 311.483L777.642 311.726C780.676 312.948 783.774 314.159 786.418 316.15L787.956 317.236L787.113 318.911C781.509 329.772 771.437 337.579 758.479 340.855C755.339 341.761 752 342.246 748.586 342.246V342.225Z",
    fill: "url(#paint39_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M726.591 332.996H724.727C725.243 332.364 725.243 331.774 725.959 331.774",
    fill: "url(#paint40_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.573 450.01H444.468C431.215 450.01 417.814 444.089 407.616 433.88C396.438 422.797 390.475 407.616 391.508 393.436L391.645 391.445L393.509 391.308C407.932 390.096 422.892 396.112 434.112 407.363C445.237 418.615 451.147 433.596 449.978 447.808L449.82 449.652L447.987 449.789C446.786 449.894 445.722 449.999 444.573 449.999V450.01ZM395.816 395.669C395.5 408.069 400.989 420.996 410.713 430.678C420.174 440.117 432.395 445.448 444.468 445.448H445.637C446.111 433.259 440.654 420.301 430.899 410.545C421.459 401.106 409.175 395.669 397.039 395.669H395.816Z",
    fill: "url(#paint41_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.667 483.975C402.558 483.975 398.608 483.385 394.836 482.026L393.098 481.436L393.372 479.624C395.057 468.162 402.706 457.5 413.947 450.916C419.889 447.081 427.042 444.784 434.933 444.163L435.312 448.545C428.138 449.177 421.711 451.263 416.254 454.677C406.762 460.25 400.051 468.994 398.155 478.402C407.194 481.057 417.887 479.276 427.874 473.598C437.314 467.74 443.846 458.648 445.626 448.545L445.805 448.029L446.153 447.608L446.658 447.955V445.627H448.608L449.882 446.775L450.198 447.892C450.283 448.556 450.377 449.104 449.977 449.915C447.817 460.892 440.643 470.985 430.16 477.401C422.48 481.794 414.463 483.986 406.677 483.986L406.667 483.975Z",
    fill: "url(#paint42_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.952 456.214L444.616 449.103C444.584 448.755 444.479 448.345 444.479 447.892H445.206L445.87 447.017L447.503 446.775C457.364 445.1 466.887 438.273 472.429 429.013C478.023 419.331 479.814 408.564 477.496 399.124C467.741 401.358 459.133 407.837 453.634 417.382C450.431 422.259 448.514 427.485 447.987 432.394L443.562 431.941C444.174 426.231 446.333 420.374 449.82 415.043C456.247 403.928 466.782 396.332 478.645 394.383L480.594 394.067L481.12 395.848C484.586 406.92 482.911 419.815 476.243 431.246C470.216 441.381 459.745 448.903 448.967 451.063L448.735 451.273H448.124L443.942 456.225L443.952 456.214Z",
    fill: "url(#paint43_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.026 745.174C278.16 745.1 263.601 738.8 254.067 727.896L252.781 726.432L254.067 724.968C263.422 714.032 278.013 707.69 294.026 707.69C310.04 707.69 324.789 714.201 333.881 725.041L335.135 726.432L333.881 727.854C324.557 738.79 310.103 745.1 294.026 745.174ZM258.723 726.432C267.436 735.524 280.183 740.718 294.026 740.718C307.87 740.718 320.775 735.313 329.225 726.432C320.849 717.445 307.922 712.178 294.026 712.178C280.131 712.178 267.32 717.266 258.723 726.432Z",
    fill: "url(#paint44_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.508 789.032L316.423 787.641C309.49 778.37 307.31 765.306 310.713 752.633C312.177 745.911 315.517 739.295 320.605 733.09L324.04 735.871C319.394 741.55 316.359 747.47 315.032 753.676C312.103 764.369 313.641 775.347 318.919 783.353C327.137 778.718 333.458 769.942 336.492 758.859C339.073 748.092 337.209 737.02 331.393 728.591L330.993 727.959V727.338L331.53 727.264L330.15 725.663C330.29 725.452 330.501 725.241 330.782 725.03L331.53 724.198L333.289 724.409L334.111 724.862C334.564 725.283 335.144 725.663 335.344 726.495C341.697 735.861 343.635 748.092 340.748 759.934C337.209 773.029 329.318 783.343 319.151 788.252L317.518 789.011L317.508 789.032Z",
    fill: "url(#paint45_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.965 734.934L330.993 729.603C330.698 729.498 330.361 729.329 329.929 728.802L330.54 728.275V727.338L331.394 726.042C337.209 717.888 339.126 706.257 336.493 695.869C333.459 684.86 327.264 676.221 318.92 671.143C313.568 679.645 312.114 690.37 314.896 700.926C316.223 706.742 318.446 711.756 321.533 715.591L318.035 718.372C314.59 714.021 312.009 708.343 310.629 701.959C307.321 689.453 309.396 676.664 316.434 666.877L317.519 665.338L319.257 666.213C329.624 671.681 337.251 681.815 340.749 694.742C343.688 706.236 341.602 719.015 335.344 728.254C335.165 728.465 335.134 728.739 334.965 728.887V734.913V734.934Z",
    fill: "url(#paint46_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.133 1061.77H393.383L391.434 1061.55L391.245 1059.68C390.265 1045.26 396.102 1030.41 407.395 1019.1C417.604 1008.86 430.994 1003 444.268 1003C445.438 1003 446.67 1003 447.819 1003.11L449.683 1003.32L449.82 1005.13C450.916 1019.31 444.922 1034.46 433.87 1045.5C423.598 1055.88 409.797 1061.77 396.144 1061.77H396.133ZM395.596 1057.33H396.133C408.638 1057.33 421.217 1051.83 430.678 1042.35C440.434 1032.7 445.87 1019.74 445.501 1007.45H444.268C432.237 1007.45 419.9 1012.78 410.545 1022.18C400.653 1032.08 395.29 1044.86 395.596 1057.33Z",
    fill: "url(#paint47_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.53 1060.02L479.697 1059.8C468.256 1058.13 457.457 1050.44 450.989 1039.04C447.175 1033.01 444.857 1025.94 444.057 1018.03L448.502 1017.76C449.166 1024.9 451.305 1031.31 454.771 1036.74C460.27 1046.39 469.088 1053.04 478.465 1055.03C481.025 1045.87 479.349 1035.31 473.566 1025.18C467.856 1015.98 458.479 1009.32 448.608 1007.45L447.891 1007.27L447.386 1006.81L447.807 1006.33L445.521 1005.91L447.702 1006.33L445.626 1005.66V1004.76L446.954 1003.08L448.208 1002.77C448.819 1002.77 449.356 1002.87 449.883 1003.22C460.976 1005.35 470.963 1012.52 477.39 1022.9C484.143 1034.95 485.818 1047.49 482.141 1058.33L481.53 1060.01V1060.02Z",
    fill: "url(#paint48_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.931 1009.65C426.601 1009.09 420.785 1006.93 415.033 1003.41C403.802 996.858 396.312 986.207 394.363 974.46L394.047 972.469L395.827 971.953C406.91 968.571 419.763 970.32 431.226 976.831C441.403 983.025 448.977 993.518 451.042 1004.24L451.221 1004.45L451.327 1005.29L454.477 1009.09L449.146 1008.5C448.366 1008.5 448.134 1008.6 447.713 1008.6V1007.59L447.576 1007.77L447.102 1007.14L446.786 1005.68C445.1 995.815 438.252 986.207 429.003 980.623C419.321 975.05 408.533 973.375 399.093 975.608C401.253 985.364 407.837 993.971 417.382 999.544C422.471 1002.72 427.749 1004.7 432.395 1005.12L431.921 1009.65H431.931Z",
    fill: "url(#paint49_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M726.462 1200.33L724.945 1199.11C714.031 1189.67 707.699 1175.15 707.699 1159.12C707.699 1143.1 714.221 1128.36 725.03 1119.31L726.452 1118.06L727.916 1119.31C738.652 1128.51 745.162 1143.38 745.162 1159.06C745.162 1174.73 738.652 1189.64 727.916 1199.11L726.452 1200.33H726.462ZM726.462 1123.98C717.455 1132.3 712.177 1145.33 712.177 1159.12C712.177 1172.91 717.286 1185.84 726.462 1194.49C735.396 1185.74 740.695 1172.68 740.695 1159.06C740.695 1145.44 735.407 1132.37 726.462 1123.98Z",
    fill: "url(#paint50_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M764.473 1144C760.607 1144 756.635 1143.49 752.632 1142.43C745.668 1140.76 738.978 1137.48 733.036 1132.57L735.912 1129.05C741.327 1133.51 747.343 1136.61 753.717 1138.07C764.305 1140.76 775.314 1139.54 783.394 1134.24C778.727 1126.11 769.983 1119.68 758.805 1116.68C748.112 1113.96 737.124 1115.87 728.58 1121.76L727.969 1122.08H727.358L727.294 1121.52L725.588 1122.99C725.44 1122.78 725.261 1122.59 725.05 1122.4L724.439 1121.77V1119.93L724.956 1118.85C725.44 1118.36 725.83 1117.94 726.504 1117.73C735.965 1111.57 748.175 1109.61 760.017 1112.32C773.217 1115.95 783.289 1123.61 788.23 1133.92L788.999 1135.66L787.64 1136.7C781.266 1141.41 773.112 1143.98 764.473 1143.98V1144Z",
    fill: "url(#paint51_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M690.432 1144.11C681.825 1144.11 673.628 1141.6 666.97 1136.72L665.4 1135.68L666.359 1133.94C671.669 1123.46 681.74 1115.86 694.73 1112.35C706.361 1109.42 718.824 1111.51 728.274 1117.81C728.538 1117.95 728.78 1118.06 728.885 1118.16H733.637L729.823 1121.92C729.391 1122.62 729.159 1122.83 728.885 1123L728.274 1122.44V1122.62H727.347L726.062 1121.71C717.855 1115.97 706.361 1114.01 695.931 1116.7C684.922 1119.63 676.146 1125.82 671.216 1134.26C679.475 1139.62 690.337 1141.09 700.946 1138.19C706.751 1136.93 711.797 1134.56 715.579 1131.57L718.382 1135.05C714.031 1138.54 708.405 1141.07 702.042 1142.54C698.154 1143.58 694.204 1144.11 690.421 1144.11H690.432Z",
    fill: "url(#paint52_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1056.33 1062.01C1042.95 1062.01 1029.37 1056.06 1019.06 1045.64C1007.94 1034.66 1001.99 1019.51 1003.1 1005.37L1003.31 1003.53L1005.15 1003.36C1019.47 1002.48 1034.45 1008.19 1045.46 1019.25C1056.57 1030.32 1062.7 1045.4 1061.76 1059.75L1061.62 1061.7L1059.67 1061.84C1058.55 1061.91 1057.4 1062.02 1056.33 1062.02V1062.01ZM1007.49 1007.69C1007.07 1019.92 1012.5 1032.91 1022.19 1042.56C1031.73 1052.11 1044.1 1057.5 1056.32 1057.5H1057.4C1057.58 1045.03 1052.07 1032 1042.39 1022.31C1033.12 1013.01 1020.87 1007.57 1008.88 1007.57C1008.39 1007.57 1007.94 1007.68 1007.49 1007.68V1007.69Z",
    fill: "url(#paint53_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1018.08 1009.09L1017.73 1004.56C1024.83 1004.07 1031.14 1001.95 1036.74 998.396C1046.36 992.823 1053.12 984.079 1055 974.671C1045.88 972.195 1035.29 973.839 1025.18 979.517C1015.87 985.375 1009.29 994.53 1007.34 1004.7L1007.24 1005.36L1006.75 1005.71L1006.37 1005.36L1006.1 1007.55H1004.53L1003.11 1006.3L1002.83 1005.04C1002.83 1004.45 1002.83 1003.9 1003.11 1003.34C1005.4 992.223 1012.58 982.088 1022.96 975.682C1034.99 968.961 1047.56 967.286 1058.36 970.973L1060.11 971.563L1059.8 973.407C1058.16 984.901 1050.36 995.668 1039.06 1002.18C1033 1006.01 1025.89 1008.38 1018.09 1009.08L1018.08 1009.09Z",
    fill: "url(#paint54_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M972.576 1058.97L972.059 1057.1C968.509 1046.3 970.184 1033.41 976.832 1021.88C983.132 1011.5 993.341 1004.11 1004.35 1002.09C1004.62 1001.96 1005.05 1001.88 1005.29 1001.78L1008.56 999.029V1004.46C1008.6 1004.78 1008.6 1004.99 1008.6 1005.37H1007.63L1007.76 1005.55L1007.24 1006L1005.6 1006.35C995.848 1008.06 986.24 1014.85 980.667 1024.22C975.02 1033.87 973.282 1044.64 975.684 1053.94C985.365 1051.85 993.973 1045.33 999.546 1035.83C1002.82 1030.42 1004.77 1025.45 1005.15 1020.71L1009.61 1021.16C1009.09 1026.53 1006.92 1032.24 1003.41 1038.16C996.764 1049.34 986.24 1056.9 974.461 1058.65L972.576 1058.99V1058.97Z",
    fill: "url(#paint55_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1159.16 745.415C1143.28 745.415 1128.4 738.967 1119.31 728.137L1118.06 726.599L1119.31 725.135C1128.51 714.442 1143.41 707.889 1159.06 707.889C1174.7 707.889 1189.72 714.442 1199.08 725.135L1200.34 726.599L1199.08 728.137C1189.96 738.904 1175.01 745.31 1159.16 745.415ZM1123.95 726.599C1132.34 735.628 1145.37 741.022 1159.16 741.022C1172.96 740.959 1185.91 735.554 1194.46 726.599C1185.85 717.686 1172.97 712.387 1159.3 712.387C1145.64 712.387 1132.41 717.676 1123.95 726.599Z",
    fill: "url(#paint56_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1120.77 728.77H1119.9L1118.86 728.138C1118.37 727.717 1117.98 727.337 1117.74 726.6C1111.58 717.129 1109.55 704.971 1112.34 693.056C1115.96 680.129 1123.83 669.931 1133.86 664.843L1135.57 663.968L1136.64 665.433C1143.61 674.661 1145.81 687.799 1142.42 700.378C1140.82 707.415 1137.51 714.105 1132.53 720.057L1129.05 717.266C1133.59 711.766 1136.65 705.835 1138.15 699.324C1140.97 688.631 1139.44 677.801 1134.22 669.71C1126.03 674.451 1119.72 683.3 1116.66 694.194C1114.07 704.961 1115.93 716.001 1121.78 724.535L1122.08 725.093V725.789H1121.56L1122.58 727.843L1121.88 728.475L1120.76 728.749L1120.77 728.77Z",
    fill: "url(#paint57_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1135.58 787.641L1133.87 786.766C1123.63 781.509 1115.82 771.164 1112.35 758.342C1109.42 746.88 1111.58 734.101 1117.84 724.862C1117.92 724.546 1118.06 724.409 1118.12 724.229V719.457L1121.95 723.26C1122.65 723.819 1122.8 723.924 1123.04 724.198L1122.48 724.788H1122.66V725.662L1121.68 727.021C1115.94 735.312 1114.05 746.88 1116.66 757.257C1119.59 768.13 1125.94 776.905 1134.23 781.815C1139.52 773.629 1140.98 762.894 1138.2 752.137C1136.94 746.385 1134.57 741.265 1131.55 737.504L1135.07 734.68C1138.51 739.031 1141.1 744.647 1142.56 751.02C1145.87 763.736 1143.71 776.558 1136.67 786.103L1135.6 787.641H1135.58Z",
    fill: "url(#paint58_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1009.02 450.116C1007.84 450.116 1006.61 450.01 1005.39 450.01L1003.51 449.8L1003.37 447.956C1002.19 433.776 1008.08 418.658 1019.18 407.617C1030.33 396.428 1045.31 390.508 1059.81 391.445L1061.68 391.656L1061.82 393.5C1062.94 407.891 1057.01 422.693 1045.66 434.081C1035.48 444.184 1022.11 450.105 1009.01 450.105L1009.02 450.116ZM1007.69 445.617C1008.14 445.722 1008.56 445.722 1009.02 445.722C1020.93 445.722 1033.19 440.286 1042.53 430.921C1052.28 421.133 1057.78 408.133 1057.51 395.838H1056.57C1044.2 395.838 1031.8 401.201 1022.33 410.683C1012.65 420.364 1007.25 433.323 1007.7 445.628L1007.69 445.617Z",
    fill: "url(#paint59_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1005.04 450.294C1004.41 450.294 1004 450.294 1003.41 450.01C992.371 447.819 982.194 440.571 975.683 430.151C968.961 418.131 967.36 405.552 970.974 394.901L971.606 393.12L973.481 393.331C984.912 395.069 995.605 402.739 1002.12 413.948C1005.98 420.08 1008.38 427.117 1009.08 435.061L1004.55 435.335C1003.99 428.265 1001.83 421.818 998.312 416.245C992.813 406.7 984.069 400.084 974.735 398.103C972.154 407.3 973.829 417.72 979.476 427.886C985.365 437.22 994.53 443.847 1004.62 445.722L1005.18 445.859L1005.67 446.175L1005.28 446.66L1007.48 447.429L1007.54 448.335L1006.29 449.999L1005.03 450.284L1005.04 450.294Z",
    fill: "url(#paint60_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1045.42 482.89C1037.58 482.89 1029.47 480.625 1021.9 476.243C1011.48 470.048 1004.13 459.797 1002.12 448.788C1001.98 448.546 1001.84 448.23 1001.84 448.019L998.398 444.606H1003.83C1004.53 444.5 1004.88 444.5 1005.4 444.5V445.301V445.227L1005.99 445.859L1006.37 447.608C1008.08 457.322 1014.8 466.94 1024.07 472.44C1033.86 477.981 1044.73 479.898 1053.96 477.391C1051.87 467.741 1045.32 459.102 1035.78 453.603C1030.55 450.368 1025.54 448.451 1020.72 447.956L1021.18 443.573C1026.67 444.089 1032.36 446.186 1038.14 449.705C1049.36 456.321 1056.88 466.877 1058.62 478.655L1058.97 480.531L1057.09 481.057C1053.36 482.269 1049.42 482.901 1045.42 482.901V482.89Z",
    fill: "url(#paint61_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.687 387.167C503.813 387.167 502.96 386.851 502.233 386.23C439.369 335.05 509.702 223.788 512.81 219.089C513.874 217.309 516.223 216.719 518.004 217.972C519.784 219.089 520.301 221.386 519.152 223.166C518.436 224.315 449.462 333.385 507.079 380.446C508.68 381.699 508.944 384.038 507.616 385.745C506.868 386.577 505.751 387.167 504.687 387.167Z",
    fill: "url(#paint62_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.453 319.132H636.671V318.542C636.029 250.748 517.065 225.074 515.812 224.905C513.736 224.378 512.482 222.398 512.883 220.343C513.315 218.289 515.369 216.825 517.36 217.414C522.459 218.457 643.635 244.585 644.246 318.542L640.453 319.132Z",
    fill: "url(#paint63_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.007 644.911C244.849 644.911 217.71 524.167 216.509 518.91C216.141 516.856 217.394 514.802 219.47 514.348C221.366 513.759 223.515 515.191 223.947 517.277C224.274 518.499 250.928 637.252 320.218 637.252C322.325 637.252 324.432 637.178 326.613 636.967C328.909 636.662 330.553 638.263 330.795 640.349C331.006 642.467 329.468 644.279 327.361 644.532C324.801 644.774 322.398 644.911 320.007 644.911Z",
    fill: "url(#paint64_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.723 521.491C219.47 521.491 218.237 520.795 217.531 519.679C216.362 518.003 216.804 515.57 218.616 514.516C222.936 511.588 327.181 444.5 379.805 496.196L377.624 499.398L374.79 501.906L374.305 501.421C326.128 454.044 223.831 520.163 222.82 520.795C222.188 521.248 221.377 521.491 220.734 521.491H220.723Z",
    fill: "url(#paint65_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.97 976.831C276.791 976.831 222.303 942.549 219.069 940.39C217.394 939.241 216.804 936.871 218.005 935.133C219.069 933.32 221.366 932.899 223.209 933.953C224.357 934.648 333.397 1003.83 380.426 946.005C381.658 944.477 384.071 944.161 385.756 945.489C387.284 946.848 387.6 949.281 386.23 950.893C370.575 970.12 349.147 976.841 326.97 976.841V976.831Z",
    fill: "url(#paint66_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.155 940.389C220.923 940.389 220.618 940.389 220.407 940.284C218.321 939.831 216.973 937.882 217.426 935.722C218.437 930.602 244.617 809.479 318.605 808.921L319.248 812.682V816.517H318.605C250.854 817.033 225.106 936.101 224.884 937.355C224.463 939.167 222.935 940.389 221.155 940.389Z",
    fill: "url(#paint67_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.075 1236.64C516.347 1236.64 514.746 1235.49 514.345 1233.61C513.861 1231.62 515.283 1229.57 517.274 1229.15C518.528 1228.83 644.55 1200.44 636.975 1126.49C636.754 1124.47 638.313 1122.56 640.388 1122.42C642.79 1122.35 644.328 1123.64 644.55 1125.83C652.756 1206.44 524.333 1235.39 518.928 1236.64H518.075Z",
    fill: "url(#paint68_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.674 1236.28C516.442 1236.28 515.199 1235.69 514.472 1234.54C511.564 1230.16 444.402 1125.89 496.214 1073.22L499.417 1075.48L501.893 1078.41L501.492 1078.76C454.063 1126.97 520.15 1229.39 520.877 1230.36C522.025 1232.14 521.488 1234.54 519.676 1235.66C519.139 1236.11 518.391 1236.28 517.674 1236.28Z",
    fill: "url(#paint69_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M937.188 1235.8C936.492 1235.8 935.723 1235.59 935.102 1235.16C933.321 1234.02 932.868 1231.72 933.922 1229.87C934.754 1228.82 1003.73 1119.68 946.006 1072.8C944.436 1071.44 944.194 1069.11 945.489 1067.4C946.88 1065.8 949.177 1065.59 950.926 1066.84C1013.77 1118.06 943.467 1229.25 940.401 1234.03C939.706 1235.17 938.452 1235.81 937.198 1235.81L937.188 1235.8Z",
    fill: "url(#paint70_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M936.556 1235.8C936.346 1235.8 936.03 1235.8 935.713 1235.69C930.625 1234.65 809.47 1208.49 808.912 1134.46L812.747 1133.87H816.508V1134.46C817.035 1202.36 936.103 1228.06 937.357 1228.31C939.411 1228.69 940.665 1230.68 940.286 1232.76C939.938 1234.54 938.368 1235.8 936.556 1235.8Z",
    fill: "url(#paint71_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1232.87 938.832C1231.19 938.832 1229.53 937.716 1229.14 935.903C1228.9 934.65 1202.11 815.897 1132.95 815.897C1130.79 815.897 1128.71 815.961 1126.51 816.213C1124.35 816.14 1122.57 814.886 1122.37 812.768C1122.08 810.64 1123.62 808.797 1125.81 808.628C1128.29 808.386 1130.79 808.238 1133.16 808.238C1208.24 808.238 1235.44 928.877 1236.56 934.271C1237.04 936.356 1235.72 938.348 1233.63 938.832H1232.86H1232.87Z",
    fill: "url(#paint72_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1125.58 976.484C1106.28 976.484 1087.82 971.227 1073.19 956.91L1075.48 953.707L1078.41 951.2L1078.8 951.727C1126.84 998.861 1229.33 932.911 1230.37 932.321C1232.18 931.246 1234.55 931.626 1235.66 933.438C1236.81 935.218 1236.36 937.578 1234.54 938.663C1231.4 940.791 1176.02 976.495 1125.58 976.495V976.484Z",
    fill: "url(#paint73_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1232.03 519.784C1231.31 519.784 1230.57 519.573 1229.95 519.152C1228.83 518.488 1119.73 449.346 1072.84 507.057C1071.45 508.659 1069.11 508.869 1067.43 507.616C1065.8 506.257 1065.59 503.855 1066.84 502.253C1118.33 439.337 1229.45 509.849 1233.98 512.81C1235.8 513.821 1236.35 516.255 1235.16 518.035C1234.5 519.152 1233.28 519.773 1232.02 519.773L1232.03 519.784Z",
    fill: "url(#paint74_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1134.5 644.215C1132.48 644.215 1130.45 642.676 1130.45 640.664C1130.32 638.641 1131.47 636.903 1133.59 636.724L1134.23 636.661C1202.37 636.071 1228.07 516.96 1228.28 515.749C1228.71 513.726 1230.1 512.304 1232.78 512.82C1234.87 513.241 1236.12 515.296 1235.74 517.276C1234.66 522.47 1208.5 643.625 1134.51 644.215H1134.5Z",
    fill: "url(#paint75_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M812.409 330.773C810.46 330.773 808.785 329.277 808.648 327.391C800.43 246.576 928.833 217.657 934.269 216.509C936.26 215.95 938.378 217.341 938.831 219.437C939.221 221.46 937.893 223.546 935.902 223.936C934.648 224.252 808.648 252.602 816.201 326.559C816.444 328.645 814.842 330.562 812.788 330.773H812.409Z",
    fill: "url(#paint76_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M953.77 381.068C952.938 381.068 952.095 380.889 951.4 380.236C949.935 378.877 949.525 376.854 950.841 375.284L951.189 374.726C998.913 326.201 932.932 223.778 932.31 222.767C931.13 220.986 931.689 218.584 933.427 217.51C935.302 216.435 937.567 216.814 938.684 218.584C941.613 223.009 1008.7 327.096 956.91 379.772C956.109 380.647 954.961 381.058 953.77 381.058V381.068Z",
    fill: "url(#paint77_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.176 600.262C523.726 600.262 504.72 593.814 489.328 581.035C440.666 540.77 445.439 452.243 445.544 448.555C445.734 446.775 447.114 445.563 448.747 445.563H448.979C450.717 445.637 452.076 447.102 451.939 448.914C451.939 449.714 447.293 537.957 493.374 576.136C514.992 594.078 544.406 598.471 580.921 589.274C582.522 588.821 584.334 589.895 584.661 591.57C585.167 593.309 584.155 594.984 582.47 595.374C569.511 598.65 557.438 600.283 546.187 600.283L546.176 600.262Z",
    fill: "url(#paint78_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.352 584.754C592.036 584.754 591.825 584.754 591.498 584.68C589.865 584.259 588.812 582.489 589.254 580.888C598.641 544.278 594.448 514.8 576.696 493.277C538.654 446.986 450.295 451.368 449.284 451.474H449.147C447.409 451.474 446.05 450.115 445.944 448.439C445.871 446.659 447.198 445.131 448.978 445.089C452.876 445.026 541.572 440.464 581.585 489.221C600.748 512.356 605.363 543.741 595.375 582.373C594.975 583.837 593.774 584.743 592.362 584.743L592.352 584.754Z",
    fill: "url(#paint79_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.852 581.446C554.035 581.446 533.786 572.491 518.395 557.099C501.675 540.485 492.668 517.74 494.301 496.374L494.532 493.625L497.145 493.382C518.626 491.707 541.235 500.694 558.07 517.518C574.863 534.175 583.744 556.92 582.038 578.243L581.827 580.93L579.183 581.172C577.392 581.351 575.611 581.446 573.852 581.446ZM500.432 499.651C499.853 518.361 508.144 537.936 522.777 552.601C537.632 567.413 556.848 575.767 575.917 574.967C576.559 556.33 568.342 536.64 553.603 521.943C538.749 507.215 519.364 498.85 500.422 499.651H500.432Z",
    fill: "url(#paint80_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.903 791.707C388.105 791.707 333.712 731.267 331.31 728.591C330.162 727.263 330.299 725.283 331.637 724.092C332.859 722.976 334.829 722.976 336.093 724.408C336.631 725.04 390.929 785.47 448.04 785.47C450.526 785.47 452.897 785.302 455.32 785.049C483.122 782.404 507.069 764.779 526.422 732.415C527.359 730.951 529.308 730.466 530.868 731.372C532.332 732.31 532.764 734.269 531.932 735.723C511.43 769.899 485.83 788.567 455.941 791.391C453.223 791.602 450.611 791.696 447.914 791.696L447.903 791.707Z",
    fill: "url(#paint81_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.618 729.076C332.849 729.076 332.069 728.802 331.479 728.275C330.247 727.127 330.068 725.104 331.216 723.819C333.618 721.174 388.169 660.797 447.893 660.797C450.696 660.797 453.487 660.976 456.237 661.219C486.125 664.148 511.642 683.058 531.922 717.382C532.754 718.909 532.322 720.9 530.773 721.733C529.309 722.533 527.255 722.08 526.422 720.616C507.206 688.147 483.439 670.279 455.615 667.529C396.102 661.398 336.578 727.348 335.967 728.043C335.335 728.77 334.482 729.086 333.618 729.086V729.076Z",
    fill: "url(#paint82_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.577 753.981C435.483 753.981 413.644 744.542 399.505 727.96L397.693 725.979L399.505 723.893C413.644 707.384 435.494 697.871 459.577 697.871C483.66 697.871 505.668 707.585 519.543 723.893L521.324 725.979L519.543 727.96C505.605 744.468 483.745 753.918 459.577 753.981ZM406.153 725.979C419.027 739.601 438.76 747.681 459.577 747.681C480.826 747.576 500.106 739.769 512.948 725.979C500.116 712.252 480.426 704.171 459.577 704.171C438.728 704.171 419.027 712.252 406.153 725.979Z",
    fill: "url(#paint83_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.669 1007.76C452.57 1007.76 449.167 1007.55 448.609 1007.55C446.776 1007.37 445.49 1005.92 445.522 1004.11C445.712 1002.48 447.092 1001.18 448.725 1001.18H448.957C449.884 1001.25 537.947 1005.92 576.242 959.724C594.057 938.2 598.366 908.828 589.232 872.282C588.853 870.617 589.843 868.837 591.571 868.489C593.194 867.931 594.953 869.047 595.438 870.817C605.014 909.344 600.21 940.697 581.099 963.758C547.882 1003.81 481.953 1007.75 457.659 1007.75L457.669 1007.76Z",
    fill: "url(#paint84_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.281 1007.14C446.543 1007.14 445.194 1005.81 445.089 1004.11C444.857 1000.42 440.422 911.725 489.242 871.554C512.388 852.464 543.709 847.871 582.447 857.721C584.132 858.143 585.196 859.881 584.764 861.661C584.311 863.263 582.678 864.38 580.898 863.895C544.141 854.382 514.779 858.67 493.266 876.506C446.954 914.58 451.336 1002.9 451.431 1003.83C451.537 1005.54 450.199 1007.04 448.418 1007.14H448.281Z",
    fill: "url(#paint85_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.791 959.059C499.926 959.059 498.167 958.954 496.291 958.785L493.679 958.543L493.415 955.857C491.635 934.576 500.748 911.862 517.509 895.037C534.26 878.212 556.542 868.804 578.329 871.069L580.963 871.249L581.226 873.998C582.985 895.427 574.262 917.509 557.259 934.681C541.793 950.252 521.555 959.059 501.801 959.059H501.791ZM499.631 952.654C518.531 953.349 537.832 945.026 552.771 930.224C567.72 915.138 575.706 895.975 575 877.169C556.184 876.927 536.715 884.66 521.924 899.462C507.206 914.337 498.915 933.954 499.631 952.664V952.654Z",
    fill: "url(#paint86_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M726.494 1122.44C725.641 1122.44 724.713 1122.09 724.102 1121.47C722.954 1120.11 723.091 1118.06 724.418 1117.01C725.029 1116.35 790.653 1057.4 785.048 997.807C782.436 970.078 764.768 946.079 732.478 926.705C731.013 925.831 730.434 923.955 731.382 922.417C732.309 920.953 734.237 920.426 735.702 921.301C769.888 941.749 788.63 967.286 791.391 997.206C797.311 1060.02 731.382 1119.2 728.569 1121.71C727.958 1122.24 727.21 1122.44 726.494 1122.44Z",
    fill: "url(#paint87_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M725.958 1122.69C725.21 1122.69 724.42 1122.41 723.777 1121.85C720.996 1119.41 655.067 1059.73 661.282 996.859C664.169 966.971 683.069 941.613 717.35 921.301C718.815 920.321 720.848 920.848 721.702 922.418C722.629 923.956 722.102 925.863 720.638 926.705C688.168 945.932 670.332 969.763 667.582 997.491C661.683 1057.1 727.348 1116.49 728.044 1117.12C729.382 1118.37 729.455 1120.32 728.265 1121.57C727.633 1122.34 726.801 1122.69 725.947 1122.69H725.958Z",
    fill: "url(#paint88_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M725.957 1055.42L723.882 1053.68C707.373 1039.44 697.828 1017.53 697.828 993.592C697.828 969.656 707.594 947.259 723.882 933.531L725.957 931.867L727.959 933.531C744.246 947.259 753.875 969.625 754.012 993.518C754.012 1017.65 744.541 1039.61 727.959 1053.67L725.957 1055.41V1055.42ZM725.957 940.179C712.251 952.863 704.181 972.543 704.181 993.582C704.181 1014.62 712.093 1034.03 725.957 1046.95C739.579 1034.16 747.681 1014.42 747.681 993.518C747.575 972.48 739.558 952.863 725.957 940.179Z",
    fill: "url(#paint89_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1004.32 1007.55H1004.14C1002.33 1007.37 1001 1005.92 1001.1 1004.11C1001.21 1003.31 1005.81 915.138 959.754 876.927C938.294 859.196 908.785 854.845 872.249 863.895C870.51 864.169 868.835 863.263 868.488 861.598C868.003 859.892 869.109 858.153 870.784 857.732C909.311 848.187 940.664 852.854 963.726 872.091C1012.43 912.325 1007.69 1000.78 1007.48 1004.47C1007.33 1006.25 1005.98 1007.56 1004.31 1007.56L1004.32 1007.55Z",
    fill: "url(#paint90_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M995.711 1008.22C971.923 1008.22 904.898 1004.45 871.628 963.936C852.464 940.696 847.839 909.343 857.721 870.711C858.174 869.078 859.502 868.13 861.661 868.477C863.326 868.825 864.379 870.605 863.926 872.344C854.561 908.816 858.733 938.283 876.505 959.891C914.548 1006.15 1002.89 1001.62 1003.83 1001.76C1005.4 1001.86 1007.07 1002.98 1007.14 1004.75C1007.25 1006.42 1005.89 1007.95 1004.15 1008.03C1003.52 1008.16 1000.39 1008.21 995.722 1008.21L995.711 1008.22Z",
    fill: "url(#paint91_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M950.632 959.901C930.71 959.901 910.398 951.083 895.069 935.617C878.171 918.824 869.258 896.079 871.038 874.861L871.312 872.175L873.999 871.859C875.705 871.827 877.475 871.648 879.33 871.648C898.946 871.648 919.184 880.529 934.755 895.889C951.611 912.756 960.598 935.607 958.828 956.783L958.586 959.606L955.868 959.711C954.193 959.89 952.454 959.891 950.642 959.891L950.632 959.901ZM877.159 878.106C876.538 896.711 884.713 916.359 899.494 931.161C913.706 945.373 932.385 953.59 950.632 953.59C951.401 953.59 951.991 953.59 952.718 953.559C953.35 934.964 945.059 915.274 930.215 900.398C915.866 886.186 897.292 878.106 879.319 878.106H877.159Z",
    fill: "url(#paint92_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1119.31 729.739C1118.37 729.739 1117.53 729.423 1116.94 728.77C1116.38 728.043 1062.07 667.708 1005.05 667.708C1002.57 667.708 1000.17 667.814 997.797 668.024C970.068 670.595 946.101 688.336 926.727 720.626C925.821 722.154 923.871 722.649 922.407 721.743C920.837 720.911 920.458 718.856 921.364 717.392C941.739 683.216 967.35 664.442 997.238 661.682C999.851 661.408 1002.57 661.408 1005.18 661.408C1064.96 661.408 1119.3 721.775 1121.64 724.535C1122.79 725.82 1122.72 727.875 1121.43 729.023C1120.76 729.508 1120 729.75 1119.3 729.75L1119.31 729.739Z",
    fill: "url(#paint93_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1005.29 792.276C1002.46 792.276 999.682 792.097 996.859 791.791C967.044 788.936 941.612 770.057 921.374 735.744C920.468 734.174 920.953 732.331 922.417 731.393C923.881 730.561 925.967 730.972 926.736 732.436C945.963 765.011 969.72 782.773 997.449 785.523C999.988 785.797 1002.57 785.839 1005.15 785.839C1062.15 785.839 1116.59 725.683 1117.15 725.051C1118.33 723.829 1120.22 723.629 1121.64 724.809C1122.93 725.989 1123.03 727.98 1121.88 729.339C1119.44 732.025 1064.96 792.286 1005.29 792.286V792.276Z",
    fill: "url(#paint94_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M993.655 755.245H993.623C969.729 755.245 947.258 745.489 933.562 729.192L931.855 727.2L933.562 725.114C947.258 708.943 969.656 699.156 993.549 699.156C1017.44 699.156 1039.75 708.838 1053.67 725.114L1055.41 727.2L1053.67 729.192C1039.43 745.774 1017.58 755.245 993.655 755.245ZM940.252 727.2C952.863 740.822 972.542 748.934 993.623 748.934H993.655C1014.73 748.934 1034.03 741.023 1046.98 727.2C1034.16 713.578 1014.41 705.435 993.539 705.435C972.532 705.54 952.852 713.589 940.241 727.2H940.252Z",
    fill: "url(#paint95_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M860.829 584.754C859.438 584.754 858.111 583.848 857.731 582.384C848.081 543.751 852.959 512.504 872.049 489.337C912.251 440.738 1000.74 445.405 1004.53 445.721C1006.31 445.795 1007.64 447.323 1007.56 449.072C1007.35 450.778 1005.99 452.064 1004.36 452.064H1004.15C1003.42 452.127 915.043 447.428 876.926 493.383C859.09 514.98 854.803 544.278 863.926 580.888C864.379 582.594 863.336 584.269 861.598 584.68C861.387 584.754 861.039 584.754 860.829 584.754Z",
    fill: "url(#paint96_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M907.678 600.462C896.216 600.462 883.984 598.787 870.721 595.342C869.119 594.953 868.003 593.183 868.487 591.539C868.972 589.759 870.194 588.895 872.354 589.243C908.795 598.545 938.293 594.331 959.901 576.664C1006.23 538.558 1001.84 450.21 1001.74 449.272C1001.63 447.608 1002.96 445.996 1004.77 445.964C1006.23 445.785 1007.97 447.176 1008.08 448.925C1008.32 452.686 1012.75 541.444 963.946 581.573C948.586 594.12 929.876 600.452 907.689 600.452L907.678 600.462Z",
    fill: "url(#paint97_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M880.266 582.279C878.486 582.279 876.642 582.173 874.83 582.037L872.217 581.794L871.901 579.181C870.194 557.658 878.865 535.503 895.932 518.362C912.799 501.569 935.154 492.161 956.751 494.258L959.575 494.5L959.754 497.144C961.419 518.92 952.716 541.076 935.649 558.006C920.247 573.44 900.083 582.279 880.255 582.279H880.266ZM878.106 575.937H880.266C898.387 575.937 916.918 567.782 931.13 553.602C946.111 538.558 954.265 519.321 953.559 500.368H951.61C933.321 500.368 914.653 508.554 900.399 522.839C885.702 537.715 877.474 557.332 878.106 575.926V575.937Z",
    fill: "url(#paint98_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.173 483.553C568.036 483.553 567.826 483.553 567.552 483.479C565.866 483.205 564.802 481.457 565.118 479.792C565.434 478.401 572.535 445.616 599.8 431.931C617.857 422.871 640.318 424.472 666.372 436.703C667.952 437.535 668.647 439.348 667.899 440.917C667.12 442.624 665.234 443.151 663.685 442.445C639.37 431.12 618.942 429.455 602.655 437.536C578.108 449.904 571.376 480.803 571.281 481.151C570.965 482.615 569.732 483.553 568.184 483.553H568.173Z",
    fill: "url(#paint99_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.565 463.947C533.386 463.947 533.354 463.947 533.185 463.842C531.394 463.705 530.225 462.03 530.467 460.25C530.678 458.269 537.61 410.682 575.316 390.507C601.39 376.463 635.566 379.498 676.864 399.388C678.434 400.083 679.045 402.032 678.223 403.602C677.581 405.13 675.61 405.793 674.083 405.066C634.913 386.05 602.654 383.122 578.339 396.038C543.552 414.611 536.82 460.692 536.725 461.219C536.493 462.757 535.124 463.937 533.575 463.937L533.565 463.947Z",
    fill: "url(#paint100_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.883 471.186C549.651 471.186 549.43 471.186 549.251 471.112C547.576 470.764 546.427 469.089 546.775 467.425C547.07 465.855 554.75 428.371 587.146 410.535C609.67 398.166 638.02 398.482 671.743 411.367C673.345 412.094 674.24 413.874 673.608 415.507C672.913 417.077 671.132 417.983 669.394 417.351C637.567 405.056 610.924 404.603 590.159 416.023C560.429 432.532 553.075 468.246 552.991 468.594C552.675 470.132 551.358 471.175 549.872 471.175L549.883 471.186Z",
    fill: "url(#paint101_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.529 667.665C439.518 667.665 438.528 667.107 437.896 666.201C437.116 665.021 418.932 636.797 428.593 607.815C434.935 588.725 451.918 573.955 479.035 564.199C480.637 563.609 482.48 564.41 483.113 566.075C483.734 567.75 482.902 569.562 481.216 570.226C455.995 579.244 440.35 592.655 434.619 609.796C425.875 635.954 442.995 662.429 443.226 662.745C444.164 664.136 443.732 666.19 442.289 667.096C441.762 667.476 441.162 667.655 440.529 667.655V667.665Z",
    fill: "url(#paint102_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.109 678.148C401.097 678.148 400.17 677.801 399.527 676.968C398.295 675.335 369.608 636.808 381.881 595.869C390.467 567.476 416.826 545.426 460.031 530.34C461.664 529.75 463.518 530.688 464.076 532.331C464.635 533.901 463.781 535.776 462.127 536.366C420.914 550.683 395.977 571.374 388.002 597.786C376.54 635.586 404.395 672.754 404.69 673.176C405.648 674.503 405.438 676.452 404.058 677.558C403.446 678.011 402.825 678.148 402.109 678.148Z",
    fill: "url(#paint103_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.743 671.806C417.785 671.806 416.763 671.385 416.131 670.416C415.298 669.131 394.217 637.114 404.5 601.611C411.664 576.979 431.933 557.089 465.024 542.456C466.404 541.697 468.385 542.456 469.186 544.057C469.902 545.722 469.101 547.534 467.563 548.229C436.348 562.03 417.205 580.561 410.536 603.338C401.097 635.945 421.209 666.56 421.419 666.876C422.378 668.34 422.03 670.321 420.534 671.269C419.997 671.691 419.365 671.785 418.743 671.785V671.806Z",
    fill: "url(#paint104_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.424 888.073C480.287 888.073 480.003 888.073 479.813 888.009C478.401 887.693 445.637 880.698 431.931 853.307C422.965 835.26 424.472 812.894 436.724 786.766C437.504 785.228 439.369 784.428 440.938 785.302C442.54 786.103 443.235 787.915 442.487 789.548C431.183 813.726 429.529 834.175 437.641 850.441C449.883 874.999 480.824 881.825 481.119 881.825C482.826 882.205 483.922 883.88 483.521 885.513C483.205 887.114 481.973 888.052 480.424 888.052V888.073Z",
    fill: "url(#paint105_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.775 922.733H460.291C458.289 922.417 410.723 915.59 390.485 877.863C376.494 851.705 379.423 817.423 399.418 776.241C400.082 774.671 401.947 773.976 403.58 774.777C405.15 775.504 405.866 777.463 405.044 779.033C386.06 818.392 383.047 850.514 396.11 874.861C414.726 909.659 460.786 916.348 461.218 916.454C462.946 916.633 464.147 918.266 463.831 920.004C463.694 921.605 462.335 922.722 460.786 922.722L460.775 922.733Z",
    fill: "url(#paint106_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.034 906.424C467.855 906.424 467.634 906.424 467.423 906.35C465.853 906.034 428.285 898.344 410.449 866.011C398.059 843.55 398.376 815.084 411.386 781.498C412.103 779.791 413.862 779.128 415.495 779.654C417.202 780.287 417.981 782.13 417.381 783.668C405.034 815.579 404.591 842.16 415.948 862.914C432.394 892.634 468.255 900.05 468.635 900.187C470.341 900.493 471.426 902.21 471.121 903.843C470.805 905.381 469.488 906.424 468.024 906.424H468.034Z",
    fill: "url(#paint107_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.789 1027.38C619.985 1027.38 613.958 1026.51 607.827 1024.48C588.706 1018.03 573.988 1001.07 564.211 974.008C563.6 972.439 564.475 970.626 566.076 970.068C567.814 969.447 569.595 970.31 570.206 971.88C579.245 996.964 592.635 1012.71 609.881 1018.46C635.956 1027.2 662.431 1010.06 662.747 1009.95C664.169 1008.84 666.076 1009.36 667.098 1010.89C668.109 1012.42 667.614 1014.34 666.16 1015.24C665.223 1015.88 647.471 1027.37 625.789 1027.37V1027.38Z",
    fill: "url(#paint108_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.065 1074.23C610.217 1074.23 603.127 1073.39 595.9 1071.2C567.487 1062.59 545.426 1036.32 530.361 993.056C529.75 991.381 530.677 989.569 532.331 989.01C533.964 988.452 535.829 989.284 536.355 990.959C550.694 1032.13 571.364 1057.08 597.723 1065.16C635.523 1076.3 672.796 1048.71 673.144 1048.37C674.566 1047.43 676.473 1047.6 677.59 1048.99C678.654 1050.53 678.338 1052.43 676.979 1053.55C675.62 1054.49 649.229 1074.21 617.076 1074.21L617.065 1074.23Z",
    fill: "url(#paint109_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621.795 1051.45C615.285 1051.45 608.521 1050.55 601.663 1048.67C577 1041.53 557.12 1021.15 542.476 988.157C541.781 986.482 542.476 984.67 544.077 984.017C545.594 983.216 547.575 983.911 548.27 985.544C562.135 1016.82 580.634 1036.02 603.348 1042.57C636.165 1051.91 666.644 1031.77 666.96 1031.67C668.319 1030.7 670.289 1031.04 671.247 1032.47C672.28 1033.93 671.89 1035.91 670.426 1036.85C669.34 1037.58 648.407 1051.45 621.795 1051.45Z",
    fill: "url(#paint110_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M828.012 1026.96C815.612 1026.96 801.78 1023.44 786.767 1016.37C785.229 1015.57 784.607 1013.73 785.303 1012.16C785.998 1010.63 787.884 1009.68 789.559 1010.63C813.663 1021.88 834.081 1023.66 850.452 1015.46C875.084 1003.23 881.805 972.438 881.805 972.133C882.226 970.321 883.796 969.172 885.566 969.625C887.304 970.078 888.389 971.648 888.042 973.386C887.726 974.777 880.583 1007.56 853.307 1021.14C845.575 1025.04 837.21 1026.96 828.012 1026.96Z",
    fill: "url(#paint111_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M841.454 1071.34C822.29 1071.34 800.483 1065.48 776.241 1053.69C774.671 1053.02 774.081 1051.07 774.777 1049.54C775.62 1047.84 777.463 1047.21 779.033 1048.08C818.392 1067.06 850.651 1070.1 874.829 1057.07C909.627 1038.43 916.285 992.518 916.391 991.991C916.601 990.421 917.96 989.305 919.53 989.305H919.92C921.732 989.579 922.986 991.085 922.701 992.897C922.427 994.815 915.527 1042.47 877.874 1062.61C867.107 1068.42 854.844 1071.35 841.475 1071.35L841.454 1071.34Z",
    fill: "url(#paint112_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M828.98 1051.65C814.631 1051.65 798.744 1048.39 781.393 1041.62C779.718 1040.99 778.917 1039.11 779.581 1037.58C780.171 1035.9 781.951 1035.07 783.689 1035.7C815.6 1048.13 842.149 1048.39 862.84 1037.12C892.592 1020.75 899.977 984.838 900.082 984.416C900.398 982.741 902.168 981.319 903.812 981.972C905.487 982.246 906.593 983.995 906.319 985.659C905.971 987.229 898.312 1024.78 865.906 1042.61C855.034 1048.64 842.665 1051.63 828.98 1051.63V1051.65Z",
    fill: "url(#paint113_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M972.999 889.19C971.671 889.19 970.418 888.284 970.07 887.136C969.438 885.471 970.281 883.691 971.914 883.101C996.998 873.904 1012.74 860.524 1018.46 843.215C1027.2 817.161 1010.14 790.644 1010.03 790.402C1009.09 788.938 1009.44 787.02 1010.97 786.019C1012.5 785.018 1014.32 785.493 1015.29 786.957C1016.06 788.105 1034.17 816.287 1024.48 845.269C1018.08 864.464 1001.11 879.161 974.115 888.948C973.768 889.127 973.388 889.19 972.999 889.19Z",
    fill: "url(#paint114_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M992.089 922.945C990.73 922.945 989.476 922.102 989.023 920.859C988.433 919.152 989.265 917.372 990.94 916.813C1032.26 902.391 1057.09 881.836 1065.17 855.393C1076.56 817.593 1048.77 780.393 1048.45 780.046C1047.34 778.623 1047.62 776.632 1049.08 775.621C1050.34 774.536 1052.5 774.778 1053.47 776.242C1054.72 777.781 1083.53 816.339 1071.24 857.237C1062.6 885.661 1036.33 907.679 993.037 922.723C992.689 922.86 992.373 922.934 992.099 922.934L992.089 922.945Z",
    fill: "url(#paint115_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M986.8 910.956C985.547 910.956 984.504 910.26 983.903 909.038C983.24 907.469 983.903 905.551 985.536 904.824C1016.82 891.034 1036.05 872.534 1042.53 849.715C1052 817.035 1031.87 786.525 1031.73 786.283C1030.69 784.818 1031.11 782.764 1032.46 781.858C1033.85 780.92 1035.98 781.268 1036.88 782.764C1037.85 784.049 1058.97 815.96 1048.66 851.421C1041.55 876.116 1021.18 896.08 988.117 910.64C987.696 910.85 987.211 910.956 986.79 910.956H986.8Z",
    fill: "url(#paint116_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1013.47 668.183C1013.12 668.183 1012.57 668.015 1012.19 667.878C1010.62 667.109 1009.92 665.265 1010.62 663.664C1022.01 639.422 1023.65 618.836 1015.53 602.633C1003.16 578.002 972.438 571.386 972.153 571.281C970.373 570.996 969.224 569.29 969.646 567.551C970.067 565.876 971.595 564.412 973.375 565.076C974.734 565.349 1007.55 572.492 1021.17 599.81C1030.2 617.888 1028.6 640.254 1016.4 666.308C1015.87 667.488 1014.65 668.183 1013.47 668.183Z",
    fill: "url(#paint117_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1050.92 678.529C1050.33 678.529 1049.99 678.455 1049.5 678.255C1047.9 677.486 1047.27 675.61 1048.04 673.967C1067.05 634.808 1070.06 602.549 1057.02 578.234C1038.36 543.394 992.37 536.704 991.886 536.641C990.211 536.43 988.957 534.861 989.168 533.059C989.484 531.489 991.433 530.13 992.718 530.341C994.804 530.689 1042.39 537.547 1062.6 575.316C1076.63 601.474 1073.71 635.587 1053.69 676.79C1053.16 677.907 1052.08 678.529 1050.94 678.529H1050.92Z",
    fill: "url(#paint118_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1038.71 673.756C1038.28 673.756 1037.9 673.756 1037.59 673.545C1035.91 672.987 1035.08 671.143 1035.71 669.468C1048.05 637.589 1048.53 610.914 1037.14 590.254C1020.72 560.503 984.849 553.118 984.502 552.981C982.763 552.696 981.615 551.032 981.994 549.252C982.342 547.545 983.596 546.639 985.682 546.776C987.22 547.092 1024.84 554.751 1042.63 587.083C1055 609.555 1054.61 638.01 1041.62 671.733C1041.17 673.019 1039.95 673.756 1038.69 673.756H1038.71Z",
    fill: "url(#paint119_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M885.84 483.206C884.586 483.206 883.364 482.374 882.911 481.152C873.714 456.036 860.408 440.36 843.341 434.608C816.94 425.863 790.665 442.93 790.423 443.036C788.958 443.973 787.115 443.668 785.998 442.13C785.06 440.739 785.44 438.748 786.904 437.81C788.084 437.01 816.055 418.826 845.248 428.613C864.443 435.061 879.003 451.917 888.863 478.982C889.485 480.615 888.621 482.363 886.914 483.027C886.598 483.206 886.251 483.206 885.829 483.206H885.84Z",
    fill: "url(#paint120_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M919.773 464.222C918.446 464.222 917.192 463.421 916.844 462.136C902.422 420.922 881.804 395.943 855.435 388.105C817.361 376.611 780.256 404.403 779.94 404.761C778.581 405.731 776.526 405.488 775.483 404.098C774.367 402.739 774.683 400.716 776.115 399.641C777.791 398.493 816.528 369.542 857.278 381.984C885.702 390.549 907.795 416.824 922.702 460.092C923.366 461.662 922.491 463.506 920.858 464.064C920.479 464.243 920.163 464.243 919.784 464.243L919.773 464.222Z",
    fill: "url(#paint121_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M907.785 469.521C906.532 469.521 905.352 468.794 904.825 467.53C891.066 436.314 872.535 417.088 849.747 410.545C816.93 401.18 786.62 421.344 786.315 421.481C784.85 422.387 782.828 422.145 781.922 420.606C780.91 419.142 781.258 417.193 782.754 416.182C784.113 415.349 816.192 394.131 851.485 404.509C876.18 411.578 896.039 431.921 910.64 465.054C911.336 466.624 910.64 468.499 909.102 469.237C908.618 469.447 908.165 469.511 907.775 469.511L907.785 469.521Z",
    fill: "url(#paint122_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.712 427.264C511.999 427.264 493.362 417.098 491.434 402.57C490.718 396.954 492.498 391.181 496.607 385.945C504.424 375.842 519.774 368.499 537.525 366.329H541.286C540.623 365.043 540.001 363.821 539.369 362.462C527.032 337.104 529.318 312.094 544.721 304.424C559.67 297.281 581.668 311.388 593.594 335.956C594.394 336.862 594.974 338.115 595.458 339.432C596.227 338.558 596.923 337.726 597.639 336.714C609.902 323.682 624.567 315.812 637.42 315.317C644.394 315.317 650.294 317.203 654.561 321.238C658.585 324.999 660.755 330.541 660.903 337.125C661.198 349.978 654.023 365.549 642.097 377.917C636.819 383.216 632.521 386.767 628.265 389.137L625.062 383.638C628.792 381.584 632.827 378.307 637.599 373.461C648.398 362.346 654.877 348.45 654.634 337.336C654.455 332.458 652.98 328.528 650.22 325.905C647.365 323.082 643.235 321.659 638.452 321.659H637.599C626.632 322.081 613.21 329.361 602.517 340.823C601.695 341.908 600.736 343.056 599.799 344.131C598.893 345.206 597.955 346.291 597.102 347.513L593.91 351.558L591.623 346.923C591.192 345.943 590.802 344.837 590.338 343.752C589.727 342.013 589.221 340.549 588.263 339.327C577.728 317.624 559.333 304.666 547.502 310.029C535.555 316.055 534.597 337.968 545.184 359.881C546.038 361.862 546.965 363.431 547.903 364.927C548.535 365.97 549.135 367.013 549.578 367.951L551.927 372.544H537.957C522.386 374.493 508.332 381.046 501.674 389.759C498.577 393.731 497.228 397.766 497.755 401.779C499.43 414.601 520.574 423.208 543.857 420.279C545.321 420.279 545.427 420.279 546.038 420.005L548.756 425.789C546.786 426.632 545.616 426.632 544.257 426.632C541.055 427.053 537.831 427.253 534.712 427.253V427.264Z",
    fill: "url(#paint123_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.489 667.877C339.422 667.877 334.86 666.55 331.183 663.663C326.653 660.176 323.851 654.951 323.103 648.334C321.47 635.65 327.148 619.595 338.189 605.414L340.855 602.833C339.517 602.412 338.137 602.001 336.809 601.369C310.103 592.277 294.026 572.945 299.536 556.542C305.035 540.939 330.467 535.429 356.426 544.384C357.658 544.563 358.901 544.911 360.155 545.501C360.155 544.384 359.966 543.236 359.86 542.056C359.218 524.188 364.106 508.164 372.84 498.861C377.538 493.847 383.132 491.023 389.022 490.918H389.654C394.953 490.918 400.189 493.183 404.845 497.608C414.169 506.457 420.09 522.545 420.416 539.727C420.416 547.007 419.774 552.823 418.446 557.595L412.294 555.815C413.526 551.664 414.053 546.375 414.053 539.822C413.758 524.314 408.554 509.86 400.484 502.201C397.018 498.925 393.288 497.218 389.654 497.218H389.274C384.987 497.323 381.057 499.304 377.517 503.17C369.974 511.146 365.655 525.779 366.108 541.487C366.339 542.846 366.508 544.373 366.561 546.017C366.634 547.271 366.74 548.672 366.94 550.062L367.656 555.077L362.8 553.402C361.672 553.128 360.692 552.707 359.597 552.148C357.995 551.485 356.478 550.726 354.982 550.473C332.353 542.846 309.818 546.438 305.551 558.628C301.306 571.375 315.981 587.536 339.095 595.511C340.992 596.312 342.772 596.733 344.405 597.144C345.659 597.429 346.807 597.776 347.955 598.155L352.802 599.788L342.941 609.576C333.312 622.007 328.012 636.64 329.371 647.544C329.982 652.454 331.953 656.215 335.05 658.627C345.258 666.571 366.424 657.785 380.878 639.253C381.566 638.558 381.984 637.999 382.132 637.578L388.189 639.39C387.557 641.444 386.778 642.287 385.629 643.436C373.598 658.796 357.5 667.856 344.51 667.856L344.489 667.877Z",
    fill: "url(#paint124_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.073 961.882C395.28 961.882 390.423 960.144 385.935 956.552C375.863 948.713 368.499 933.322 366.319 915.591V911.861C365.149 912.525 363.832 913.189 362.473 913.81C337.115 925.936 312.115 923.671 304.435 908.374C297.239 893.435 311.399 871.554 335.977 859.502C336.936 858.701 338.19 858.143 339.422 857.658C338.601 856.889 337.842 856.194 336.81 855.456C326.97 846.227 320.006 835.639 316.993 825.357C313.79 814.348 315.286 804.877 321.239 798.566C325.073 794.521 330.541 792.298 337.21 792.192H337.958C350.6 792.192 365.866 799.293 378.034 810.934C383.122 816.192 386.757 820.69 389.159 824.936L383.617 828.033C381.479 824.23 378.234 820.227 373.567 815.486C362.558 805.003 349.041 798.556 338.032 798.556H337.315C332.364 798.629 328.413 800.125 325.79 802.843C321.523 807.479 320.512 814.864 323.093 823.535C325.79 832.805 332.058 842.414 340.845 850.568C341.993 851.368 343.162 852.317 344.384 853.497C345.417 854.371 346.354 855.129 347.503 856.067L351.664 859.238L346.892 861.43C345.954 861.851 344.922 862.304 343.952 862.609C342.225 863.199 340.644 863.832 339.285 864.769C317.688 875.494 304.604 893.931 310.145 905.519C316.045 917.54 337.958 918.657 359.892 907.995C361.968 907.121 363.516 906.183 365.033 905.245C366.013 904.655 367.035 904.034 368.046 903.465L372.608 901.2V906.32C372.608 908.901 372.608 911.819 372.661 915.096C374.61 930.698 381.142 944.742 389.78 951.495C393.826 954.592 397.861 955.814 401.717 955.435C414.675 953.728 423.198 932.584 420.322 909.28C420.378 908.255 420.297 907.57 420.08 907.226L425.579 904.086C426.727 906.004 426.727 907.321 426.664 908.996C429.941 935.681 419.152 959.575 402.528 961.703C401.727 961.735 400.979 961.84 400.094 961.84L400.073 961.882Z",
    fill: "url(#paint125_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.156 1154.6C560.997 1154.6 558.71 1154.25 556.645 1153.56C540.758 1148.06 535.322 1123.14 544.33 1096.74C544.488 1095.52 544.972 1094.17 545.499 1092.95C544.404 1093.01 543.255 1093.13 542.086 1093.37H539.21C512.282 1093.37 491.433 1080.76 490.79 1064.07C490.664 1058.57 492.971 1053.06 497.638 1048.26C506.456 1038.96 522.585 1033.04 539.821 1032.66C546.785 1032.66 552.61 1033.35 557.478 1034.71L555.897 1040.81C551.452 1039.63 546.174 1038.97 539.821 1038.97C524.334 1039.39 509.88 1044.57 502.221 1052.62C498.786 1056.21 497.122 1060.11 497.153 1063.95C497.638 1076.98 516.222 1087.04 539.083 1087.04H541.485C543.118 1086.69 544.983 1086.62 546.795 1086.59C547.912 1086.51 549.06 1086.41 550.23 1086.27L555.371 1085.74L553.538 1090.55C553.19 1091.49 552.705 1092.42 552.305 1093.37C551.557 1095 550.788 1096.54 550.525 1098.32C542.813 1120.99 546.574 1143.33 558.689 1147.51C560.154 1148 561.702 1148.21 563.251 1148.21C574.903 1148.21 588.493 1134.42 595.584 1114.14C596.405 1112.19 596.806 1110.34 597.153 1108.7C597.469 1107.55 597.764 1106.3 598.091 1105.21L599.724 1100.33L603.369 1103.96C605.234 1105.77 607.415 1107.89 609.553 1110.06C621.953 1119.77 636.27 1125.04 647.49 1123.75C652.473 1123.16 656.203 1121.25 658.668 1118.08C666.664 1107.87 657.657 1086.86 639.199 1072.23C638.553 1071.64 638.065 1071.27 637.735 1071.11L639.168 1064.95C641.485 1065.51 642.402 1066.44 643.434 1067.49C664.631 1084.24 673.955 1108.76 663.693 1121.93C660.248 1126.46 654.875 1129.24 648.228 1130.12C635.881 1131.9 619.562 1125.94 605.444 1114.82C604.517 1114.02 603.664 1113.07 602.811 1112.34C602.516 1113.67 602.115 1114.96 601.504 1116.35C593.476 1139.44 577.8 1154.6 563.167 1154.6H563.156Z",
    fill: "url(#paint126_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M899.565 1150.63C894.129 1150.63 888.177 1148.5 882.214 1144.53C873.301 1138.61 865.221 1128.96 859.437 1117.12C858.668 1116.18 858.046 1114.96 857.625 1113.67C856.782 1114.52 856.087 1115.38 855.433 1116.29C846.205 1126.15 835.648 1133.11 825.366 1136.1C814.283 1139.14 804.749 1137.81 798.544 1131.89C794.509 1128.05 792.349 1122.55 792.138 1115.9C791.833 1103.18 799.112 1087.44 810.954 1075.07C816.106 1069.98 820.573 1066.43 824.955 1063.93L828.095 1069.47C824.197 1071.66 820.077 1074.94 815.516 1079.54C804.749 1090.73 798.238 1104.58 798.48 1115.73C798.544 1120.64 800.113 1124.68 802.905 1127.29C807.541 1131.65 814.999 1132.49 823.565 1129.98C832.793 1127.37 842.37 1120.99 850.524 1112.25C851.356 1111.1 852.473 1109.88 853.59 1108.63C854.422 1107.58 855.265 1106.71 856.097 1105.6L859.3 1101.53L861.46 1106.27C862.018 1107.25 862.292 1108.18 862.713 1109.26C863.335 1111 863.83 1112.46 864.873 1113.93C870.446 1125.1 877.758 1133.95 885.775 1139.32C893.234 1144.3 900.271 1145.66 905.497 1142.83C917.475 1137.05 918.592 1115.28 908.004 1093.22C907.235 1091.35 906.224 1089.78 905.36 1088.31C904.664 1087.2 904.032 1086.26 903.548 1085.14L901.04 1080.44L906.403 1080.55C908.836 1080.49 911.87 1080.49 914.968 1080.44C938.83 1077.55 957.014 1064.56 955.518 1051.39C953.843 1038.54 932.941 1029.82 909.258 1032.72H907.867L903.969 1027.71C905.992 1026.38 907.382 1026.53 909.058 1026.48C935.912 1023.13 959.711 1034.04 961.797 1050.56C963.746 1067.59 943.476 1083.48 915.537 1086.82C914.283 1086.85 913.103 1086.85 911.881 1086.85C912.471 1088.07 913.208 1089.25 913.725 1090.54C926.061 1116.03 923.754 1141.09 908.225 1148.58C905.613 1150.01 902.726 1150.63 899.586 1150.63H899.565Z",
    fill: "url(#paint127_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1063.54 962.303C1058.21 962.303 1052.92 959.965 1048.24 955.582C1038.98 946.806 1032.98 930.603 1032.64 913.325C1032.64 906.319 1033.33 900.536 1034.72 895.626L1040.78 897.301C1039.6 901.652 1038.97 906.92 1038.97 913.294C1039.35 928.833 1044.54 943.214 1052.62 950.883C1056.1 954.223 1059.87 955.93 1063.53 955.93H1063.84C1068.1 955.856 1072.03 953.875 1075.68 950.04C1083.13 942.171 1087.45 927.327 1086.97 911.724C1086.76 910.186 1086.62 908.448 1086.55 906.741C1086.44 905.529 1086.37 904.339 1086.23 902.98L1085.6 898.028L1090.3 899.598C1091.48 900.019 1092.46 900.504 1093.65 901.062C1095.17 901.758 1096.71 902.39 1098.18 902.59C1110.09 906.636 1121.31 907.784 1130.92 905.793C1139.7 904.118 1145.55 900.041 1147.5 894.436C1151.76 881.825 1137.02 865.622 1114.03 857.542C1112.19 856.783 1110.54 856.362 1108.91 856.014C1107.52 855.666 1106.27 855.35 1105.15 854.834L1099.92 853.085L1104.03 849.535C1105.98 847.87 1107.96 845.774 1109.99 843.54C1119.77 831.172 1125.04 816.507 1123.74 805.635C1123.08 800.725 1121.17 796.996 1118.03 794.52C1107.72 786.514 1086.76 795.426 1072.12 813.852C1071.61 814.456 1071.31 814.899 1071.22 815.18L1064.98 814.031C1065.36 811.84 1066.31 810.829 1067.24 809.744C1084.49 788.146 1108.6 779.023 1121.93 789.537C1126.39 792.951 1129.18 798.208 1129.94 804.866C1131.61 817.582 1125.9 833.532 1114.79 847.744C1114.03 848.618 1113.13 849.524 1112.31 850.251C1113.64 850.673 1114.96 851.094 1116.25 851.684C1142.9 860.944 1158.92 880.245 1153.35 896.448C1150.7 904.318 1143.11 909.828 1132.1 911.987C1121.75 914.115 1109.07 912.967 1096.7 908.711C1095.48 908.606 1094.19 908.121 1092.94 907.594C1093.01 908.711 1093.08 909.922 1093.33 911.071C1093.92 929.118 1089.01 945.142 1080.23 954.37C1075.54 959.385 1069.96 962.072 1063.97 962.282H1063.52L1063.54 962.303Z",
    fill: "url(#paint128_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1115.13 661.05C1102.59 661.05 1087.26 653.834 1075.07 642.171C1069.88 636.977 1066.43 632.447 1063.93 628.128L1069.53 625.094C1071.69 628.928 1074.76 632.826 1079.53 637.673C1090.6 648.197 1104.12 654.666 1115.13 654.666H1115.76C1120.71 654.529 1124.67 653.065 1127.29 650.283C1131.65 645.69 1132.66 638.336 1129.97 629.592C1127.4 620.363 1121.02 610.745 1112.28 602.559C1111.1 601.727 1109.84 600.684 1108.69 599.567C1107.68 598.693 1106.77 597.86 1105.66 596.996L1101.65 593.825L1106.29 591.666C1107.22 591.213 1108.16 590.833 1109.22 590.486C1110.95 589.896 1112.49 589.274 1113.88 588.252C1135.48 577.559 1148.58 559.133 1142.94 547.639C1137.05 535.65 1115.07 534.544 1093.12 545.195C1091.45 545.996 1089.99 546.796 1088.56 547.639C1087.33 548.366 1086.15 549.167 1085.01 549.693L1080.02 552.095L1080.44 546.596C1080.69 544.015 1080.58 541.16 1080.44 538.168C1078.5 522.492 1072.02 508.49 1063.3 501.621C1059.47 498.629 1055.75 497.091 1051.39 497.787C1038.5 499.325 1029.93 520.5 1032.65 543.973C1032.65 544.637 1032.65 545.121 1032.72 545.227L1027.71 549.019C1026.38 547.207 1026.38 545.817 1026.38 544.278C1023.24 517.382 1034.11 493.52 1050.62 491.402C1055.84 490.633 1061.98 492.487 1067.28 496.691C1077.35 504.498 1084.63 519.858 1086.79 537.662C1086.86 538.874 1086.86 540.138 1086.86 541.286C1088.04 540.591 1089.29 540.001 1090.52 539.369C1116.16 526.937 1140.99 529.371 1148.66 544.868C1156.04 559.923 1142.25 581.341 1117.17 593.709C1116.26 594.405 1115.01 594.963 1113.76 595.521C1114.53 596.322 1115.36 596.986 1116.4 597.787C1126.16 606.878 1133.12 617.54 1136.11 627.854C1139.32 638.863 1137.86 648.334 1131.87 654.645C1128.11 658.648 1122.6 660.913 1115.95 661.05H1115.15H1115.13Z",
    fill: "url(#paint129_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M913.358 420.364C905.973 420.364 900.326 419.774 895.585 418.341L897.292 412.347C901.506 413.495 906.595 414.085 913.284 414.085C928.75 413.811 943.246 408.586 950.905 400.568C954.319 396.944 956.099 393.015 955.92 389.348C955.857 384.997 953.834 381.026 949.999 377.433C942.056 369.943 927.075 365.592 911.715 366.15C910.324 366.392 908.786 366.424 907.216 366.498C905.825 366.603 904.498 366.708 903.107 366.845L898.23 367.435L899.694 362.726C900.073 361.683 900.6 360.566 901.021 359.46C901.717 357.922 902.412 356.468 902.549 354.898C910.313 332.048 906.595 309.755 894.469 305.573C882.037 301.222 865.518 315.845 857.617 339.011C856.774 340.96 856.394 342.604 856.015 344.237C855.625 345.522 855.32 346.744 854.835 348.03L853.086 353.118L849.536 349.041C848.072 347.408 846.26 345.691 844.448 343.995L843.542 343.057C831.142 333.375 816.719 328.076 805.604 329.361C800.695 329.993 796.997 331.9 794.49 335.04C786.515 345.206 795.427 366.319 813.896 380.952C814.349 381.373 814.728 381.679 814.833 381.784L813.99 388.158C811.694 387.673 810.682 386.63 809.671 385.619C788.358 368.858 779.224 344.3 789.538 331.131C792.952 326.601 798.209 323.851 804.793 323.082C817.13 321.302 833.502 327.159 847.713 338.232L848.756 339.317C849.315 339.833 849.873 340.255 850.221 340.813C850.642 339.486 851.127 338.169 851.685 336.841C860.745 310.156 879.941 294.163 896.555 299.536C912.442 305.036 917.73 330.046 908.786 356.352C908.607 357.606 908.154 358.86 907.669 360.082C908.786 360.082 909.997 359.976 911.262 359.766H914.19C930.773 359.766 945.648 364.612 954.319 372.798C959.334 377.496 962.157 383.217 962.262 389.064C962.473 394.563 960.103 400.073 955.541 404.846C946.723 414.075 930.531 420.069 913.358 420.354V420.364Z",
    fill: "url(#paint130_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.069 193.024C525.563 193.825 525.036 194.351 524.541 195.047L526.069 193.024Z",
    fill: "url(#paint131_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.601 195.638C500.532 186.167 496.834 174.146 496.834 160.977C496.834 155.509 497.445 150.558 498.678 146.28C501.164 134.786 507.053 124.683 515.797 117.267L517.177 116.118L518.673 117.34C530.652 127.654 537.626 143.604 537.626 160.987C537.626 162.315 537.626 163.463 537.331 164.928L533.033 164.095C533.17 163.021 533.17 162.115 533.17 160.998C533.17 145.638 527.354 131.563 517.177 122.018C510.087 128.602 505.199 137.378 503.039 147.344C501.891 151.39 501.354 155.952 501.354 160.998C501.354 173.229 504.714 184.302 511.162 193.046L507.611 195.659L507.601 195.638Z",
    fill: "url(#paint132_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.348 160.661C465.999 148.956 467.252 137.072 471.782 127.18L472.509 125.473L474.395 126.032C485.489 129.066 495.244 135.682 502.651 145.469L499.1 148.187C492.674 139.759 484.467 133.838 475.006 130.804C471.509 139.517 470.655 149.715 472.688 159.786L468.348 160.661Z",
    fill: "url(#paint133_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.173 198.282C496.792 187.831 490.261 177.622 480.884 169.405C477.492 166.687 473.573 164.253 469.496 162.199C460.278 157.637 450.195 155.646 440.65 156.594C441.072 165.612 444.254 174.673 449.879 182.995H450.996L451.312 185.229L449.068 185.26V187.452H447.899L446.961 186.514C439.924 176.622 436.184 165.612 436.184 154.708V152.759L438.069 152.549C448.868 150.874 460.783 152.823 471.445 158.259C475.954 160.418 480.01 163.031 483.76 165.992C493.937 174.904 500.901 185.987 503.514 197.376L499.194 198.282H499.173Z",
    fill: "url(#paint134_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.024 226.748C463.609 226.748 458.099 225.947 452.768 224.483C447.385 223.155 442.697 221.175 438.746 218.667C428.59 213.337 420.299 204.803 415.41 194.774L414.578 193.035L416.211 191.992C424.955 186.072 435.427 183.006 446.426 183.006H448.849L450.988 183.28C455.307 183.459 459.553 184.049 463.514 185.166C476.546 188.368 487.587 195.648 494.814 205.72L491.19 208.195C484.742 199.346 474.186 192.414 462.345 189.422C458.162 188.273 453.622 187.747 449.06 187.747H446.774V187.399H446.647C436.976 187.399 428.042 189.875 420.299 194.605C424.776 203.002 432.088 210.176 440.969 214.843C444.593 217.214 448.944 218.889 453.906 220.142C465.526 223.45 477.905 222.787 488.598 218.615L490.231 222.66C483.573 225.347 476.346 226.769 469.003 226.769L469.024 226.748Z",
    fill: "url(#paint135_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.069 251.79C447.679 251.79 446.33 251.79 444.929 251.547C433.488 251.094 422.647 246.912 413.755 239.769L412.291 238.484L413.271 236.851C419.265 227.095 428.41 219.183 439.082 214.727L440.841 218.878C431.539 222.713 423.595 229.297 418.128 237.515C425.997 243.372 435.331 246.743 445.329 247.165C450.123 247.829 454.98 247.102 459.352 246.396C470.972 244.415 482.066 238.631 490.357 229.887L493.602 233.027C484.594 242.361 472.7 248.566 460.058 250.863C456.665 251.389 452.883 251.8 449.08 251.8L449.069 251.79Z",
    fill: "url(#paint136_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.403 282.827C439.104 282.827 435.027 282.342 431.087 281.362L429.201 280.878L429.422 278.897C430.349 268.067 435.417 256.984 443.55 247.966L446.879 250.895C439.81 258.764 435.312 268.067 434.09 277.443C443.213 279.434 453.495 278.318 463.051 274.378C467.159 272.913 471.258 270.722 475.293 268.035C477.674 266.255 480.286 264.274 482.551 261.904C484.121 260.65 485.754 258.764 487.218 256.952C487.534 256.362 487.966 255.836 488.472 255.246C488.767 254.93 489.083 254.614 489.399 254.129L490.063 253.012C491.095 251.474 491.928 250.083 492.76 248.556L493.034 248.103C494.319 245.353 495.562 242.456 496.426 239.643L500.714 240.897C499.829 243.931 498.533 246.818 497.332 249.293C497.279 249.746 497.069 250.094 496.858 250.336C495.847 252.317 494.888 253.855 493.877 255.488L493.023 256.636C492.623 257.3 492.17 257.721 491.854 258.206C491.454 258.659 491.074 259.038 490.737 259.46C489.705 260.819 487.808 263.326 485.564 265.17C483.247 267.54 480.465 269.763 477.8 271.649C473.407 274.609 468.982 276.906 464.663 278.476C457.752 281.404 450.482 282.827 443.36 282.827H443.403Z",
    fill: "url(#paint137_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.323 312.546L461.68 310.355C458.404 299.872 458.404 287.609 461.68 275.862L462.007 274.609L463.134 274.261C467.632 272.965 472.099 270.289 475.133 268.309L476.06 267.54C478.642 265.485 480.643 263.915 482.139 261.893L482.677 261.44C484.457 260.218 486.09 258.479 487.07 256.941C487.681 255.719 488.503 254.782 489.872 254.012C491.105 252.063 491.948 250.631 492.485 248.861L492.885 247.154H493.581C495.045 244.51 495.582 242.35 496.214 240.085L500.46 241.096C499.923 243.572 499.206 246.29 497.31 249.493C497.131 250.02 496.889 250.578 496.457 250.884C495.761 253.012 494.645 254.782 493.581 256.383L493.264 256.941L492.443 257.71C491.589 257.984 491.315 258.342 490.978 259.069C489.535 261.334 487.586 263.315 485.479 264.853C483.635 267.181 481.433 268.93 478.842 270.985L477.778 271.891C474.586 273.977 470.203 276.589 465.641 278.191C463.134 287.841 463.06 298.113 465.315 307.004C471.572 304.845 476.64 302.379 481.318 299.029L483.909 302.79C478.231 306.72 472.205 309.512 464.419 311.914L462.312 312.546H462.323Z",
    fill: "url(#paint138_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.37 261.576L605.337 257.289C606.886 256.867 608.14 256.456 609.33 255.93C605.337 247.154 598.753 239.632 590.167 234.333C585.605 231.193 581.738 229.286 578.23 228.306C566.452 223.608 553.841 223.218 542.474 226.947L541.041 222.765C553.462 218.656 567.168 219.141 579.642 224.092C583.382 225.072 587.691 227.263 592.632 230.54C602.493 236.85 609.994 245.626 614.197 256.035L614.872 257.71L613.407 258.753C611.216 260.217 609.14 260.881 606.349 261.576H606.37Z",
    fill: "url(#paint139_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.2 234.586L590.789 230.403C600.629 227.064 609.151 221.174 615.051 213.789C607.993 207.342 598.701 203.128 588.629 201.874L589.24 197.449C600.945 198.914 611.722 204.107 619.634 211.903L620.888 213.336L619.845 214.801C613.418 223.756 603.557 230.719 592.2 234.586Z",
    fill: "url(#paint140_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.247 218.036C546.634 218.036 544.148 217.825 541.566 217.509L542.283 213.084C553.513 214.823 565.671 212.21 576.68 205.804C580.568 203.645 584.308 200.895 587.352 197.966C595.264 190.855 600.542 181.974 602.576 172.566C593.452 169.743 583.412 169.848 573.657 172.777L572.403 168.489C583.728 165.149 595.338 165.286 605.884 168.91L607.675 169.574L607.38 171.418C605.41 182.669 599.563 192.941 590.376 201.201C587.047 204.403 583.043 207.258 578.914 209.597C569.579 215.139 559.181 218.025 549.236 218.025L549.247 218.036Z",
    fill: "url(#paint141_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.345 207.026L537.007 202.886C547.721 199.335 557.561 191.771 564.609 181.636C567.485 177.559 569.592 173.693 570.951 169.858C574.996 160.102 576.05 149.831 573.932 140.665C560.205 142.551 547.078 150.874 538.524 163.453C538.123 163.979 537.828 164.464 537.597 164.917L536.964 165.823C531.497 174.251 528.505 183.764 528.273 193.099L528.189 193.825C528.052 194.173 528.052 194.763 528.052 195.321H523.574C523.574 194.595 523.574 193.646 523.89 192.709C524.185 182.574 527.43 172.439 533.351 163.305L533.857 162.431C534.204 161.872 534.583 161.419 534.931 160.903C544.56 146.796 559.647 137.389 575.397 136.03L577.177 135.893L577.714 137.599C580.728 148.261 579.79 160.313 575.102 171.491C573.637 175.494 571.362 179.708 568.349 184.207C560.69 195.111 550.081 203.265 538.355 207.026H538.345Z",
    fill: "url(#paint142_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.474 228.971L538.429 227.054C538.64 226.674 538.882 226.253 539.061 225.937C539.461 225.305 539.493 225.21 539.493 224.894L539.577 224.167C540.104 222.639 540.104 221.691 540.104 219.816C540.104 218.878 540.104 217.203 539.756 216.434L539.493 215.455C539.493 212.146 537.734 208.765 536.048 205.878C532.761 201.422 528.284 198.735 525.123 197.376L526.903 193.236C530.633 194.911 535.816 197.977 539.756 203.476C541.779 206.921 543.749 210.756 543.949 214.938C544.56 216.571 544.56 218.531 544.56 219.816C544.56 221.702 544.56 223.229 543.949 225.252C543.844 226.537 543.307 227.412 542.917 228.213C542.78 228.423 542.59 228.666 542.464 228.982L542.474 228.971Z",
    fill: "url(#paint143_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.726 245.142C500.535 244.51 499.176 243.814 497.1 242.35C493.36 238.726 491.106 235.281 490.031 231.931C488.293 229.107 487.334 225.209 487.334 220.542V219.815C487.334 215.254 488.619 209.954 490.716 205.709L491.116 205.045C493.676 201.948 496.289 198.734 500.24 195.953C503.042 194.594 505.602 193.34 508.752 191.981L509.605 191.771C510.385 191.771 511.238 191.634 511.997 191.56C513.177 191.423 514.473 191.181 516 191.181C519.308 191.181 522.058 191.771 525.566 193.235L523.891 197.375C520.91 196.153 518.687 195.637 516 195.637C514.747 195.637 513.63 195.816 512.618 195.953C511.786 196.164 510.933 196.227 510.09 196.227C507.203 197.449 504.886 198.597 502.494 199.851C499.291 202.011 496.995 204.803 494.519 207.868C492.886 211.313 491.801 215.949 491.801 219.815V220.542C491.801 224.303 492.475 227.58 494.034 230.055C495.13 233.332 496.995 236.082 499.924 238.968C501.356 239.874 502.347 240.433 504.064 240.991L502.726 245.131V245.142Z",
    fill: "url(#paint144_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.539 240.085C498.396 236.493 493.592 228.655 493.592 220.543C493.592 207.827 503.674 197.513 516.011 197.513C528.347 197.513 538.271 207.827 538.271 220.543C538.271 222.46 538.271 224.62 537.523 226.853L533.362 225.389C533.868 223.861 533.868 222.218 533.868 220.543C533.868 210.271 525.808 202.011 516.011 202.011C506.213 202.011 498.069 210.271 498.069 220.543C498.069 226.948 501.904 233.227 507.509 236.082L505.539 240.085Z",
    fill: "url(#paint145_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.535 491.118C207.767 491.919 207.767 492.72 207.851 493.626L207.535 491.118Z",
    fill: "url(#paint146_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.356 505.952C184.683 504.277 173.505 498.356 164.15 488.99C160.105 484.913 157.292 481.152 155.111 477.317C148.684 467.214 145.787 456.036 146.799 444.785L146.936 442.941L148.779 442.73C150.138 442.699 151.36 442.625 152.677 442.625C167.237 442.625 181.712 448.893 193.017 460.187C193.954 461.019 194.881 461.968 195.682 463.39L191.952 465.623C191.415 464.865 190.836 464.296 189.951 463.39C179.584 452.971 165.815 447.092 152.519 447.092H151.055C150.602 456.742 153.32 466.319 158.861 475.031C160.947 478.655 163.602 482.037 167.342 485.83C175.981 494.574 186.274 500.042 196.957 501.58L196.346 505.962L196.356 505.952Z",
    fill: "url(#paint147_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.783 509.017C133.922 502.464 126.452 493.267 122.639 482.89L121.996 481.152L123.65 480.246C133.627 474.504 145.247 472.439 157.321 473.935L156.688 478.392C146.269 477.001 136.208 478.634 127.495 483.196C131.225 491.866 137.757 499.704 146.164 505.246L143.772 509.007L143.783 509.017Z",
    fill: "url(#paint148_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.934 542.392C134.934 540.338 124.567 535.249 116.908 527.443L115.57 526.115L116.687 524.619C123.114 515.812 132.869 508.838 144.226 505.045C148.788 503.507 153.644 502.464 158.512 501.874C171.976 501.179 184.692 503.791 194.69 509.997L192.372 513.758C183.048 508.048 171.344 505.119 158.88 506.267C154.477 506.783 150.01 507.837 145.659 509.196C135.903 512.546 127.296 518.361 121.481 525.704C128.139 531.804 136.83 536.05 146.723 537.83L147.871 536.956L149.441 538.768L147.65 540.022L148.904 541.76L148.156 542.287L146.955 542.392H146.934Z",
    fill: "url(#paint149_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.828 573.366C141.855 573.366 135.966 572.46 130.498 570.511L128.654 569.921L129.055 568.035C131.141 556.92 136.967 546.786 145.795 538.494L147.639 537.209C150.926 534.175 154.297 531.71 157.721 529.687C168.941 522.966 182.352 520.111 194.278 522.091L193.646 526.516C182.605 524.735 170.447 527.243 159.954 533.553C156.33 535.639 152.674 538.463 149.187 541.771L147.302 543.646L147.165 543.404C140.422 550.199 135.881 558.279 133.838 566.95C142.908 569.636 153.117 569.563 162.799 566.634C166.908 565.654 171.09 563.99 175.757 561.377C186.366 555.319 194.552 546.153 199.082 535.566L203.085 537.241C198.292 548.84 189.358 558.732 177.938 565.18C172.87 568.035 168.309 569.921 163.989 570.995C158.732 572.597 153.222 573.366 147.807 573.366H147.828Z",
    fill: "url(#paint150_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.185 603.739L158.753 601.895C156.035 590.812 156.972 578.697 161.439 567.93L165.58 569.636C161.682 578.939 160.681 589.253 162.588 598.861C172.448 597.323 181.414 593.119 188.736 586.429C192.118 583.743 194.899 580.33 198.102 575.979C204.897 566.465 208.605 554.518 208.373 542.392L212.872 542.287C213.051 555.382 209.111 568.235 201.641 578.549C198.228 583.216 195.215 586.904 191.665 589.864C183.268 597.428 172.659 602.232 161.134 603.454L159.195 603.728L159.185 603.739Z",
    fill: "url(#paint151_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.181 621.713L199.948 620.217C192.985 611.715 188.729 600.4 188.033 588.232L192.426 587.99C193.037 598.44 196.472 608.333 202.182 615.897C210.157 610.566 216.689 602.56 220.545 593.12C222.325 589.359 223.737 584.861 224.727 579.983C225.307 576.296 225.507 573.293 225.507 570.575C225.749 568.415 225.591 566.013 225.191 563.78C225.117 563.053 225.012 562.284 224.98 561.483C224.98 561.03 224.98 560.577 224.896 560.124C224.717 559.566 224.58 558.733 224.369 557.964C224.042 556.542 223.832 555.278 223.337 553.919L222.936 552.802C222.083 550.358 221.019 547.471 219.502 545.101L223.421 542.73C224.97 545.417 226.139 548.409 227.045 550.99C227.372 551.506 227.466 552.075 227.498 552.381C228.077 553.982 228.383 555.446 228.699 557.006C228.931 557.775 229.047 558.544 229.226 559.344C229.363 560.177 229.458 560.767 229.458 561.367C229.458 561.926 229.458 562.41 229.616 563.042C229.984 565.655 230.195 568.447 229.911 570.744C229.984 573.493 229.689 576.77 229.057 580.71C227.993 586.041 226.529 590.813 224.685 594.858C220.155 605.762 212.443 614.991 202.793 620.67L201.192 621.713H201.181Z",
    fill: "url(#paint152_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.964 620.67L245.026 619.584C235.165 614.433 226.515 605.752 220.521 595.164L219.889 594.047L220.521 592.931C222.301 589.759 223.713 585.514 224.703 580.32C225.177 576.664 225.483 573.662 225.177 570.743V570.227C225.578 567.931 225.578 565.623 225.177 563.78C224.703 562.6 224.672 561.272 224.998 559.734C224.672 557.648 224.166 555.899 223.239 554.298L222.47 552.939L222.891 552.454C222.175 549.673 221.058 547.787 219.899 545.807L221.638 544.269L223.713 543.499C224.967 545.628 226.347 547.956 227.2 551.475C227.463 551.822 227.579 552.381 227.495 552.939C228.612 554.993 229.012 557.016 229.444 559.039L229.602 559.671L229.444 560.577C229.128 561.42 229.128 561.725 229.444 562.526C229.971 565.244 229.971 567.931 229.602 570.575C229.971 573.925 229.602 577.191 229.044 581.026C228.106 586.22 226.747 590.571 224.998 594.058C230.171 602.728 237.208 609.913 245.099 614.538C247.312 610.155 249.819 604.435 250.915 597.682L255.308 598.377C253.844 606.879 250.641 613.737 247.954 618.721L246.964 620.67Z",
    fill: "url(#paint153_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.151 503.519L239.211 501.57C245.026 489.791 254.993 480.457 267.424 475.126C270.732 473.283 275.347 471.713 281.162 470.459C292.466 467.983 304.013 468.889 314.379 473.283L316.033 473.946L315.738 475.653C315.264 478.403 314.253 480.32 312.852 482.722L309.07 480.457C309.923 478.993 310.534 477.95 310.955 476.696C301.885 473.177 291.95 472.482 282.089 474.821C276.685 475.937 272.523 477.328 269.32 479.172C257.7 484.155 248.524 492.72 243.141 503.519H243.151Z",
    fill: "url(#paint154_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.669 473.662L279.719 471.713C284.28 462.484 286.145 452.244 285.134 442.73C275.62 443.257 266.076 446.776 258.027 453.118L255.309 449.494C264.674 442.319 275.968 438.274 286.977 438.274H288.947L289.263 440.223C290.939 450.958 289.042 462.905 283.669 473.662Z",
    fill: "url(#paint155_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.787 497.313L233.174 493.72C242.424 486.967 249.177 476.516 252.39 464.285C253.538 459.934 254.286 455.509 254.476 451.221C254.929 440.56 252.316 430.498 247.196 422.45C238.768 426.98 231.752 434.017 226.874 443.035L222.934 440.918C228.696 430.498 236.956 422.45 246.975 417.677L248.66 416.803L249.725 418.33C256.151 427.454 259.459 439.095 258.869 451.358C258.648 455.888 257.889 460.798 256.636 465.401C253.222 478.644 245.784 489.991 235.787 497.313Z",
    fill: "url(#paint156_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.363 494.458C206.752 493.836 206.109 493.099 205.582 492.161C198.924 485.197 193.962 475.652 191.644 464.917C191.465 464.285 191.349 463.695 191.244 463L191.117 462.231C187.915 445.122 192.055 427.886 202.127 415.865L203.275 414.506L204.876 415.349C214.39 420.68 222.291 429.835 226.958 441.16C228.907 445.301 230.203 449.905 231.12 454.993C233.469 468.025 231.731 481.362 226.189 492.266L222.238 490.349C227.358 480.214 228.991 467.846 226.737 455.794C225.957 450.958 224.661 446.776 222.923 442.941C218.846 433.08 212.314 425.073 204.318 420.122C195.995 431.131 192.666 446.323 195.416 461.367L195.595 462.136C195.679 462.768 195.827 463.39 195.995 463.979C198.176 473.914 202.632 482.722 209.164 489.58C209.744 490.454 210.144 490.907 210.555 491.255L207.352 494.458H207.363Z",
    fill: "url(#paint157_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.455 506.373C240.223 505.888 240.139 505.54 239.97 505.119C239.844 504.424 239.728 504.276 239.602 504.108L239.222 503.591C238.443 502.127 237.758 501.295 236.504 500.073L236.02 499.651C235.387 498.988 234.471 498.187 233.786 497.913L232.964 497.428C231.079 495.616 228.066 494.226 223.715 493.183C218.036 492.171 213.106 493.53 209.924 494.858L208.291 490.644C213.653 488.452 219.248 487.863 224.684 488.769C229.614 490.022 233.27 491.655 235.725 493.92C237.052 494.51 238.211 495.627 239.033 496.396L239.538 496.849C240.897 498.24 242.014 499.325 243.036 501.274C243.784 502.148 244.016 503.054 244.216 503.886C244.321 504.203 244.395 504.519 244.532 504.824L240.455 506.394V506.373Z",
    fill: "url(#paint158_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.638 546.438C216.497 546.438 212.725 545.638 209.48 543.994C206.414 543.33 203.033 541.276 199.556 537.894L199.103 537.304C195.827 534.165 192.972 529.435 191.476 525.041L191.349 524.135C190.843 520.09 190.39 516.055 191.423 511.388L191.96 509.681C192.708 507.353 193.53 505.119 194.678 502.464L195.11 501.801C195.69 501.242 196.143 500.652 196.627 500.02C197.291 498.977 198.092 497.966 199.103 497.028C201.505 494.553 203.897 493.025 207.363 491.561L209.101 495.669C206.109 496.891 204.202 498.177 202.253 500.062C201.4 501 200.789 501.874 200.167 502.633C199.64 503.328 199.135 504.024 198.618 504.624C197.544 506.995 196.933 509.081 196.143 511.072L195.69 512.536C194.889 516.223 195.289 519.847 195.721 523.545C196.922 527.443 199.461 531.489 202.253 534.207L202.738 534.797C205.572 537.547 208.237 539.18 210.997 539.917C214.095 541.381 217.529 542.045 221.638 542.045C223.239 541.697 224.356 541.276 225.905 540.507L227.885 544.521C226.02 545.49 224.556 545.985 222.07 546.438H221.638Z",
    fill: "url(#paint159_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.774 539.917C214.043 539.917 208.249 537.546 204.024 533.511C199.547 528.981 197.145 523.092 197.145 516.961C197.145 510.829 199.41 505.53 203.592 501.421C207.753 497.207 213.242 494.974 219.163 494.974H219.595C225.621 495.153 231.279 497.513 235.566 501.8C237.199 503.37 238.579 504.898 239.591 506.921L235.566 508.764C234.934 507.405 233.881 506.362 232.69 505.214C225.273 497.755 213.632 497.513 206.742 504.624C203.413 507.827 201.538 512.22 201.538 516.961C201.538 521.944 203.592 526.642 207.132 530.266C211.778 534.976 218.942 536.535 224.789 534.617L226.253 538.758C224.167 539.527 221.955 539.906 219.774 539.906V539.917Z",
    fill: "url(#paint160_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.971 927.053C193.824 927.611 194.351 927.959 195.057 928.591L192.971 927.053Z",
    fill: "url(#paint161_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.953 956.309C156.454 956.172 151.176 955.856 146.162 954.318C134.626 951.884 124.649 945.995 117.337 937.356L116.168 935.966L117.337 934.501C127.578 922.449 143.465 915.58 160.953 915.443C162.28 915.443 163.534 915.443 164.999 915.791L164.008 920.142C162.997 919.931 162.196 919.931 160.964 919.931C145.477 919.994 131.402 925.82 122.089 935.955C128.536 943.056 137.259 947.871 147.331 950.03C151.998 951.526 156.876 951.737 161.058 951.811C173.163 951.811 184.52 948.26 193.033 941.918L195.698 945.469C186.469 952.432 174.122 956.236 160.964 956.299L160.953 956.309Z",
    fill: "url(#paint162_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.059 985.955C141.295 985.955 133.804 984.417 127.178 981.32L125.492 980.551L126.029 978.812C128.958 967.803 135.701 958.016 145.467 950.525L148.164 954.002C139.736 960.523 133.794 968.846 130.834 978.043C139.525 981.731 149.681 982.531 159.784 980.519L160.669 984.838C156.771 985.565 152.81 985.955 149.049 985.955H149.059Z",
    fill: "url(#paint163_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.708 1017H152.822L152.527 1015.16C150.842 1004.26 152.822 992.34 158.238 981.647C160.271 977.464 162.989 973.324 166.002 969.457C174.915 959.28 185.966 952.243 197.46 949.672L198.492 954.023C187.915 956.394 177.643 962.841 169.426 972.207C166.624 975.8 164.148 979.729 162.199 983.701C157.584 992.93 155.614 1003.11 156.647 1012.44C165.791 1012.14 174.936 1008.86 183.143 1003.11L183.438 1001.51L185.977 1001.96L185.366 1004.09L187.473 1004.47L187.315 1005.37L186.567 1006.25C176.695 1013.28 165.718 1017.01 154.708 1017.01V1017Z",
    fill: "url(#paint164_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.024 1038.59L191.96 1036.96C185.67 1027.73 182.605 1016.4 182.952 1004.35L183.247 1002.46C183.426 997.839 184.069 993.509 185.112 989.579C188.315 976.832 195.826 965.475 205.75 958.364L208.279 961.883C199.324 968.499 192.413 979.055 189.379 990.759C188.315 994.731 187.777 999.188 187.693 1004.1L187.609 1007.27L187.472 1007.03C187.525 1016.6 189.958 1025.42 194.583 1032.87C202.98 1028.34 210.154 1021.06 214.906 1012.14C217.202 1008.48 218.951 1004.09 220.236 999.177C223.513 987.472 222.902 975.104 218.614 964.548L222.617 962.883C227.369 974.346 228.064 987.683 224.461 1000.4C223.102 1005.66 221.153 1010.37 218.677 1014.34C213.346 1024.58 204.813 1032.9 194.741 1037.7L193.013 1038.58L193.024 1038.59Z",
    fill: "url(#paint165_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.503 1041L236.923 1039.99C227.146 1033.93 219.298 1024.8 214.715 1014L218.855 1012.32C222.806 1021.55 229.359 1029.57 237.524 1035.07C243.328 1027.2 246.805 1017.61 247.195 1007.87C247.595 1003.82 247.321 999.546 246.394 993.899C244.498 982.226 238.682 971.227 229.896 962.757L232.993 959.617C242.412 968.635 248.743 980.551 250.851 993.087C251.757 999.251 251.967 1003.82 251.577 1008.17C251.145 1019.39 246.879 1030.54 239.715 1039.42L238.493 1040.99L238.503 1041Z",
    fill: "url(#paint166_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.866 1023.97L278.97 1023.79C268.045 1022.74 257.036 1017.62 247.965 1009.64L250.925 1006.3C258.732 1013.2 268.098 1017.76 277.506 1019.09C279.402 1009.75 278.338 999.546 274.461 990.107C272.933 985.892 270.679 981.742 268.056 977.77C265.791 974.662 263.926 972.471 261.945 970.627C260.692 969.026 258.953 967.561 256.878 966.034C256.161 965.475 255.55 964.885 254.939 964.285L254.002 963.516C253.654 963.347 252.832 962.82 252.19 962.367C250.968 961.672 249.903 960.977 248.671 960.313L248.755 960.208L248.281 960.271L247.649 959.892C244.499 958.354 242.002 957.311 239.674 956.794L240.854 952.443C243.33 953.033 245.953 954.15 249.177 955.783C249.893 955.857 250.43 956.173 250.746 956.478C251.968 957.037 253.222 957.806 254.476 958.67C255.171 959.049 255.856 959.47 256.635 959.892L257.995 961.072C258.5 961.451 258.932 961.978 259.49 962.357C261.924 964.243 263.736 965.907 265.169 967.551C267.15 969.437 269.214 971.87 271.701 975.284C274.503 979.498 276.926 983.996 278.549 988.379C283.11 999.462 284.048 1011.41 281.351 1022.1L280.866 1023.95V1023.97Z",
    fill: "url(#paint167_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.591 993.899C287.776 993.899 281.75 993.099 275.934 991.455L274.754 991.076L274.386 989.991C273.185 986.367 271.194 982.258 268.328 978.044C265.905 975.01 264.061 972.745 261.828 970.975L261.427 970.49C260.195 968.857 258.499 966.971 256.971 966.065C255.717 965.475 254.864 964.601 253.99 963.347C252.314 962.199 250.85 961.293 248.796 960.629L247.416 960.208L247.31 959.723C244.919 958.259 242.749 957.7 240.673 957.079L240.041 956.942L241.168 952.623L241.811 952.76C244.076 953.349 246.657 954.15 249.575 955.857C250.007 955.962 250.587 956.236 250.934 956.689C253.305 957.564 255.075 958.744 256.834 959.892L257.614 960.619C258.088 961.451 258.393 961.767 259.141 962.188C261.269 963.653 263.25 965.496 264.82 967.593C267.296 969.753 269.213 972.123 271.857 975.463C274.797 979.709 276.893 983.786 278.21 987.483C287.966 990.096 298.027 990.17 306.95 987.831C304.864 981.563 302.42 976.506 299.112 971.733L302.757 969.258C306.75 974.936 309.563 981.099 311.933 988.695L312.513 990.749L310.374 991.381C305.117 993.088 299.417 993.889 293.57 993.889L293.591 993.899Z",
    fill: "url(#paint168_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.807 911.998C218.677 899.598 219.162 885.903 224.113 873.44C225.104 869.71 227.284 865.391 230.613 860.408C236.956 850.515 245.784 843.098 256.151 838.947L257.784 838.284L258.816 839.748C260.196 841.834 260.997 844.036 261.618 846.786L257.267 847.755C256.867 846.185 256.467 844.931 256.035 843.751C247.291 847.755 239.853 854.202 234.438 862.81C231.246 867.477 229.286 871.375 228.327 874.904C223.66 886.609 223.26 899.293 227.053 910.639L222.817 911.998H222.807Z",
    fill: "url(#paint169_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.852 864.453L197.459 863.895C198.818 852.327 204.201 841.286 211.913 833.553L213.346 832.194L214.81 833.311C223.639 839.759 230.676 849.577 234.627 860.861L230.466 862.325C227.031 852.538 221.142 844.036 213.746 838.115C207.352 845.016 203.106 854.56 201.852 864.453Z",
    fill: "url(#paint170_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.529 911.545L213.104 910.776C214.811 899.703 212.23 887.367 205.793 876.4C203.496 872.428 200.799 868.73 197.976 865.706C190.822 857.795 181.899 852.464 172.575 850.515C169.826 859.607 169.826 869.604 172.754 879.392L168.509 880.687C165.074 869.257 165.306 857.731 169.036 847.249L169.678 845.574L171.522 845.89C182.352 847.596 192.898 853.623 201.252 862.714C204.297 866.022 207.141 869.963 209.617 874.145C216.581 886.06 219.383 899.293 217.539 911.555L217.529 911.545Z",
    fill: "url(#paint171_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.372 929.487C194.54 929.487 193.592 929.487 192.412 929.181C182.92 929.076 172.637 925.831 163.303 919.847C162.502 919.289 161.839 918.836 160.954 918.277C146.615 908.459 137.355 893.267 136.028 877.801L135.891 875.926L137.566 875.473C148.038 872.439 160.385 873.313 171.51 878.054C175.556 879.519 179.717 881.741 184.205 884.913C195.056 892.435 203.168 902.991 207.035 914.769L202.852 916.128C199.312 905.403 191.769 895.574 181.655 888.473C177.526 885.545 173.659 883.522 169.845 882.163C160.195 878.117 149.671 877.18 140.674 879.266C142.349 892.814 150.829 906.015 163.419 914.59C164.304 915.149 164.989 915.602 165.768 916.223C174.376 921.554 183.815 924.62 193.012 924.894C194.213 925.104 194.666 925.104 195.362 925.104V929.487H195.372Z",
    fill: "url(#paint172_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.364 928.022L193.287 926.178C195.689 920.847 199.239 916.359 203.496 913.388C206.909 911.229 210.775 909.311 215.042 909.037C216.675 908.447 218.614 908.447 219.815 908.447C221.848 908.447 223.249 908.447 225.314 909.174C226.568 909.311 227.453 909.659 228.201 910.186C228.432 910.291 228.685 910.46 229.001 910.639L227.137 914.642C226.631 914.431 226.336 914.221 225.957 913.978C225.314 913.704 225.103 913.588 224.787 913.588L224.261 913.378C222.606 912.956 221.679 912.956 219.804 912.956C218.93 912.956 217.276 912.956 216.443 913.304L215.506 913.578C212.198 913.578 208.848 915.327 205.887 917.128C201.494 920.236 198.776 924.756 197.354 928.001L197.364 928.022Z",
    fill: "url(#paint173_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.531 965.822L219.699 965.748H219.299C215.116 965.748 209.838 964.568 205.761 962.44C202.263 959.828 198.797 957.036 196.005 952.927L195.12 951.178C194.141 949.061 193.034 946.827 192.076 944.215L191.865 943.445C191.865 942.687 191.791 941.918 191.654 941.117C191.475 939.969 191.254 938.641 191.254 937.251C191.254 933.943 191.865 931.151 193.287 927.601L197.364 929.17C196.216 932.299 195.731 934.501 195.731 937.251C195.731 938.399 195.91 939.442 196.047 940.454C196.153 941.286 196.321 942.234 196.321 942.992C197.248 945.321 198.218 947.343 199.145 949.261L199.861 950.725C202.042 954.002 205.16 956.372 208.079 958.742C211.302 960.27 215.832 961.355 219.509 961.355H219.825L220.763 961.429C224.471 961.355 227.59 960.555 230.087 959.164C233.331 958.016 236.113 956.172 239.041 953.243C239.979 951.705 240.474 950.662 241.012 949.134L245.194 950.525C244.52 952.653 243.803 954.002 242.476 955.93C238.789 959.828 235.407 962.061 231.867 963.21C229.233 964.874 225.335 965.748 220.542 965.822H220.531Z",
    fill: "url(#paint174_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.533 959.627C207.848 959.627 197.545 949.524 197.545 937.198C197.545 931.246 199.863 925.662 204.129 921.479C208.375 917.234 214.201 914.863 220.333 914.863C220.764 914.758 221.555 914.832 222.271 914.832C223.735 914.832 225.305 914.937 226.991 915.601L225.421 919.741C223.872 919.225 222.197 919.151 220.733 919.288H220.469C215.349 919.288 210.703 921.206 207.227 924.651C203.898 927.959 202.033 932.489 202.033 937.198C202.033 947.059 210.324 955.097 220.533 955.097C227.043 955.097 233.322 951.305 236.104 945.658L240.054 947.533C236.588 954.707 228.75 959.627 220.533 959.627Z",
    fill: "url(#paint175_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.119 1245.66C491.951 1245.48 492.752 1245.34 493.679 1245.34L491.119 1245.66Z",
    fill: "url(#paint176_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.179 1306.52C447.715 1306.52 446.25 1306.49 444.786 1306.38L442.921 1306.2L442.795 1304.29C441.541 1288.64 447.894 1272.51 460.178 1260.11C461.063 1259.14 462.011 1258.19 463.38 1257.39L465.54 1261.29C464.708 1261.74 464.128 1262.33 463.38 1263.14C452.455 1274.11 446.661 1288.22 447.093 1302.01H449.168C458.05 1302.01 466.878 1299.4 475.085 1294.25C479.183 1292.01 482.733 1288.85 485.915 1285.71C494.417 1277.21 500.022 1266.62 501.56 1256.14L505.964 1256.73C504.278 1268.26 498.283 1279.61 489.107 1288.91C485.504 1292.26 481.743 1295.71 477.318 1297.97C468.469 1303.58 458.892 1306.51 449.168 1306.51L449.179 1306.52Z",
    fill: "url(#paint177_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.224 1331.14L480.286 1329.6C474.607 1319.68 472.427 1307.93 474.07 1295.77L478.474 1296.41C477.083 1306.89 478.716 1316.96 483.215 1325.7C491.727 1322.08 499.534 1315.49 505.349 1306.89L508.973 1309.39C502.357 1319.36 493.065 1326.85 483.004 1330.54L481.224 1331.13V1331.14Z",
    fill: "url(#paint178_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.211 1337.66L524.641 1336.51C515.728 1329.93 508.754 1320.07 505.025 1308.89C503.423 1304.04 502.391 1299.24 501.959 1294.6C501.032 1281.27 503.876 1268.31 510.092 1258.3L513.853 1260.7C508.143 1269.93 505.53 1281.89 506.341 1294.25C506.763 1298.46 507.722 1302.99 509.302 1307.38C512.473 1317.2 518.373 1325.74 525.747 1331.73C531.91 1324.93 536.04 1316.22 537.821 1306.19L536.272 1303.58L539.98 1303.27L540.107 1305.43L541.845 1304.32L542.277 1305.04L542.382 1306.19C540.381 1318.14 535.239 1328.49 527.559 1336.29L526.2 1337.65L526.211 1337.66Z",
    fill: "url(#paint179_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.995 1324.46L568.025 1324.11C557.121 1322.03 546.639 1315.96 538.516 1307.32L537.821 1306.2C534.703 1302.85 531.921 1299.24 529.709 1295.47C522.956 1284.14 520.143 1270.77 522.06 1258.65L526.506 1259.45C524.747 1270.46 527.254 1282.78 533.565 1293.2C535.724 1297.01 538.58 1300.66 541.856 1303.9L545.596 1307.66H545.269C551.622 1313.4 559.113 1317.52 567.024 1319.36C569.721 1310.13 569.606 1299.92 566.603 1290.31C565.676 1286.17 563.917 1281.88 561.293 1277.42C555.352 1266.79 546.175 1258.5 535.545 1253.97L537.284 1249.86C548.809 1254.77 558.712 1263.73 565.139 1275.16C568.025 1280.03 569.995 1284.77 570.891 1289.23C574.378 1300.17 574.252 1312.11 570.575 1322.71L569.995 1324.45V1324.46Z",
    fill: "url(#paint180_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.106 1295.89C581.858 1295.89 574.684 1294.53 567.857 1291.75L569.595 1287.64C579.035 1291.51 589.412 1292.59 598.872 1290.5C597.44 1280.81 593.141 1271.68 586.451 1264.37C583.818 1261.3 580.562 1258.31 576 1255.11C566.561 1248.34 554.856 1244.73 543.015 1244.73H542.383L542.277 1240.23H543.004C555.773 1240.23 568.415 1244.2 578.518 1251.56C583.417 1254.9 586.999 1258.11 589.802 1261.48C597.429 1269.85 602.391 1280.68 603.508 1291.96L603.74 1293.91L601.875 1294.36C597.692 1295.37 593.447 1295.89 589.085 1295.89H589.106Z",
    fill: "url(#paint181_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.254 1265.17L587.991 1260.67C598.463 1260.04 608.313 1256.62 615.899 1250.91C610.62 1242.91 602.593 1236.42 593.206 1232.66C589.255 1230.84 584.862 1229.38 579.963 1228.4C576.571 1227.92 572.999 1227.6 568.638 1227.49C567.11 1227.49 565.446 1227.74 563.992 1227.92C562.317 1228.08 561.505 1228.05 560.21 1228.3L559.114 1228.51C557.355 1228.89 555.669 1229.23 554.025 1229.86L552.856 1230.21C550.212 1231.12 547.409 1232.06 545.092 1233.56L542.795 1229.76C545.323 1228.19 548.2 1227.15 551.002 1226.21C551.634 1225.72 552.393 1225.62 552.867 1225.62C554.436 1224.99 556.227 1224.58 558.282 1224.15L559.43 1223.91C560.789 1223.7 561.727 1223.7 563.075 1223.56C565.688 1223.18 568.269 1223.01 570.755 1223.17C574.253 1223.25 577.582 1223.56 580.732 1224.08C586.01 1225.09 590.804 1226.56 594.965 1228.61C605.848 1232.99 614.982 1240.77 620.692 1250.31L621.725 1251.88L620.26 1253.14C611.748 1260.21 600.443 1264.36 588.265 1265.16L588.254 1265.17Z",
    fill: "url(#paint182_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.49 1233.5L543.109 1229.77C545.006 1228.62 547.587 1226.95 551.316 1225.94C551.748 1225.73 552.243 1225.62 553.002 1225.62C554.94 1224.68 556.816 1224.16 558.596 1223.81L559.976 1223.53L560.587 1223.71C561.441 1223.92 561.82 1223.89 562.642 1223.71C565.57 1223.02 568.752 1223.26 570.754 1223.53C573.946 1223.4 577.075 1223.64 581.025 1224.02C586.072 1224.99 590.391 1226.32 594.068 1228.06C602.918 1222.94 610.008 1215.83 614.654 1207.96C610.208 1205.83 604.582 1203.37 597.703 1202.11L598.535 1197.75C607.047 1199.42 613.811 1202.56 618.689 1205.14L620.585 1206.11L619.626 1208.06C614.643 1217.81 605.952 1226.48 595.206 1232.45L594.194 1233.08L593.13 1232.59C589.696 1230.78 585.366 1229.39 580.256 1228.38C576.664 1227.96 573.651 1227.68 570.627 1227.96C567.382 1227.61 565.318 1227.61 563.832 1227.93C562.494 1228.38 561.272 1228.52 559.808 1228.06L559.513 1228.1C557.722 1228.52 555.91 1228.9 554.308 1229.84L553.076 1230.54L552.591 1230.22C549.652 1230.99 547.713 1232.07 545.48 1233.5H545.49Z",
    fill: "url(#paint183_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.57 1213.85C489.76 1208.17 480.426 1198.07 475.147 1185.7C473.251 1182.39 471.681 1177.86 470.533 1171.94C467.952 1160.45 468.963 1148.82 473.367 1138.6L474.062 1136.93L475.948 1137.25C478.403 1137.87 480.426 1138.85 482.743 1140.39L480.32 1144.11C479.046 1143.23 477.939 1142.64 476.675 1142.23C473.283 1151.15 472.682 1161.05 474.831 1171.01C475.948 1176.5 477.318 1180.66 479.077 1183.75C484.145 1195.38 492.752 1204.55 503.498 1209.94L501.559 1213.84L501.57 1213.85Z",
    fill: "url(#paint184_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.588 1197.86C442.477 1188.74 438.252 1177.09 438.252 1166.09V1164.24L440.138 1163.93C451.01 1162.05 462.852 1164.14 473.682 1169.42L471.785 1173.36C462.367 1168.8 452.295 1167.05 442.803 1168C443.235 1177.44 446.965 1187.2 453.18 1195.1L449.588 1197.85V1197.86Z",
    fill: "url(#paint185_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.927 1230.22C430.529 1224.58 422.459 1216.29 417.676 1206.09L416.822 1204.45L418.392 1203.37C426.82 1197.42 437.503 1194.25 448.965 1194.25C449.745 1194.25 450.598 1194.28 451.441 1194.28C456.245 1194.59 461.07 1195.29 465.379 1196.47C478.79 1199.99 490.094 1207.4 497.322 1217.4L493.75 1220.02C487.081 1210.85 476.641 1204.02 464.315 1200.79C460.185 1199.64 455.708 1198.94 451.22 1198.7C450.44 1198.64 449.692 1198.64 448.87 1198.64C439.199 1198.64 429.939 1201.21 422.48 1205.92C426.978 1214.38 434.026 1221.49 443.013 1226.23L440.937 1230.23L440.927 1230.22Z",
    fill: "url(#paint186_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.432 1263.15C437.442 1263.15 425.263 1258.93 415.929 1251.05L414.496 1249.87L415.328 1248.33C420.712 1238.71 430.067 1230.68 441.161 1226.21C445.427 1224.16 449.979 1222.8 454.972 1222.1C468.173 1219.59 481.321 1221.33 492.33 1226.94L490.255 1230.91C480.278 1225.79 468.025 1224.32 455.783 1226.45C451.032 1227.15 446.881 1228.37 442.909 1230.21C433.333 1234.15 425.073 1240.84 420.164 1248.74C431.173 1257.17 446.428 1260.59 461.283 1257.7L462.347 1257.46C462.958 1257.38 463.516 1257.28 464.127 1257.07C474.051 1254.88 482.901 1250.31 489.538 1244C490.392 1243.45 490.655 1243.13 491.108 1242.75L494.416 1245.71C493.742 1246.37 493.089 1247 492.204 1247.49C485.356 1254.08 475.748 1259.06 465.012 1261.49C464.212 1261.66 463.78 1261.73 463.2 1261.81L462.052 1262.05C458.164 1262.75 454.235 1263.14 450.421 1263.14L450.432 1263.15Z",
    fill: "url(#paint187_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.665 1244.83C488.537 1239.11 487.915 1233.61 488.8 1228.53C489.632 1225.01 490.991 1220.66 493.973 1217.44C494.615 1215.98 495.89 1214.62 496.796 1213.76C498.261 1212.26 499.304 1211.11 501.274 1210.07C502.106 1209.41 502.959 1209.2 503.749 1208.89C504.076 1208.78 504.382 1208.62 504.729 1208.54L506.457 1212.59C505.983 1212.9 505.551 1212.94 505.045 1213.15C504.434 1213.28 504.297 1213.39 504.118 1213.49L503.581 1213.87C502.116 1214.64 501.368 1215.34 500.115 1216.7C499.314 1217.47 498.271 1218.69 497.934 1219.38L497.376 1220.26C494.974 1222.73 493.804 1226.6 493.193 1229.42C492.466 1233.64 492.972 1238.3 494.826 1243.18L490.665 1244.86V1244.83Z",
    fill: "url(#paint188_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.36 1262.27C515.422 1262.27 513.494 1262.13 511.418 1261.76C508.142 1260.67 505.339 1259.56 502.505 1258.31L501.894 1257.99C501.357 1257.4 500.746 1257.09 500.103 1256.57C499.176 1255.88 498.07 1255.18 497.006 1254.1C494.657 1251.8 493.066 1249.36 491.602 1245.73L495.594 1244.02C496.901 1247.12 498.176 1249.04 500.103 1250.92C501.041 1251.8 501.894 1252.49 502.737 1253.01C503.369 1253.43 504.075 1253.92 504.602 1254.4C507.215 1255.55 509.796 1256.49 512.577 1257.39C516.444 1258.19 520.152 1257.78 524.039 1257.36C527.432 1256.17 531.477 1253.66 534.258 1250.91L534.638 1250.43C537.514 1247.57 539.199 1244.86 539.916 1242L540.105 1241.52C541.844 1238.28 542.076 1234.24 542.076 1231.62C541.675 1229.88 541.275 1228.77 540.611 1227.27L544.562 1225.28C545.489 1227.17 545.942 1228.63 546.458 1231.14C546.458 1234.73 546.226 1239.33 544.14 1243.4C543.234 1246.89 541.127 1250.33 537.819 1253.43L537.503 1253.99C534.195 1257.3 529.423 1260.23 525.03 1261.69C522.449 1262.01 519.931 1262.28 517.35 1262.28L517.36 1262.27Z",
    fill: "url(#paint189_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.961 1255.93C511.103 1255.93 505.53 1253.66 501.39 1249.52C497.228 1245.41 494.963 1239.9 494.963 1234.03C494.932 1227.93 497.449 1221.87 501.79 1217.52L502.222 1216.96C503.56 1215.75 505.024 1214.39 506.857 1213.48L508.754 1217.53C507.605 1218.09 506.436 1219.19 505.34 1220.25L504.887 1220.67C501.39 1224.19 499.42 1229.1 499.42 1233.94C499.42 1238.79 501.263 1243.17 504.508 1246.42C511.335 1253.18 523.387 1252.97 530.319 1245.99C534.934 1241.4 536.672 1234.26 534.586 1228.34L538.747 1226.87C541.465 1234.5 539.358 1243.28 533.469 1249.06C529.066 1253.44 523.071 1255.96 516.961 1255.96V1255.93Z",
    fill: "url(#paint190_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M927.084 1260.11C927.674 1259.34 927.99 1258.75 928.685 1258.03L927.084 1260.11Z",
    fill: "url(#paint191_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M935.891 1337.07L934.469 1335.79C922.554 1325.58 915.59 1309.63 915.453 1292.14C915.453 1290.57 915.453 1289.35 915.874 1287.92L920.12 1289.18C919.909 1289.98 919.909 1290.64 919.909 1291.69C920.046 1307.64 925.83 1321.71 935.902 1331.15C942.971 1324.67 947.849 1315.96 950.051 1305.76C951.473 1301.3 951.684 1296.53 951.831 1292.14C951.831 1280.04 948.281 1268.55 941.939 1260.05L945.489 1257.4C952.453 1266.74 956.287 1279 956.361 1292.14C956.151 1297.02 955.877 1302.03 954.338 1306.91C951.831 1318.45 945.973 1328.64 937.271 1335.79L935.912 1337.07H935.891Z",
    fill: "url(#paint192_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M980.593 1327.66L978.781 1327.18C967.698 1324.11 957.953 1317.39 950.525 1307.64L953.97 1304.92C960.513 1313.35 968.814 1319.31 978.075 1322.3C981.667 1313.66 982.5 1303.38 980.477 1293.32L984.828 1292.38C987.156 1304.22 985.945 1316.03 981.415 1325.89L980.572 1327.67L980.593 1327.66Z",
    fill: "url(#paint193_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1007.24 1301.11C998.524 1301.11 989.885 1298.99 981.668 1294.92C977.137 1292.59 972.997 1289.97 969.373 1287.08C959.27 1278.26 952.232 1267.19 949.588 1255.62L953.981 1254.61C956.415 1265.27 962.894 1275.51 972.239 1283.67C975.547 1286.31 979.339 1288.76 983.669 1290.92C993.003 1295.62 1003.11 1297.29 1012.51 1296.42C1012.12 1287.32 1008.89 1278.26 1003.18 1269.94L998.829 1269.31L1002.59 1266.11L1004.01 1267.63L1004.33 1265.68L1005.2 1265.79L1006.25 1266.62C1013.21 1276.51 1017.01 1287.45 1017.12 1298.32V1300.24L1015.24 1300.45C1012.53 1300.97 1009.88 1301.11 1007.27 1301.11H1007.24Z",
    fill: "url(#paint194_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1006.51 1270.14H1004.35L1002.26 1269.84C997.913 1269.73 993.625 1269.04 989.653 1267.95C976.832 1264.75 965.412 1257.36 958.227 1247.5L961.851 1244.92C968.404 1253.83 978.991 1260.67 990.833 1263.6C995.079 1264.85 999.683 1265.52 1004.21 1265.52H1010.97L1010.75 1265.55C1018.84 1264.96 1026.43 1262.56 1032.84 1258.55C1028.38 1250.23 1021.06 1243.04 1012.01 1238.27C1008.46 1235.94 1004.03 1234.13 999.156 1232.94C987.693 1229.67 975.294 1230.22 964.453 1234.54L962.82 1230.54C974.388 1225.8 987.693 1225.18 1000.37 1228.62C1005.59 1229.88 1010.37 1231.96 1014.31 1234.47C1024.55 1239.83 1032.97 1248.41 1037.75 1258.41L1038.62 1260.11L1036.95 1261.23C1028.38 1267.01 1017.58 1270.14 1006.5 1270.14H1006.51Z",
    fill: "url(#paint195_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1013.97 1238.38L1012.19 1234.24C1021.49 1230.44 1029.54 1223.89 1035.07 1215.67C1027.26 1209.75 1017.69 1206.4 1007.82 1205.92C1003.51 1205.5 999.533 1205.78 993.929 1206.72C978.874 1209.23 968.634 1217.06 962.787 1223.2L959.584 1220.1C965.926 1213.48 976.935 1205.16 993.128 1202.37C997.584 1201.64 1002.75 1200.94 1008.14 1201.46C1019.53 1202.05 1030.68 1206.3 1039.42 1213.44L1040.99 1214.62L1039.95 1216.3C1033.85 1226.16 1024.69 1233.92 1013.96 1238.38H1013.97Z",
    fill: "url(#paint196_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M956.761 1213.43L952.441 1212.25C953.074 1209.74 954.18 1207.13 955.781 1203.96C955.855 1203.26 956.129 1202.74 956.476 1202.36C957.172 1200.93 957.941 1199.67 958.741 1198.39C959.194 1197.76 959.584 1197.17 959.89 1196.47L960.585 1195.7C961.217 1195 961.839 1194.34 962.397 1193.61C963.862 1191.8 965.537 1189.58 967.486 1187.94C969.719 1185.7 972.363 1183.58 975.355 1181.59C979.601 1178.5 984.205 1175.99 988.451 1174.52C999.386 1170.13 1011.09 1169.19 1022.1 1171.63L1023.94 1172.22L1023.81 1174.13C1022.69 1184.98 1017.68 1196.02 1009.59 1205.14L1006.29 1202.15C1013.19 1194.28 1017.72 1184.98 1019.03 1175.6C1009.7 1173.58 999.449 1174.72 990.084 1178.73C986.08 1180.09 981.898 1182.35 977.926 1185.13C975.071 1187.16 972.669 1189.07 970.404 1191.13C968.803 1192.67 967.233 1194.57 965.905 1196.22C965.315 1197.15 964.62 1197.92 963.851 1198.69C963.398 1199.42 962.977 1200.08 962.492 1200.78C961.765 1201.89 961.028 1203.07 960.501 1204.43L960.195 1204.81H960.258L959.879 1205.48C958.341 1208.58 957.298 1211.09 956.74 1213.42L956.761 1213.43Z",
    fill: "url(#paint197_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M956.972 1213.05L952.621 1212.01C953.243 1209.64 953.833 1206.96 955.855 1203.58C955.919 1203.02 956.277 1202.57 956.688 1202.12C957.278 1200.34 958.226 1198.94 959.058 1197.52L960.101 1195.71L960.659 1195.5C961.534 1195.02 961.776 1194.66 962.187 1193.93C963.725 1191.67 965.78 1189.64 967.971 1188.11C969.572 1185.92 972.048 1183.83 975.356 1181.26C980.128 1178.19 983.963 1176.09 987.482 1174.95C990.021 1165.26 990.2 1154.95 987.83 1146.17C983.057 1147.84 977.453 1150.01 971.732 1154.01L969.225 1150.36C976.399 1145.4 983.373 1142.83 988.63 1141.3L990.832 1140.6L991.422 1142.69C994.804 1153.24 994.804 1165.51 991.485 1177.27L991.106 1178.5L989.926 1178.77C985.428 1180.1 980.971 1182.82 978.011 1184.83C975.019 1187.17 972.754 1189.08 970.91 1191.23C968.824 1192.87 967.075 1194.58 966.032 1196.14C965.474 1197.4 964.642 1198.2 963.314 1198.97L962.788 1199.84C961.882 1201.3 961.155 1202.56 960.733 1204.19L960.386 1205.66L959.69 1205.76C958.015 1208.51 957.499 1210.67 956.972 1213.04V1213.05Z",
    fill: "url(#paint198_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M894.689 1233.08C887.441 1233.08 880.267 1231.75 873.44 1228.97C868.562 1227.75 863.684 1224.68 860.408 1222.56C850.441 1216.19 842.919 1207.3 838.811 1196.92L838.115 1195.18L839.685 1194.28C842.013 1192.71 844.247 1192.12 846.723 1191.45L847.734 1195.81C846.133 1196.23 844.879 1196.61 843.699 1197.06C847.671 1205.84 854.255 1213.37 862.862 1218.87C865.854 1220.82 870.385 1223.58 874.946 1224.79C886.725 1229.56 899.261 1229.88 910.65 1226.15L912.041 1230.29C906.468 1232.13 900.61 1233.07 894.689 1233.07V1233.08Z",
    fill: "url(#paint199_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M863.926 1255.62C852.4 1254.27 841.317 1248.98 833.658 1241.2L832.268 1239.92L833.448 1238.38C839.684 1229.47 849.545 1222.46 860.828 1218.52L862.293 1222.81C852.474 1226.16 844.035 1232.04 838.115 1239.42C845.078 1245.73 854.56 1250.01 864.453 1251.23L863.926 1255.61V1255.62Z",
    fill: "url(#paint200_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M864.588 1287.08C858.667 1287.08 852.809 1286.07 847.205 1284.15L845.498 1283.52L845.814 1281.68C847.595 1270.77 853.579 1260.22 862.713 1251.86C866.158 1248.76 870.066 1245.84 874.069 1243.47C886.164 1236.5 899.501 1233.82 911.48 1235.7L910.858 1240.05C899.396 1238.45 887.407 1240.89 876.303 1247.2C872.616 1249.52 868.844 1252.21 865.715 1255.11C857.908 1262.28 852.546 1271.31 850.534 1280.57C859.794 1283.36 869.761 1283.26 879.348 1280.43L880.601 1284.72C875.313 1286.25 869.908 1287.09 864.609 1287.09L864.588 1287.08Z",
    fill: "url(#paint201_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M875.945 1317.21L875.46 1315.51C872.468 1305.16 873.3 1292.69 877.967 1281.68C879.506 1277.54 881.802 1273.28 884.931 1268.86C892.527 1258.03 903.115 1249.87 914.746 1246.04L916.136 1250.32C905.475 1253.84 895.582 1261.37 888.545 1271.47C885.616 1275.5 883.498 1279.44 882.097 1283.24C878.094 1292.89 877.114 1303.37 879.242 1312.46C892.938 1310.71 905.749 1302.43 914.598 1289.64C915.125 1288.84 915.578 1288.15 916.063 1287.38C921.499 1278.74 924.565 1269.19 924.87 1260.03L924.975 1259.44C925.007 1259.13 925.007 1258.64 925.007 1258.08L927.272 1257.69H929.506C929.506 1258.63 929.506 1259.53 929.263 1260.38C928.947 1270.16 925.608 1280.66 919.824 1289.67C919.265 1290.55 918.854 1291.35 918.222 1292.12C908.256 1306.65 893.559 1315.74 877.746 1317.1L875.934 1317.2L875.945 1317.21Z",
    fill: "url(#paint202_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M926.147 1259.76C920.648 1257.29 916.392 1253.84 913.431 1249.52C911.619 1246.7 909.322 1242.62 909.112 1238.17C908.49 1236.49 908.49 1234.54 908.49 1233.29C908.49 1231.41 908.49 1229.88 909.112 1227.79C909.249 1226.58 909.744 1225.74 910.092 1225.01C910.334 1224.69 910.408 1224.42 910.65 1224.1L914.622 1225.95C914.348 1226.46 914.2 1226.85 914.032 1227.17C913.684 1227.76 913.579 1227.94 913.579 1228.21L913.442 1228.91C912.957 1230.44 912.957 1231.45 912.957 1233.29C912.957 1234.16 912.957 1235.87 913.379 1236.64L913.589 1237.65C913.589 1241.17 915.612 1244.72 917.15 1247.12C919.552 1250.64 923.282 1253.64 928.012 1255.73L926.168 1259.76H926.147Z",
    fill: "url(#paint203_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M936.766 1261.82C933.7 1261.82 930.919 1261.22 927.432 1259.76L929.244 1255.73C932.099 1256.94 934.258 1257.39 936.84 1257.39C938.093 1257.36 939.421 1257.18 940.601 1257.08C941.401 1256.94 942.202 1256.76 942.971 1256.76C945.9 1255.61 948.333 1254.46 950.63 1253.32C953.833 1251.11 956.34 1248.12 958.742 1245.13C960.207 1241.99 961.355 1237.22 961.355 1233.29V1232.67C961.418 1228.77 960.66 1225.63 959.121 1223.12C957.794 1219.08 955.223 1216.19 953.232 1214.1C951.768 1213.17 950.757 1212.64 949.092 1212.11L950.63 1207.93C952.505 1208.52 953.98 1209.22 956.035 1210.68C958.816 1213.43 961.776 1216.84 963.104 1221.24C964.916 1224.09 965.822 1227.96 965.79 1232.7V1233.29C965.79 1237.89 964.568 1243.36 962.482 1247.44C959.596 1251.24 956.909 1254.4 952.937 1257.09C950.04 1258.55 947.438 1259.77 944.225 1261.03L943.456 1261.24C942.76 1261.24 941.991 1261.39 941.296 1261.48C939.937 1261.69 938.441 1261.83 936.766 1261.83V1261.82Z",
    fill: "url(#paint204_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M937.188 1255.55C924.788 1255.55 914.748 1245.24 914.748 1232.67C914.748 1230.68 914.748 1228.41 915.517 1226.26L919.7 1227.68C919.215 1229.22 919.215 1230.85 919.215 1232.67C919.215 1242.83 927.295 1251.12 937.199 1251.12C941.939 1251.12 946.29 1249.28 949.735 1245.84C953.149 1242.39 955.172 1237.58 955.098 1232.67C955.098 1226.05 951.2 1219.77 945.658 1217.06L947.502 1213.12C954.718 1216.51 959.596 1224.34 959.596 1232.67C959.596 1238.69 957.12 1244.72 952.769 1249.04C948.587 1253.25 943.088 1255.55 937.199 1255.55H937.188Z",
    fill: "url(#paint205_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1245.62 962.061C1245.41 961.123 1245.25 960.428 1245.35 959.417L1245.62 962.061Z",
    fill: "url(#paint206_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1300.6 1010.55C1286.1 1010.55 1271.51 1004.24 1260.05 992.929L1259.56 992.444C1258.84 991.717 1258.02 990.98 1257.43 989.863L1261.23 987.493C1261.62 988.262 1262.07 988.715 1262.69 989.305L1263.21 989.863C1273.84 1000.21 1287.24 1006.03 1300.59 1006.03H1302.05C1302.5 996.553 1299.82 986.839 1294.21 977.99C1292.16 974.018 1289.02 970.636 1285.78 967.118C1277.25 958.763 1266.73 953.18 1256.11 951.547L1256.7 947.164C1268.26 948.902 1279.69 954.928 1288.96 964.02C1292.43 967.823 1295.78 971.542 1298.02 975.799C1304.5 985.902 1307.32 997.227 1306.38 1008.4L1306.17 1010.32L1304.3 1010.39C1303.07 1010.49 1301.82 1010.56 1300.61 1010.56L1300.6 1010.55Z",
    fill: "url(#paint207_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1303.66 979.518C1301.08 979.518 1298.4 979.339 1295.79 979.065L1296.42 974.608C1306.91 976.241 1316.98 974.366 1325.69 969.868C1322.07 961.439 1315.51 953.601 1306.92 947.775L1309.39 944.12C1319.39 950.809 1326.85 960.007 1330.58 970.11L1331.21 971.89L1329.67 972.796C1321.87 977.253 1313.06 979.518 1303.68 979.518H1303.66Z",
    fill: "url(#paint208_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1289.45 951.431C1277.88 951.431 1267.26 948.502 1258.31 943.003L1260.68 939.273C1270.04 945.015 1281.87 947.67 1294.22 946.795C1298.57 946.311 1302.97 945.331 1307.42 943.803C1317.21 940.706 1325.74 934.785 1331.81 927.326C1324.88 921.195 1316.14 916.949 1306.24 915.274L1303.59 916.812L1303.27 913.125H1305.43L1304.39 911.239L1305.05 910.86L1306.17 910.786C1318.01 912.672 1328.39 917.75 1336.27 925.525L1337.66 926.81L1336.51 928.38C1329.93 937.366 1320.1 944.435 1308.89 948.06C1304.12 949.661 1299.34 950.736 1294.64 951.189C1292.9 951.399 1291.2 951.431 1289.45 951.431Z",
    fill: "url(#paint209_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1266.11 931.689C1263.6 931.689 1261.15 931.447 1258.72 931.099L1259.35 926.706C1270.54 928.381 1282.83 925.831 1293.11 919.531C1296.79 917.509 1300.6 914.653 1303.87 911.314L1307.71 907.69V907.827C1313.42 901.421 1317.53 893.889 1319.34 886.198C1310.11 883.375 1299.87 883.448 1290.36 886.546C1286.19 887.388 1281.75 889.232 1277.4 891.803C1266.81 897.829 1258.52 906.994 1254.06 917.582L1249.88 915.907C1254.79 904.34 1263.82 894.521 1275.18 888C1279.92 885.144 1284.79 883.09 1289.25 882.247C1299.94 878.834 1311.96 878.834 1322.69 882.49L1324.43 883.08L1324.05 885.06C1322.06 895.722 1316.07 906.31 1307.33 914.569L1306.39 915.265C1303.78 917.667 1299.87 920.838 1295.38 923.313C1286.53 928.75 1276.16 931.678 1266.12 931.678L1266.11 931.689Z",
    fill: "url(#paint210_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1240.25 910.713C1240.11 897.712 1244.09 884.902 1251.55 874.556C1254.96 869.605 1258.02 866.096 1261.44 863.231C1269.8 855.677 1280.66 850.757 1291.96 849.577L1293.91 849.335L1294.36 851.179C1297.05 862.325 1296.17 874.345 1291.75 885.249L1287.64 883.68C1291.43 874.24 1292.44 863.852 1290.49 854.213C1280.81 855.677 1271.69 859.954 1264.4 866.613C1261.23 869.267 1258.3 872.533 1255.1 877.169C1248.27 886.819 1244.57 898.597 1244.71 910.723H1240.25V910.713Z",
    fill: "url(#paint211_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1229.84 910.292C1228.17 907.784 1227.16 904.75 1226.22 902.211C1225.69 901.484 1225.56 900.747 1225.56 900.294C1224.97 898.83 1224.65 896.88 1224.17 895.037L1223.95 893.783C1223.82 892.877 1223.74 892.319 1223.74 891.729C1223.74 891.202 1223.64 890.644 1223.6 890.096L1223.32 888.284C1223.11 886.366 1222.97 884.312 1223.11 882.426C1223.32 878.802 1223.6 875.599 1224.15 872.291C1225.09 867.098 1226.59 862.325 1228.61 858.143C1232.93 847.418 1240.66 838.115 1250.21 832.332L1251.84 831.289L1253.06 832.827C1260.13 841.286 1264.39 852.643 1265.12 864.811L1260.66 865.128C1260.03 854.645 1256.55 844.784 1250.9 837.188C1242.93 842.582 1236.41 850.526 1232.65 859.902C1230.76 863.874 1229.34 868.256 1228.54 873.145C1227.98 876.242 1227.77 879.171 1227.53 882.795C1227.42 884.323 1227.56 886.071 1227.77 887.704L1227.98 889.548C1228.04 890.18 1228.04 890.77 1228.16 891.36C1228.16 891.813 1228.19 892.34 1228.26 892.993L1228.61 894.11C1228.88 895.922 1229.31 897.629 1229.83 899.093L1230.21 900.315C1231.04 902.822 1232.09 905.72 1233.55 908.048L1229.83 910.313L1229.84 910.292Z",
    fill: "url(#paint212_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1229.66 909.944C1228.41 907.784 1226.94 905.445 1225.98 901.758C1225.69 901.337 1225.55 900.82 1225.55 900.188C1224.75 898.587 1224.34 897.017 1224.03 895.627C1223.89 895.037 1223.75 894.51 1223.64 893.888L1223.39 893.256L1223.64 892.561C1224.03 891.581 1223.95 891.276 1223.74 890.57C1223.05 887.23 1223.32 883.985 1223.59 882.31C1223.32 879.624 1223.49 876.495 1224.02 872.102C1224.95 867.013 1226.34 862.694 1228.05 859.112C1222.96 850.399 1215.93 843.193 1208.02 838.526C1205.76 842.982 1203.36 848.629 1202.1 855.393L1197.75 854.624C1199.22 846.196 1202.52 839.369 1205.14 834.417L1206.15 832.542L1208.14 833.448C1217.82 838.642 1226.53 847.344 1232.52 857.974L1233.18 858.943L1232.67 860.123C1230.78 863.536 1229.36 867.793 1228.41 872.839C1227.89 876.737 1227.78 879.634 1227.99 882.489C1227.78 884.301 1227.43 886.977 1227.88 889.284C1228.4 890.464 1228.47 891.729 1228.05 893.33C1228.16 893.783 1228.26 894.204 1228.4 894.615C1228.67 896.08 1228.99 897.439 1229.73 898.692L1230.36 899.767L1230.15 900.22L1230.22 900.294C1230.92 903.496 1232.17 905.551 1233.56 907.679L1229.66 909.944Z",
    fill: "url(#paint213_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1159.44 984.006C1152.19 984.006 1145.09 982.573 1138.61 979.718L1136.94 979.054L1137.25 977.242C1137.85 974.84 1138.82 972.786 1140.36 970.31L1144.12 972.743C1143.29 973.997 1142.65 975.282 1142.17 976.399C1151.16 979.844 1161.12 980.508 1171.09 978.274C1176.31 977.126 1180.66 975.767 1183.77 973.987C1195.4 969.003 1204.6 960.396 1209.96 949.598L1213.9 951.515C1208.09 963.325 1198.09 972.733 1185.72 977.958C1182.38 979.95 1177.71 981.477 1171.99 982.552C1167.81 983.458 1163.63 983.984 1159.45 983.984L1159.44 984.006Z",
    fill: "url(#paint214_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1166.2 1014.83H1164.32L1164 1012.96C1162.16 1002.26 1164.1 990.317 1169.4 979.518L1173.38 981.509C1168.78 990.77 1166.93 1001.01 1168.09 1010.32C1177.56 1009.87 1187.25 1006.25 1195.15 1000.08L1197.87 1003.53C1188.7 1010.7 1177.21 1014.85 1166.2 1014.85V1014.83Z",
    fill: "url(#paint215_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1204.44 1036.33L1203.37 1034.8C1197.03 1025.81 1193.75 1014 1194.31 1001.77C1194.55 996.964 1195.21 992.117 1196.39 987.693C1200.05 974.355 1207.43 962.998 1217.36 955.676L1219.97 959.269C1210.95 966.032 1204.08 976.473 1200.67 988.841C1199.63 992.918 1198.92 997.48 1198.72 1001.94C1198.3 1012.42 1200.78 1022.6 1205.9 1030.68C1214.4 1026.11 1221.44 1019.11 1226.21 1010.19L1230.21 1012.24C1224.56 1022.72 1216.24 1030.67 1206.03 1035.47L1204.43 1036.31L1204.44 1036.33Z",
    fill: "url(#paint216_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1249.8 1038.59L1248.27 1037.65C1238.79 1032.39 1230.71 1023.12 1226.22 1012.11C1224.16 1007.69 1222.77 1002.99 1222.17 998.008C1219.7 984.976 1221.45 971.743 1226.95 960.84L1230.92 962.82C1225.8 972.892 1224.16 985.155 1226.53 997.27C1227.17 1001.94 1228.41 1006.23 1230.22 1010.3C1234.19 1019.85 1240.96 1028 1248.83 1032.88C1257.36 1021.9 1260.5 1007.04 1257.74 991.771C1257.47 990.759 1257.35 989.927 1257.11 989.158C1254.95 979.087 1250.28 970.311 1244.01 963.663C1243.45 962.82 1243.11 962.441 1242.83 962.093L1244.16 960.281L1245.83 958.785C1246.6 959.628 1247.09 960.218 1247.51 960.84C1254.06 967.877 1259.04 977.38 1261.45 988.147C1261.72 988.947 1261.83 989.927 1262.08 990.97C1265.28 1008.28 1261.31 1025.1 1251 1037.16L1249.82 1038.58L1249.8 1038.59Z",
    fill: "url(#paint217_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1233.29 964.674C1231.62 964.674 1230.09 964.569 1228.48 964.253C1225.28 963.515 1220.61 962.304 1217.48 959.164C1215.94 958.501 1214.68 957.321 1213.58 956.172C1212.11 954.782 1211.04 953.697 1210.09 951.821C1209.39 950.989 1209.08 950.115 1208.84 949.346C1208.76 949.072 1208.63 948.713 1208.56 948.366L1212.61 946.627C1212.88 947.154 1212.96 947.67 1213.12 948.092C1213.3 948.724 1213.33 948.819 1213.5 949.072L1213.89 949.63C1214.69 950.989 1215.32 951.716 1216.47 952.864C1217.2 953.56 1218.46 954.919 1219.47 955.235L1220.27 955.793C1222.71 958.163 1226.67 959.28 1229.36 959.902C1233.65 960.839 1238.18 960.218 1243.25 958.364L1244.72 962.546C1240.68 963.937 1236.91 964.674 1233.29 964.674Z",
    fill: "url(#paint218_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1245.76 961.609L1244.02 957.5C1247.09 956.172 1249.07 954.919 1250.92 953.044C1251.86 952.074 1252.45 951.2 1253.08 950.294C1253.54 949.662 1254.06 949.145 1254.41 948.587C1255.59 946.006 1256.5 943.467 1257.45 940.717C1258.17 936.609 1257.82 932.711 1257.37 929.15C1256.22 925.842 1253.64 921.628 1250.92 918.91L1250.4 918.383C1247.68 915.601 1244.93 913.958 1242.11 913.294L1241.59 913.02C1238.39 911.314 1234.83 911.103 1231.62 911.103C1229.95 911.419 1228.73 911.872 1227.23 912.536L1225.36 908.459C1227.17 907.795 1228.7 907.036 1231.2 906.678H1231.83C1235.46 906.678 1239.64 906.994 1243.4 909.006C1246.95 909.944 1250.3 911.935 1253.54 915.275L1254.06 915.802C1257.27 918.973 1260.2 923.671 1261.62 928.17C1262.21 932.31 1262.7 936.746 1261.72 941.76C1260.61 945.1 1259.56 947.892 1258.31 950.61L1258.04 951.2C1257.58 951.758 1257.13 952.317 1256.71 952.949C1255.94 953.918 1255.24 954.929 1254.06 956.183C1251.77 958.448 1249.4 960.018 1245.77 961.619L1245.76 961.609Z",
    fill: "url(#paint219_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1233.92 958.121C1228.06 958.121 1222.08 955.856 1217.51 951.295C1215.94 949.725 1214.48 948.26 1213.5 946.248L1217.51 944.331C1218.14 945.658 1219.29 946.838 1220.4 947.955C1228 955.414 1239.42 955.582 1246.46 948.587C1249.66 945.353 1251.55 940.823 1251.55 936.113C1251.55 931.162 1249.52 926.358 1245.97 922.776C1241.38 918.214 1234.24 916.539 1228.27 918.636L1226.81 914.348C1234.33 911.872 1243.26 913.895 1249.07 919.752C1253.42 923.966 1255.93 929.992 1255.93 936.124C1255.93 942.255 1253.7 947.555 1249.52 951.727C1245.24 955.972 1239.63 958.132 1233.92 958.132V958.121Z",
    fill: "url(#paint220_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1260.16 526.023C1259.28 525.464 1258.72 525.085 1258.03 524.316L1260.16 526.023Z",
    fill: "url(#paint221_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1292.16 537.726C1290.29 537.547 1289.65 537.726 1288.12 537.305L1289.02 532.986C1289.96 533.26 1290.97 533.059 1292.37 533.26C1307.52 533.049 1321.64 527.233 1331.18 517.267C1324.63 510.124 1315.92 505.247 1305.75 503.024C1301.25 501.696 1296.56 501.422 1292.16 501.243C1280.04 501.275 1268.68 504.899 1260.04 511.241L1257.43 507.617C1266.79 500.685 1279.1 496.818 1292.16 496.818C1297.01 497.029 1302.05 497.303 1306.9 498.662C1318.44 501.275 1328.54 507.196 1335.85 515.866L1337.03 517.257L1335.85 518.721C1325.51 530.563 1309.59 537.526 1292.17 537.705L1292.16 537.726Z",
    fill: "url(#paint222_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1307.63 502.581L1304.91 499.136C1313.41 492.446 1319.36 484.155 1322.32 474.958C1313.82 471.513 1303.44 470.775 1293.37 472.619L1292.43 468.268C1304.38 466.003 1316.34 467.225 1325.87 471.713L1327.68 472.44L1327.13 474.189C1324.2 485.093 1317.44 494.88 1307.61 502.581H1307.63Z",
    fill: "url(#paint223_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1255.65 503.656L1254.64 499.305C1265.41 496.766 1275.44 490.424 1283.66 480.879C1286.41 477.466 1288.82 473.6 1290.9 469.522C1295.57 460.114 1297.46 450.222 1296.48 440.572C1287.39 441.056 1278.33 444.301 1269.93 450.011L1269.44 453.393L1266.3 450.643L1267.7 449.105L1265.67 448.758L1265.78 447.883L1266.58 446.977C1276.55 439.908 1287.48 436.073 1298.28 436.073H1300.23L1300.44 437.991C1302.25 449.105 1300.33 460.704 1294.94 471.429C1292.75 475.928 1290.03 480.005 1287.07 483.724C1278.16 494.038 1267.32 500.865 1255.65 503.646V503.656Z",
    fill: "url(#paint224_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1247.5 494.88L1244.92 491.256C1253.83 484.745 1260.67 474.189 1263.59 462.379C1264.84 458.091 1265.48 453.466 1265.48 448.936V443.574L1265.65 443.679C1265.13 435.177 1262.69 426.992 1258.59 420.239C1250.08 424.769 1242.94 432.154 1238.27 441.067C1235.98 444.512 1234.2 448.799 1232.94 453.951C1229.59 465.624 1230.23 477.95 1234.54 488.717L1230.57 490.35C1225.8 478.677 1225.11 465.413 1228.62 452.803C1230.01 447.303 1232.04 442.531 1234.51 438.833C1239.84 428.698 1248.27 420.228 1258.3 415.35L1260.04 414.413L1261.16 416.046C1267.32 425.169 1270.52 436.81 1270.14 448.789L1269.8 450.601C1269.72 454.92 1269.1 459.345 1267.98 463.422C1264.78 476.244 1257.35 487.706 1247.5 494.88Z",
    fill: "url(#paint225_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1220.09 493.626C1210.79 484.608 1204.52 472.651 1202.36 459.945C1201.6 455.626 1200.89 450.369 1201.42 444.964C1202.05 433.607 1206.19 422.461 1213.34 413.717L1214.59 412.179L1216.26 413.148C1226.13 419.216 1233.92 428.445 1238.39 439.201L1234.25 440.908C1230.49 431.606 1223.9 423.525 1215.61 418.026C1209.83 425.864 1206.38 435.472 1205.93 445.228C1205.37 450.284 1206.07 455.162 1206.69 459.229C1208.71 470.965 1214.6 482.016 1223.2 490.339L1220.1 493.616L1220.09 493.626Z",
    fill: "url(#paint226_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1212.28 500.696C1209.8 500.032 1207.02 498.915 1203.88 497.388C1203.11 497.209 1202.56 496.756 1202.21 496.45C1200.96 495.923 1199.43 494.986 1197.99 494.048L1195.2 492.173C1194.75 491.72 1194.3 491.267 1193.6 490.814L1192.49 489.876C1190.92 488.654 1189.25 487.263 1187.92 485.736C1185.63 483.228 1183.54 480.584 1181.58 477.824C1178.24 473.199 1176.01 468.911 1174.54 464.623C1170.06 453.856 1168.97 441.836 1171.69 431.111L1172.11 429.225L1174.06 429.362C1184.99 430.479 1196.08 435.494 1205.14 443.574L1202.21 446.882C1194.34 439.918 1185.01 435.42 1175.57 434.029C1173.57 443.395 1174.76 453.603 1178.74 463.085C1179.99 467.057 1182.22 470.997 1185.14 475.243C1186.99 477.887 1189.04 480.331 1191.2 482.733C1192.45 484.061 1193.99 485.314 1195.28 486.421L1196.29 487.263C1196.92 487.716 1197.54 488.233 1198.24 488.759L1199.01 489.592L1200.33 490.361C1201.72 491.235 1202.98 492.036 1204.44 492.689L1205.56 493.279C1208.55 494.743 1211.03 495.755 1213.43 496.376L1212.28 500.696Z",
    fill: "url(#paint227_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1212.01 500.589C1209.61 499.957 1206.92 499.23 1203.58 497.313C1203.06 497.208 1202.54 496.892 1202.12 496.544C1200.48 495.912 1199.23 495.153 1198.01 494.31C1197.38 494.036 1196.92 493.72 1196.41 493.373L1195.82 493.088L1195.47 492.467C1194.98 491.561 1194.7 491.318 1193.93 490.929C1191.63 489.464 1189.55 487.336 1188.11 485.187C1185.92 483.438 1183.76 480.868 1181.29 477.802C1178.75 473.904 1176.3 469.858 1175.02 465.613C1165.16 463.137 1155.13 463 1146.21 465.297C1147.74 470.037 1150.01 475.747 1153.94 481.352L1150.31 483.828C1145.44 476.864 1142.86 469.785 1141.33 464.454L1140.63 462.368L1142.72 461.641C1153.17 458.438 1165.39 458.333 1177.35 461.641L1178.5 461.957L1178.88 463.179C1179.99 467.319 1182.44 471.439 1184.8 475.126C1187.17 478.055 1189.04 480.32 1191.35 482.269C1192.88 484.355 1194.55 486.072 1196.15 487.178C1197.38 487.768 1198.31 488.537 1199.01 489.865C1199.46 490.107 1199.84 490.349 1200.26 490.56C1201.59 491.392 1202.74 492.161 1204.1 492.477L1205.46 492.793L1205.56 493.352C1208.49 495.09 1210.71 495.617 1213.02 496.207L1212.01 500.589Z",
    fill: "url(#paint228_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1195.29 614.78L1194.32 613.389C1192.83 611.261 1192.16 608.965 1191.53 606.457L1195.82 605.34C1196.3 607.089 1196.62 608.332 1197.07 609.281C1205.78 605.52 1213.31 598.903 1218.85 590.191C1221.87 585.524 1223.89 581.657 1224.8 578.139C1229.54 566.539 1229.95 553.929 1226.13 542.403L1230.3 541.013C1234.51 553.56 1234 567.245 1229.01 579.719C1228.08 583.311 1225.92 587.631 1222.57 592.677C1216.16 602.749 1207.3 610.166 1196.92 614.201L1195.29 614.791V614.78Z",
    fill: "url(#paint229_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1239.9 620.807L1238.37 619.764C1229.45 613.39 1222.48 603.676 1218.51 592.277L1222.75 590.813C1226.1 600.674 1232.02 609.176 1239.41 614.991C1245.75 608.059 1250 598.546 1251.25 588.622L1255.64 589.138C1254.25 600.705 1248.95 611.778 1241.22 619.553L1239.89 620.807H1239.9Z",
    fill: "url(#paint230_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1283.52 607.712L1281.65 607.395C1270.85 605.52 1260.19 599.494 1251.86 590.36C1248.84 587.084 1245.97 583.112 1243.47 579.109C1236.57 566.951 1233.78 553.719 1235.6 541.593L1239.92 542.225C1238.28 553.297 1240.96 565.634 1247.23 576.886C1249.6 580.573 1252.32 584.271 1255.1 587.442C1262.35 595.206 1271.26 600.537 1280.59 602.56C1283.31 593.394 1283.31 583.396 1280.35 573.746L1284.6 572.461C1287.98 583.639 1287.77 595.28 1284.14 605.899L1283.51 607.712H1283.52Z",
    fill: "url(#paint231_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1302.65 579.424C1295.8 579.424 1288.41 577.96 1281.57 575.136C1277.25 573.429 1273.07 571.164 1268.9 568.162C1258.03 560.671 1249.88 550.052 1245.97 538.347L1250.22 536.883C1253.84 547.713 1261.44 557.437 1271.47 564.538C1275.44 567.393 1279.2 569.373 1283.31 570.985C1292.96 575.062 1303.52 575.968 1312.4 573.84C1310.69 560.261 1302.33 547.186 1289.65 538.558C1288.82 537.926 1288.19 537.547 1287.49 537.094C1278.89 531.594 1269.17 528.529 1260.04 528.286C1259.03 528.044 1258.3 528.044 1257.74 528.044V523.619C1258.51 523.619 1259.55 523.619 1260.6 523.861C1270.14 524.135 1280.67 527.443 1289.72 533.269C1290.55 533.722 1291.32 534.207 1292.26 534.976C1306.44 544.626 1315.74 559.818 1317.06 575.315L1317.19 577.201L1315.41 577.58C1311.41 578.76 1307.12 579.424 1302.62 579.424H1302.65Z",
    fill: "url(#paint232_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1233.36 544.626C1231.49 544.626 1229.85 544.552 1227.86 543.962C1226.61 543.857 1225.7 543.404 1224.9 542.919L1224.1 542.54L1225.99 538.495C1226.37 538.768 1226.75 538.874 1226.96 539.053C1227.69 539.369 1227.79 539.401 1228.08 539.401L1229.01 539.611C1230.3 540.033 1231.41 540.128 1233.36 540.128C1234.2 540.128 1235.87 540.128 1236.57 539.811L1237.68 539.538C1240.85 539.538 1244.09 537.831 1247.09 535.945C1250.61 533.543 1253.43 529.993 1255.8 525.073L1259.78 526.916C1257.13 532.563 1253.78 536.704 1249.61 539.664C1245.99 541.792 1242.22 543.846 1238.18 543.952C1236.5 544.615 1234.55 544.615 1233.37 544.615L1233.36 544.626Z",
    fill: "url(#paint233_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1259.84 525.674L1255.73 523.936C1257.06 520.796 1257.43 518.679 1257.43 515.992C1257.43 514.665 1257.19 513.559 1257.12 512.516C1256.98 511.715 1256.84 510.914 1256.84 510.145C1255.94 508.154 1255.11 506.279 1254.34 504.646L1253.22 502.486C1250.99 499.146 1248 496.776 1245 494.332C1242.01 492.868 1237.33 491.825 1233.36 491.825H1232.18C1228.56 491.825 1225.57 492.488 1223.12 494.058C1219.08 495.312 1216.36 497.682 1214.09 499.979C1213.22 501.443 1212.6 502.591 1212.11 504.056L1207.93 502.591C1208.56 500.779 1209.18 499.241 1210.71 497.092C1213.49 494.342 1216.91 491.34 1221.24 489.949C1224.03 488.348 1227.79 487.368 1232.11 487.368H1233.36C1237.95 487.368 1243.46 488.653 1247.36 490.645C1250.84 493.363 1254.33 496.081 1257.12 500.369L1258.3 502.739C1259.2 504.656 1260.17 506.605 1261.08 508.902L1261.22 509.703C1261.22 510.43 1261.35 511.093 1261.43 511.894C1261.7 513.074 1261.81 514.37 1261.81 515.897C1261.91 519.701 1261.14 522.545 1259.83 525.685L1259.84 525.674Z",
    fill: "url(#paint234_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1232.67 538.358C1230.61 538.358 1228.56 538.359 1226.33 537.558L1227.68 533.417C1229.32 533.87 1230.86 533.871 1232.67 533.871C1243.04 533.871 1251.13 526.001 1251.13 515.898C1251.13 505.794 1242.83 497.998 1232.67 497.998C1226.05 497.998 1219.77 501.896 1217.07 507.575L1213.12 505.657C1216.57 498.304 1224.24 493.637 1232.67 493.637C1245.25 493.637 1255.58 503.603 1255.58 515.898C1255.58 528.192 1245.24 538.369 1232.67 538.369V538.358Z",
    fill: "url(#paint235_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M962.057 207.447C961.151 207.763 960.424 207.827 959.486 207.763L962.057 207.447Z",
    fill: "url(#paint236_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M951.501 197.07L947.213 196.374C948.888 184.807 954.946 173.387 964.08 164.253C967.767 160.734 971.433 157.489 975.784 155.129C984.634 149.524 994.284 146.522 1004.15 146.522C1005.5 146.522 1006.93 146.627 1008.39 146.796L1010.34 146.933L1010.37 148.776C1011.59 164.527 1005.18 180.656 992.988 193.014C992.567 193.435 992.356 193.635 992.082 193.92C991.419 194.478 990.829 195.205 989.891 195.7L987.489 191.971C988.047 191.623 988.426 191.244 988.953 190.749C989.269 190.433 989.585 190.117 989.891 189.843C1000.63 178.939 1006.5 164.895 1006.09 151.073H1004.15C995.127 151.073 986.246 153.686 978.018 158.943C974.12 161.134 970.601 164.137 967.082 167.371C958.759 175.799 953.144 186.355 951.511 197.049L951.501 197.07Z",
    fill: "url(#paint237_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M979.02 157.279L974.637 156.795C975.996 146.028 974.395 135.925 969.833 127.433C961.373 130.984 953.567 137.673 947.857 146.281L944.096 143.805C950.859 133.807 960.088 126.243 970.086 122.555L971.835 121.923L972.772 123.451C978.419 133.207 980.611 144.911 979.041 157.279H979.02Z",
    fill: "url(#paint238_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M943.001 194.763L939.313 192.393C945.129 183.059 947.741 171.491 946.804 158.849C946.319 154.53 945.339 150.136 943.812 145.712C940.609 135.893 934.899 127.496 927.366 121.365C921.235 128.118 916.979 137.073 915.24 146.86L916.842 149.504L913.081 149.82V147.629L911.269 148.704L910.847 148.04L910.773 146.923C912.659 135.25 917.811 124.557 925.47 116.793L926.797 115.434L928.336 116.582C937.564 123.335 944.328 132.922 948.047 144.31C949.722 148.946 950.765 153.75 951.186 158.459C952.092 172.113 949.374 184.586 943.001 194.753V194.763Z",
    fill: "url(#paint239_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M915.863 203.202C904.432 198.293 894.476 189.411 888.029 177.949C885.142 173.145 883.119 168.404 882.319 163.906C878.8 153.076 878.874 141.087 882.529 130.53L883.119 128.645L885.037 129.066C895.73 131.047 906.318 136.978 914.609 145.785L915.241 146.797C918.686 150.421 921.509 154.182 923.364 157.732C930.19 168.847 932.94 182.226 931.128 194.342L926.745 193.647C928.484 182.574 925.839 170.269 919.529 159.966C917.611 156.373 914.83 152.76 911.343 149.199L907.793 145.364H907.866C901.313 139.654 893.897 135.608 886.164 133.796C883.383 142.993 883.52 153.234 886.585 162.778C887.418 166.993 889.198 171.207 891.811 175.705C897.837 186.367 906.96 194.584 917.622 199.083L915.884 203.191L915.863 203.202Z",
    fill: "url(#paint240_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M909.728 212.852C896.981 212.852 884.581 208.807 874.541 201.675C869.452 198.156 866.039 195.059 863.215 191.645C855.619 183.28 850.742 172.45 849.52 161.167L849.277 159.218L851.195 158.765C862.267 156.078 874.319 157.027 885.297 161.451L883.559 165.56C874.33 161.799 863.911 160.682 854.229 162.631C855.62 172.281 860.044 181.542 866.629 188.685C869.168 191.887 872.444 194.785 877.153 197.987C886.382 204.74 897.918 208.407 909.728 208.407H910.634L910.771 212.863H909.728V212.852Z",
    fill: "url(#paint241_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M884.129 230.057C883.508 230.057 882.981 230.057 882.422 229.983C879.009 229.878 875.596 229.604 872.246 228.971C866.462 227.823 862.005 226.432 858.171 224.62C847.298 220.122 838.101 212.431 832.254 202.886L831.316 201.211L832.781 199.989C841.388 192.952 852.777 188.664 864.86 188.011L865.071 192.404C854.694 193.036 844.865 196.513 837.206 202.191C842.463 210.24 850.511 216.645 859.993 220.554C863.543 222.229 867.726 223.546 873.131 224.631C876.228 225.221 879.325 225.505 882.781 225.569C884.593 225.843 886.784 225.495 888.701 225.253L889.607 225.221C890.44 225.042 891.209 224.947 892.115 224.947L893.021 224.915C893.369 224.81 894.138 224.642 894.833 224.494C896.329 224.115 897.688 223.799 899.047 223.24L900.332 222.861C902.776 222.029 905.695 221.017 908.065 219.585L910.33 223.451C907.791 224.947 904.757 226.064 902.176 226.97C901.544 227.391 900.891 227.528 900.332 227.528C898.868 228.013 897.309 228.434 895.739 228.75C895.149 228.929 894.485 229.098 893.864 229.203L892.326 229.382C891.662 229.456 890.967 229.456 890.208 229.625L889.27 229.698C887.637 229.909 885.857 230.078 884.15 230.078L884.129 230.057Z",
    fill: "url(#paint242_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M854.547 255.309C846.192 253.844 839.365 250.568 834.382 247.955L832.57 246.912L833.508 245.026C838.596 235.271 847.267 226.674 857.96 220.543L858.94 219.911L860.12 220.543C863.459 222.323 867.579 223.745 872.804 224.788C876.807 225.241 879.631 225.484 882.423 225.21C885.141 225.484 887.438 225.557 889.387 225.21C890.503 224.788 891.757 224.62 893.358 225.073C893.885 224.936 894.264 224.799 894.823 224.694C896.319 224.314 897.499 224.03 898.752 223.335L899.764 222.776L900.248 222.913H900.385C903.525 222.144 905.579 220.933 907.665 219.71L909.993 223.44C907.76 224.799 905.463 226.263 901.807 227.096C901.291 227.412 900.691 227.58 900.175 227.58C898.71 228.307 897.288 228.655 895.823 228.971C895.191 229.108 894.57 229.287 893.874 229.455L893.242 229.729L892.579 229.413C891.462 229.097 891.251 229.171 890.493 229.445C887.838 229.972 884.92 229.866 882.307 229.582C879.62 229.719 876.523 229.582 872.13 229.097C866.873 228.117 862.585 226.727 859.066 225.02C850.354 230.172 843.179 237.251 838.512 245.048C842.968 247.313 848.689 249.715 855.305 250.863L854.536 255.288L854.547 255.309Z",
    fill: "url(#paint243_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M979.019 316.14L977.239 315.824C974.942 315.339 972.888 314.328 970.412 312.863L972.677 308.997C974.099 309.935 975.29 310.567 976.407 310.946C979.883 302.033 980.484 292.141 978.25 281.995C977.133 276.801 975.774 272.524 974.11 269.311C969.021 257.712 960.383 248.514 949.584 243.11L951.501 239.212C963.311 245.027 972.688 254.994 978.008 267.393C979.957 270.702 981.485 275.442 982.601 281.121C985.214 292.72 984.203 304.246 979.704 314.496L979.009 316.129L979.019 316.14Z",
    fill: "url(#paint244_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1004.77 289.801C996.339 289.801 987.627 287.683 979.473 283.701L981.495 279.729C990.83 284.291 1000.93 286.208 1010.34 284.986C1009.86 275.62 1006.23 265.822 1000.1 257.984L1003.51 255.298C1010.69 264.463 1014.8 275.957 1014.8 286.893V288.736L1012.95 289.053C1010.34 289.537 1007.55 289.779 1004.77 289.779V289.801Z",
    fill: "url(#paint245_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1004.13 258.975C1003.3 258.975 1002.46 258.975 1001.73 258.87C997.307 258.659 992.566 257.932 987.794 256.784C974.309 253.023 962.889 245.638 955.641 235.819L959.265 233.175C965.818 242.267 976.406 249.062 988.942 252.581C993.293 253.55 997.897 254.213 1001.97 254.498C1012.35 254.814 1022.7 252.338 1030.67 247.187C1026.14 238.758 1019.04 231.795 1010.05 226.875L1012.18 222.935C1022.63 228.613 1030.68 236.873 1035.49 246.934L1036.32 248.64L1034.79 249.757C1026.43 255.752 1015.56 258.986 1004.13 258.986V258.975Z",
    fill: "url(#paint246_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M986.585 232.037C977.419 232.037 968.57 230.056 960.805 226.148L962.786 222.208C972.857 227.254 985.047 228.961 997.31 226.664C1002.05 225.937 1006.3 224.684 1010.27 222.903C1019.78 218.963 1027.89 212.21 1032.84 204.34C1021.97 195.807 1006.93 192.636 991.81 195.385C990.725 195.628 990.03 195.701 989.366 195.944C979.263 198.135 970.382 202.633 963.629 209.081C962.691 209.745 962.27 210.229 961.848 210.609L958.74 207.437C959.267 206.805 959.962 206.184 960.795 205.552C967.969 198.893 977.451 193.921 988.249 191.687C988.734 191.477 989.64 191.308 990.62 191.161C1008.56 187.916 1025.11 191.856 1037.23 202.065L1038.62 203.244L1037.65 204.846C1032.39 214.391 1023.02 222.44 1012.01 226.927C1007.82 228.877 1003.05 230.267 998.005 231.036C994.244 231.732 990.409 232.016 986.574 232.016L986.585 232.037Z",
    fill: "url(#paint247_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M948.257 244.584L946.793 240.444C947.214 240.307 947.562 240.202 947.973 240.128C948.742 239.886 948.742 239.854 948.879 239.643L949.574 239.222C950.965 238.421 951.766 237.789 952.924 236.567C953.757 235.693 954.947 234.586 955.221 233.712L955.779 232.911C958.224 230.436 959.267 226.506 959.888 223.788C960.72 219.5 960.204 215.044 958.35 209.924L962.49 208.396C964.618 214.285 965.177 219.511 964.229 224.631C963.502 227.907 962.174 232.469 959.182 235.703C958.487 237.273 957.16 238.632 956.327 239.538C954.789 241.002 953.672 242.014 951.871 242.951C950.965 243.826 949.985 244.131 949.153 244.31C948.879 244.416 948.668 244.521 948.247 244.584H948.257Z",
    fill: "url(#paint248_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M908.477 227.717C907.782 226.042 907.044 224.472 906.696 221.859C906.591 218.098 906.939 213.642 909.025 209.628C909.931 206.109 911.953 202.865 915.219 199.557L915.851 198.998C918.991 195.901 923.658 192.94 927.977 191.476C932.571 190.844 936.964 190.391 941.736 191.402L944.17 192.277C946.161 192.94 948.321 193.636 950.618 194.679L951.176 195.026C951.808 195.585 952.356 195.932 952.988 196.417C953.968 197.144 955.011 197.945 956.127 199.061C958.498 201.4 960.068 203.76 961.564 207.426L957.486 209.101C956.127 206.036 954.948 204.224 953.062 202.243C952.082 201.305 951.176 200.61 950.312 199.978C949.722 199.557 949.09 199.072 948.574 198.587C946.519 197.755 944.497 197.06 942.685 196.428L940.599 195.627C936.627 194.963 932.929 195.311 928.957 195.806C925.818 196.849 921.604 199.567 918.928 202.254L918.232 202.875C915.588 205.488 913.987 208.132 913.281 210.987L913.07 211.546C911.258 214.717 911.079 218.509 911.079 221.543C911.395 223.218 911.848 224.293 912.543 225.831L908.466 227.717H908.477Z",
    fill: "url(#paint249_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M946.279 239.632L944.33 235.587C945.795 234.86 946.943 233.701 948.197 232.447C955.55 225.062 955.656 213.779 948.481 206.636C945.278 203.391 940.885 201.516 936.218 201.516C931.267 201.516 926.357 203.644 922.839 207.163C918.171 211.799 916.496 218.868 918.593 224.894L914.337 226.358C911.619 218.594 913.704 209.85 919.699 204.024C924.018 199.673 930.076 197.123 936.208 197.123C942.065 197.123 947.565 199.356 951.6 203.571C960.512 212.42 960.417 226.495 951.294 235.587C949.998 237.009 948.471 238.621 946.279 239.632Z",
    fill: "url(#paint250_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M671.67 316.139C659.428 303.213 652.686 285.935 652.686 267.646C652.686 227.897 684.976 195.606 724.725 195.606C764.474 195.606 797.323 227.897 797.323 267.646C797.323 285.313 790.422 302.696 778.339 315.507L774.23 311.578C785.239 299.873 791.676 283.881 791.676 267.646C791.676 231.068 761.619 201.316 724.725 201.316C687.831 201.316 658.396 231.068 658.396 267.646C658.396 284.471 664.611 300.326 675.852 312.136L671.67 316.139Z",
    fill: "url(#paint251_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M721.5 211.314C721.5 212.842 722.754 214.201 724.429 214.201C725.967 214.201 727.284 212.842 727.284 211.314C727.284 209.607 725.956 208.385 724.429 208.385C722.754 208.385 721.5 209.607 721.5 211.314Z",
    fill: "url(#paint252_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M699.884 217.34C700.558 218.867 702.328 219.425 703.824 218.772C705.214 218.045 705.826 216.37 705.214 214.832C704.445 213.473 702.728 212.778 701.348 213.473C699.884 214.2 699.273 215.875 699.884 217.34Z",
    fill: "url(#paint253_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M682.879 232.005C684.132 233.016 685.997 232.879 687.093 231.626C687.978 230.404 687.841 228.528 686.608 227.517C685.354 226.506 683.595 226.685 682.573 227.896C681.53 229.118 681.646 230.888 682.879 232.005Z",
    fill: "url(#paint254_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M673.754 252.39C675.293 252.738 676.852 251.906 677.252 250.262C677.684 248.798 676.746 247.165 675.219 246.817C673.617 246.396 672.069 247.239 671.668 248.871C671.215 250.336 672.185 252.011 673.754 252.39Z",
    fill: "url(#paint255_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M673.966 274.82C675.536 274.503 676.631 273.039 676.315 271.406C676.105 269.868 674.588 268.825 672.986 269.141C671.353 269.415 670.342 270.89 670.637 272.449C670.9 274.019 672.365 275.03 673.966 274.82Z",
    fill: "url(#paint256_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M683.69 295.058C685.071 294.046 685.366 292.277 684.354 290.949C683.511 289.622 681.657 289.316 680.361 290.212C679.034 291.255 678.813 293.035 679.75 294.257C680.498 295.69 682.363 296.006 683.68 295.058H683.69Z",
    fill: "url(#paint257_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M763.041 297.492C761.819 296.344 760.018 296.344 758.901 297.492C757.753 298.609 757.753 300.389 758.975 301.601C760.018 302.686 761.904 302.686 763.052 301.601C764.306 300.379 764.2 298.609 763.052 297.492H763.041Z",
    fill: "url(#paint258_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M774.019 277.96C772.386 277.401 770.743 278.202 770.363 279.74C769.774 281.131 770.427 282.837 771.965 283.364C773.535 283.88 775.168 283.153 775.694 281.689C776.421 280.119 775.557 278.486 774.019 277.96Z",
    fill: "url(#paint259_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M775.62 255.519C774.018 255.73 772.828 257.058 773.112 258.659C773.112 260.292 774.545 261.546 776.252 261.272C777.79 261.208 778.938 259.881 778.728 258.206C778.728 256.468 777.263 255.382 775.63 255.519H775.62Z",
    fill: "url(#paint260_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M767.708 234.618C766.349 235.492 765.865 237.157 766.697 238.621C767.392 239.949 769.341 240.433 770.626 239.559C772.049 238.895 772.47 237.157 771.638 235.587C770.942 234.228 769.267 233.807 767.708 234.607V234.618Z",
    fill: "url(#paint261_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M751.716 218.973C750.747 220.301 751.094 222.071 752.411 222.913C753.591 223.925 755.477 223.535 756.446 222.218C757.426 220.933 757.078 219.152 755.614 218.246C754.392 217.309 752.622 217.656 751.716 218.973Z",
    fill: "url(#paint262_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.564 475.125C379.802 474.704 362.851 467.224 349.893 454.266C321.869 426.19 321.869 380.446 349.893 352.443C378.253 324.188 424.113 323.946 452.168 351.99C464.705 364.632 471.985 381.394 472.512 399.335L466.78 399.441C466.306 383.027 459.638 367.667 448.123 356.036C422.153 330.151 380.023 330.393 353.928 356.489C328.064 382.374 328.064 424.346 353.928 450.231C365.864 462.146 381.34 468.941 397.68 469.457L397.554 475.136L397.564 475.125Z",
    fill: "url(#paint263_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.637 365.812C359.753 366.855 361.618 366.96 362.682 365.812C363.799 364.632 363.83 362.82 362.682 361.703C361.618 360.512 359.753 360.512 358.637 361.703C357.488 362.82 357.488 364.632 358.637 365.812Z",
    fill: "url(#paint264_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.585 385.323C349.166 385.945 350.914 385.081 351.452 383.574C351.884 382.005 351.136 380.435 349.671 379.887C348.207 379.329 346.469 380.129 345.942 381.594C345.405 383.121 346.121 384.691 347.575 385.323H347.585Z",
    fill: "url(#paint265_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.036 407.753C347.584 407.542 348.838 406.078 348.67 404.508C348.427 402.875 347.1 401.685 345.498 401.864C343.95 402.043 342.707 403.402 342.833 405.067C343.023 406.594 344.382 407.816 346.036 407.753Z",
    fill: "url(#paint266_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.927 428.623C355.307 427.823 355.813 426.116 354.991 424.694C354.222 423.229 352.463 422.808 351.04 423.545C349.576 424.42 349.144 426.19 350.061 427.58C350.735 429.013 352.494 429.466 353.927 428.623Z",
    fill: "url(#paint267_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.898 444.194C370.856 443.046 370.562 441.202 369.181 440.296C368.033 439.285 366.168 439.601 365.241 441.065C364.304 442.319 364.525 443.994 365.989 444.963C367.222 445.975 369.087 445.627 369.887 444.205L369.898 444.194Z",
    fill: "url(#paint268_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.095 451.684C391.422 450.009 390.263 448.66 388.704 448.344C387.239 448.028 385.691 449.103 385.375 450.641C385.164 452.274 386.207 453.738 387.777 453.949C389.325 454.402 390.79 453.285 391.085 451.684H391.095Z",
    fill: "url(#paint269_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.964 397.376C447.278 397.481 446.035 398.588 446.035 400.305C445.93 401.874 447.268 403.16 448.964 403.086C450.597 403.086 451.851 401.864 451.851 400.231C451.987 398.598 450.597 397.376 448.964 397.376Z",
    fill: "url(#paint270_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.842 375.842C441.378 376.506 440.756 378.286 441.536 379.603C442.168 381.068 443.854 381.689 445.318 381.026C446.782 380.33 447.393 378.655 446.656 377.233C446.034 375.558 444.285 375.042 442.842 375.842Z",
    fill: "url(#paint271_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.179 358.849C427.136 360.103 427.273 361.873 428.6 362.821C429.749 363.938 431.698 363.727 432.73 362.473C433.689 361.357 433.478 359.481 432.33 358.438C431.097 357.322 429.211 357.501 428.189 358.86L428.179 358.849Z",
    fill: "url(#paint272_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.751 349.578C407.434 351.211 408.33 352.749 409.931 353.129C411.322 353.613 413.029 352.57 413.429 351.106C413.861 349.505 412.892 347.935 411.322 347.513C409.826 346.987 408.225 347.861 407.751 349.568V349.578Z",
    fill: "url(#paint273_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.384 349.893C385.7 351.495 387.164 352.506 388.797 352.222C390.261 351.979 391.431 350.441 391.031 348.777C390.894 347.249 389.345 346.301 387.786 346.585C386.132 346.722 385.068 348.218 385.384 349.893Z",
    fill: "url(#paint274_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.647 800.389C227.982 800.389 195.691 768.13 195.691 728.349C195.691 688.569 227.982 655.709 267.647 655.709C285.43 655.889 302.465 662.61 315.529 674.799L311.642 678.94C299.642 667.688 284.05 661.483 267.647 661.377C231.142 661.377 201.401 691.476 201.401 728.328C201.401 765.18 231.132 794.689 267.647 794.689C284.503 794.689 300.358 788.558 312.221 777.306L316.14 781.415C303.182 793.636 286.02 800.368 267.647 800.368V800.389Z",
    fill: "url(#paint275_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.292 731.625C212.862 731.625 214.094 730.298 214.094 728.665C214.094 727.201 212.862 725.81 211.292 725.81C209.606 725.81 208.363 727.137 208.363 728.665C208.363 730.298 209.701 731.52 211.292 731.625Z",
    fill: "url(#paint276_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.392 753.222C218.772 752.464 219.499 750.747 218.772 749.251C218.045 747.86 216.37 747.228 214.958 747.997C213.494 748.587 212.872 750.293 213.494 751.758C214.189 753.222 215.832 753.844 217.392 753.222Z",
    fill: "url(#paint277_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.078 770.289C233.005 768.899 232.962 767.087 231.709 766.075C230.276 765.096 228.506 765.138 227.495 766.455C226.515 767.708 226.641 769.489 227.895 770.532C229.128 771.575 230.908 771.406 232.078 770.289Z",
    fill: "url(#paint278_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.483 779.381C252.778 777.78 251.893 776.315 250.292 775.757C248.88 775.441 247.195 776.315 246.805 777.843C246.384 779.476 247.279 781.12 248.88 781.436C250.292 781.952 252.073 780.951 252.483 779.381Z",
    fill: "url(#paint279_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.746 779.138C274.503 777.569 273.039 776.557 271.417 776.873C269.952 776.979 268.783 778.548 269.099 780.15C269.415 781.825 270.732 782.762 272.533 782.415C274.061 782.141 275.146 780.708 274.746 779.138Z",
    fill: "url(#paint280_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.056 769.383C294.023 768.129 292.253 767.844 290.926 768.719C289.704 769.488 289.377 771.363 290.283 772.764C291.242 774.05 293.022 774.334 294.276 773.428C295.688 772.596 296.004 770.71 295.056 769.393V769.383Z",
    fill: "url(#paint281_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.543 690.032C296.395 691.286 296.395 693.056 297.543 694.204C298.607 695.353 300.377 695.353 301.641 694.141C302.789 693.056 302.789 691.286 301.588 690.032C300.472 688.852 298.607 688.916 297.543 690.032Z",
    fill: "url(#paint282_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.937 679.128C277.505 680.593 278.158 682.299 279.717 682.752C281.15 683.342 282.815 682.647 283.363 681.119C283.9 679.581 283.12 677.917 281.656 677.495C280.023 676.8 278.464 677.559 277.948 679.128H277.937Z",
    fill: "url(#paint283_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.623 677.485C255.707 679.118 257.087 680.266 258.636 679.992C260.269 679.992 261.522 678.528 261.301 676.958C261.301 675.325 259.784 674.135 258.204 674.314C256.466 674.387 255.401 675.852 255.623 677.485Z",
    fill: "url(#paint284_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.639 685.397C235.492 686.756 237.22 687.24 238.59 686.408C239.97 685.681 240.454 683.827 239.664 682.468C238.895 681.046 237.125 680.593 235.661 681.425C234.249 682.194 233.775 683.932 234.629 685.397H234.639Z",
    fill: "url(#paint285_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.94 701.379C220.32 702.316 222.079 702.074 222.933 700.609C223.944 699.461 223.649 697.617 222.258 696.711C220.931 695.668 219.171 696.048 218.318 697.438C217.391 698.65 217.707 700.536 218.94 701.368V701.379Z",
    fill: "url(#paint286_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.361 1124.29C384.913 1124.29 366.487 1117.33 352.465 1103.25C324.157 1074.97 323.957 1029.16 351.98 1001.01C364.623 988.399 381.437 981.193 399.41 980.635L399.536 986.387C383.133 986.84 367.646 993.53 356.026 1005.06C330.246 1030.94 330.373 1073.23 356.458 1099.28C382.29 1125.09 424.357 1125.09 450.2 1099.28C462.136 1087.33 468.963 1071.72 469.5 1055.46L475.21 1055.52C474.705 1073.43 467.246 1090.32 454.235 1103.24C440.213 1117.32 421.765 1124.28 403.361 1124.28V1124.29Z",
    fill: "url(#paint287_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.772 1094.47C366.921 1093.35 366.847 1091.54 365.772 1090.54C364.624 1089.42 362.844 1089.32 361.643 1090.43C360.494 1091.55 360.494 1093.36 361.643 1094.47C362.844 1095.69 364.624 1095.51 365.772 1094.47Z",
    fill: "url(#paint288_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.304 1105.48C385.831 1103.95 385.178 1102.2 383.629 1101.72C382.049 1101.19 380.321 1102.03 379.973 1103.42C379.415 1104.96 380.11 1106.59 381.575 1107.23C383.124 1107.78 384.672 1106.95 385.304 1105.48Z",
    fill: "url(#paint289_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.755 1107.23C407.534 1105.48 406.154 1104.23 404.5 1104.54C402.951 1104.78 401.708 1106 401.908 1107.71C402.034 1109.25 403.457 1110.4 404.974 1110.32C406.607 1110.14 407.85 1108.75 407.765 1107.23H407.755Z",
    fill: "url(#paint290_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.603 1099.13C427.75 1097.85 426.117 1097.29 424.652 1098.09C423.325 1098.97 422.682 1100.74 423.588 1102.06C424.421 1103.5 426.222 1104.01 427.581 1103.11C429.014 1102.48 429.446 1100.57 428.614 1099.13H428.603Z",
    fill: "url(#paint291_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.175 1083.11C443.006 1082.27 441.246 1082.55 440.309 1083.91C439.276 1085.13 439.698 1087.02 441.078 1087.96C442.405 1088.8 444.007 1088.62 444.923 1087.16C445.935 1085.93 445.64 1084.06 444.175 1083.11Z",
    fill: "url(#paint292_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.665 1062.07C450.117 1061.77 448.652 1062.77 448.357 1064.37C448.041 1065.83 449.137 1067.4 450.707 1067.68C452.287 1067.99 453.751 1066.83 454.067 1065.38C454.362 1063.92 453.319 1062.31 451.665 1062.07Z",
    fill: "url(#paint293_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.442 1004.21C397.442 1005.71 398.611 1006.99 400.244 1007.14C401.898 1007.14 403.173 1005.81 403.131 1004.11C403.162 1002.61 401.93 1001.25 400.244 1001.33C398.611 1001.26 397.357 1002.61 397.442 1004.22V1004.21Z",
    fill: "url(#paint294_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.865 1010.27C376.539 1011.66 378.246 1012.26 379.678 1011.52C381.143 1010.9 381.754 1009.36 381.037 1007.87C380.321 1006.33 378.656 1005.71 377.224 1006.45C375.643 1007.14 375.085 1008.82 375.865 1010.28V1010.27Z",
    fill: "url(#paint295_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.829 1024.9C360.156 1025.95 361.821 1025.81 362.853 1024.48C364.002 1023.33 363.791 1021.46 362.537 1020.44C361.357 1019.39 359.524 1019.6 358.429 1020.86C357.354 1022.11 357.491 1023.88 358.829 1024.89V1024.9Z",
    fill: "url(#paint296_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.685 1045.32C351.212 1045.71 352.782 1044.76 353.13 1043.23C353.614 1041.77 352.603 1040.17 351.149 1039.68C349.579 1039.31 347.947 1040.21 347.42 1041.95C346.998 1043.23 347.947 1044.88 349.685 1045.33V1045.32Z",
    fill: "url(#paint297_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.822 1067.82C351.55 1067.4 352.509 1066.01 352.161 1064.38C351.982 1062.78 350.434 1061.69 348.853 1062.08C347.273 1062.32 346.262 1063.93 346.662 1065.39C346.799 1067.07 348.263 1068 349.833 1067.83L349.822 1067.82Z",
    fill: "url(#paint298_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M728.274 1257.47C688.314 1257.39 655.676 1225.1 655.676 1185.46C655.886 1167.65 662.692 1150.63 674.787 1137.57L679.032 1141.36C667.812 1153.49 661.597 1169.19 661.46 1185.46C661.46 1222.01 691.401 1251.79 728.274 1251.86C746.11 1251.86 762.829 1244.86 775.408 1232.39C787.955 1219.85 794.782 1203.2 794.782 1185.47C794.782 1167.74 788.577 1152.73 777.326 1140.78L781.508 1136.94C793.739 1150.01 800.429 1167.25 800.429 1185.47C800.492 1204.74 792.97 1222.82 779.454 1236.44C765.863 1250.03 747.68 1257.48 728.274 1257.48V1257.47Z",
    fill: "url(#paint299_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M731.604 1241.79C731.688 1240.26 730.308 1239.04 728.78 1239.01C727.211 1239.04 725.82 1240.23 725.883 1241.79C725.82 1243.54 727.105 1244.83 728.664 1244.83C730.224 1244.83 731.562 1243.39 731.593 1241.79H731.604Z",
    fill: "url(#paint300_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M753.252 1235.8C752.419 1234.33 750.744 1233.6 749.28 1234.33C747.889 1234.96 747.257 1236.91 747.984 1238.2C748.648 1239.63 750.249 1240.22 751.713 1239.66C753.252 1238.86 753.873 1237.32 753.252 1235.8Z",
    fill: "url(#paint301_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770.288 1221.13C768.824 1220.09 766.98 1220.12 766.074 1221.55C765.168 1222.81 765.168 1224.59 766.39 1225.63C767.57 1226.64 769.487 1226.5 770.425 1225.28C771.573 1224.03 771.51 1222.19 770.288 1221.14V1221.13Z",
    fill: "url(#paint302_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M779.337 1200.68C777.767 1200.41 776.24 1201.1 775.787 1202.77C775.47 1204.3 776.24 1205.91 777.872 1206.39C779.505 1206.74 781.044 1205.91 781.391 1204.2C781.95 1202.78 780.97 1201.1 779.337 1200.68Z",
    fill: "url(#paint303_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M779.03 1178.42C777.64 1178.56 776.523 1180.02 776.871 1181.66C777.008 1183.23 778.577 1184.27 780.179 1184.06C781.812 1183.57 782.749 1182.35 782.444 1180.64C782.128 1179.01 780.663 1177.99 779.03 1178.41V1178.42Z",
    fill: "url(#paint304_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M769.455 1158.11C768.233 1159.12 767.885 1160.8 768.728 1162.16C769.497 1163.44 771.446 1163.73 772.7 1162.93C774.164 1161.99 774.375 1160.1 773.469 1158.85C772.7 1157.52 770.751 1157.18 769.466 1158.12L769.455 1158.11Z",
    fill: "url(#paint305_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M690.169 1155.54C691.285 1156.69 692.971 1156.66 694.214 1155.71C695.331 1154.59 695.362 1152.68 694.109 1151.49C693.045 1150.35 691.285 1150.31 690.169 1151.56C688.936 1152.6 688.936 1154.49 690.169 1155.53V1155.54Z",
    fill: "url(#paint306_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M679.158 1175.16C680.675 1175.67 682.256 1174.73 682.74 1173.48C683.372 1171.94 682.677 1170.42 681.033 1169.75C679.548 1169.19 677.999 1169.99 677.462 1171.53C676.746 1173.17 677.641 1174.63 679.148 1175.16H679.158Z",
    fill: "url(#paint307_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M677.462 1197.51C679.095 1197.41 680.18 1196.15 680.054 1194.49C680.085 1192.81 678.526 1191.74 676.956 1191.8C675.387 1191.91 674.133 1193.37 674.27 1194.9C674.375 1196.74 675.84 1197.75 677.462 1197.51Z",
    fill: "url(#paint308_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M685.458 1218.41C686.796 1217.61 687.238 1215.97 686.29 1214.52C685.679 1213.13 683.815 1212.63 682.424 1213.43C681.033 1214.26 680.559 1216.15 681.413 1217.51C682.213 1218.93 683.888 1219.35 685.458 1218.41Z",
    fill: "url(#paint309_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M701.43 1234.23C702.315 1232.76 702.072 1231.13 700.629 1230.15C699.481 1229.21 697.532 1229.45 696.699 1230.98C695.667 1232.13 696.141 1234.02 697.426 1234.88C698.764 1235.79 700.555 1235.47 701.43 1234.22V1234.23Z",
    fill: "url(#paint310_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1051.8 1121.98C1032.47 1121.98 1014.53 1114.67 1001.01 1101.08C988.472 1088.47 981.182 1071.65 980.592 1053.74L986.302 1053.57C986.86 1070.05 993.55 1085.44 1005.04 1097.04C1017.44 1109.44 1034.03 1116.26 1051.79 1116.26H1052.18C1069.88 1116.19 1086.63 1109.23 1099.24 1096.68C1111.79 1084.04 1118.68 1067.38 1118.68 1049.72C1118.68 1032.07 1111.78 1015.44 1099.24 1002.87C1087.46 991.064 1071.83 984.195 1055.41 983.542L1055.62 977.864C1073.49 978.559 1090.42 985.944 1103.27 998.839C1116.93 1012.42 1124.46 1030.54 1124.46 1049.73C1124.46 1068.93 1116.94 1087.08 1103.27 1100.77C1089.65 1114.32 1071.44 1121.91 1052.17 1121.98H1051.78H1051.8Z",
    fill: "url(#paint311_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1094.54 1087.32C1093.36 1086.25 1091.58 1086.28 1090.43 1087.32C1089.49 1088.55 1089.36 1090.25 1090.43 1091.48C1091.58 1092.69 1093.36 1092.59 1094.54 1091.48C1095.62 1090.25 1095.51 1088.55 1094.54 1087.32Z",
    fill: "url(#paint312_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1105.58 1067.82C1103.98 1067.34 1102.17 1068 1101.72 1069.56C1101.13 1070.98 1102.02 1072.76 1103.42 1073.22C1104.96 1073.74 1106.62 1072.98 1107.23 1071.62C1107.74 1070.05 1107.05 1068.31 1105.59 1067.82H1105.58Z",
    fill: "url(#paint313_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1107.22 1045.32C1105.44 1045.71 1104.19 1046.95 1104.54 1048.6C1104.64 1050.13 1106 1051.45 1107.64 1051.38C1109.21 1051.21 1110.42 1049.64 1110.32 1048.17C1110.19 1046.5 1108.78 1045.25 1107.22 1045.32Z",
    fill: "url(#paint314_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1099.18 1024.48C1097.85 1025.36 1097.26 1027.06 1098.09 1028.53C1098.92 1029.81 1100.67 1030.4 1102.14 1029.51C1103.42 1028.63 1104.05 1027.06 1103.11 1025.5C1102.44 1024.07 1100.49 1023.66 1099.18 1024.49V1024.48Z",
    fill: "url(#paint315_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1083.14 1008.85C1082.31 1010.06 1082.58 1011.94 1083.91 1012.78C1085.13 1013.79 1086.98 1013.41 1087.95 1012.11C1088.76 1010.68 1088.65 1009.08 1087.19 1008.17C1085.93 1007.27 1084.05 1007.54 1083.14 1008.84V1008.85Z",
    fill: "url(#paint316_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1062.07 1001.49C1061.76 1002.99 1062.8 1004.45 1064.37 1004.77C1065.86 1005.04 1067.47 1003.94 1067.75 1002.61C1068.1 1000.77 1066.84 999.408 1065.38 999.197C1063.92 998.744 1062.28 999.787 1062.07 1001.49Z",
    fill: "url(#paint317_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1004.14 1055.63C1005.77 1055.7 1006.92 1054.49 1007.13 1052.85C1007.13 1051.39 1005.8 1049.96 1004.14 1049.96C1002.57 1049.96 1001.24 1051.21 1001.42 1052.92C1001.24 1054.49 1002.57 1055.77 1004.14 1055.63Z",
    fill: "url(#paint318_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1010.27 1077.26C1011.8 1076.54 1012.19 1074.93 1011.6 1073.5C1010.97 1072.04 1009.44 1071.45 1007.76 1072.04C1006.3 1072.76 1005.77 1074.44 1006.44 1075.84C1007.13 1077.55 1008.81 1077.97 1010.27 1077.26Z",
    fill: "url(#paint319_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1024.98 1094.3C1025.95 1093 1025.81 1091.44 1024.49 1090.25C1023.38 1089.07 1021.57 1089.41 1020.45 1090.63C1019.48 1091.78 1019.62 1093.62 1020.87 1094.57C1022.2 1095.83 1023.86 1095.58 1024.98 1094.3Z",
    fill: "url(#paint320_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1045.32 1103.42C1045.74 1101.96 1044.84 1100.43 1043.16 1099.98C1041.7 1099.46 1040.17 1100.5 1039.67 1102.03C1039.22 1103.6 1040.23 1105.27 1041.83 1105.69C1043.27 1106.07 1044.87 1105.26 1045.32 1103.42Z",
    fill: "url(#paint321_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1067.89 1103.24C1067.47 1101.72 1066.01 1100.56 1064.37 1101.01C1062.8 1101.08 1061.68 1102.72 1062.07 1104.25C1062.28 1105.89 1063.92 1106.94 1065.38 1106.52C1067.06 1106.28 1068.02 1104.81 1067.89 1103.24Z",
    fill: "url(#paint322_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1185.64 797.292H1185.46C1167.73 797.292 1150.73 790.496 1137.56 778.37L1141.39 774.156C1153.55 785.334 1169.19 791.603 1185.46 791.603H1185.64C1203.27 791.603 1219.85 784.639 1232.43 771.955C1244.9 759.344 1251.76 742.519 1251.86 724.789C1251.86 706.984 1244.93 690.37 1232.43 677.791C1219.92 665.318 1203.27 658.385 1185.64 658.385H1185.46C1168.5 658.385 1153.1 664.412 1140.77 675.769L1136.94 671.554C1150.1 659.428 1167.31 652.781 1185.46 652.781H1185.64C1204.83 652.781 1222.78 660.166 1236.43 673.756C1250.02 687.378 1257.47 705.425 1257.47 724.789C1257.47 744.152 1250.01 762.304 1236.43 776C1222.78 789.791 1204.73 797.281 1185.64 797.281V797.292Z",
    fill: "url(#paint323_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1241.87 721.521C1240.27 721.521 1239.07 722.775 1238.91 724.345C1239.15 725.873 1240.27 727.274 1241.87 727.274C1243.47 727.274 1244.8 725.988 1244.8 724.419C1244.8 722.849 1243.4 721.637 1241.87 721.532V721.521Z",
    fill: "url(#paint324_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1235.8 699.82C1234.33 700.62 1233.64 702.327 1234.33 703.791C1234.97 705.214 1236.92 705.846 1238.17 705.15C1239.63 704.424 1240.25 702.854 1239.77 701.389C1238.9 699.82 1237.33 699.23 1235.8 699.82Z",
    fill: "url(#paint325_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1221.17 682.89C1220.08 684.28 1220.19 686.092 1221.44 686.925C1222.69 687.905 1224.64 687.905 1225.55 686.682C1226.67 685.46 1226.53 683.617 1225.27 682.637C1224.02 681.489 1222.18 681.594 1221.17 682.879V682.89Z",
    fill: "url(#paint326_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1200.68 673.756C1200.41 675.325 1201.1 676.853 1202.84 677.306C1204.31 677.696 1205.91 676.853 1206.36 675.22C1206.68 673.545 1205.91 672.049 1204.2 671.743C1202.84 671.185 1201.03 672.165 1200.68 673.766V673.756Z",
    fill: "url(#paint327_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1178.42 674.071C1178.53 675.536 1179.99 676.547 1181.67 676.231C1183.2 676.126 1184.31 674.493 1184.04 672.923C1183.62 671.385 1182.36 670.342 1180.66 670.626C1179.06 670.942 1178.04 672.502 1178.42 674.071Z",
    fill: "url(#paint328_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1158.11 683.754C1159.15 684.976 1160.83 685.281 1162.16 684.449C1163.41 683.512 1163.79 681.626 1162.93 680.404C1161.99 678.939 1160.07 678.771 1158.88 679.708C1157.49 680.404 1157.17 682.458 1158.11 683.754Z",
    fill: "url(#paint329_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1155.51 762.977C1156.72 761.934 1156.66 760.154 1155.62 758.837C1154.65 757.752 1152.69 757.72 1151.57 759.006C1150.39 760.049 1150.32 761.934 1151.71 763.083C1152.61 764.168 1154.49 764.168 1155.51 762.977Z",
    fill: "url(#paint330_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1175.15 773.987C1175.67 772.417 1174.77 770.848 1173.44 770.363C1171.98 769.699 1170.45 770.437 1169.75 772.07C1169.2 773.64 1169.96 775.167 1171.53 775.694C1173.17 776.358 1174.63 775.515 1175.16 773.987H1175.15Z",
    fill: "url(#paint331_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1197.56 775.62C1197.38 774.05 1196.17 772.87 1194.46 773.113C1192.83 773.039 1191.85 774.535 1191.85 776.242C1191.88 777.674 1193.38 778.928 1194.91 778.854C1196.76 778.717 1197.77 777.253 1197.56 775.62Z",
    fill: "url(#paint332_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1218.45 767.539C1217.61 766.317 1215.94 765.864 1214.48 766.77C1213.12 767.497 1212.63 769.351 1213.43 770.637C1214.26 772.069 1216.15 772.586 1217.51 771.753C1218.84 770.953 1219.4 769.278 1218.45 767.539Z",
    fill: "url(#paint333_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1234.23 751.621C1232.87 750.746 1231.06 750.988 1230.15 752.463C1229.25 753.612 1229.46 755.561 1230.99 756.435C1232.11 757.404 1233.99 756.951 1234.86 755.561C1235.8 754.339 1235.45 752.632 1234.23 751.621Z",
    fill: "url(#paint334_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1053.75 472.481L1053.54 466.877C1070.12 466.213 1085.52 459.492 1097.01 448.029C1109.41 435.693 1116.23 419.216 1116.28 401.559C1116.38 383.586 1109.42 366.613 1096.73 353.94C1084.05 341.392 1067.43 334.429 1049.7 334.429C1031.97 334.429 1015.42 341.392 1002.89 353.94C991.118 365.823 984.217 381.289 983.585 397.661L977.875 397.555C978.57 379.614 985.987 362.758 998.851 349.905C1012.5 336.283 1030.55 328.655 1049.7 328.655C1068.86 328.655 1087.08 336.177 1100.78 349.905C1114.51 363.737 1122.09 382.026 1122.03 401.569C1121.95 420.796 1114.51 438.779 1101.02 452.085C1088.44 464.622 1071.69 471.902 1053.75 472.492V472.481Z",
    fill: "url(#paint335_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1087.32 358.638C1086.25 359.755 1086.35 361.536 1087.32 362.684C1088.55 363.727 1090.28 363.832 1091.51 362.684C1092.69 361.536 1092.49 359.65 1091.51 358.638C1090.28 357.49 1088.55 357.627 1087.32 358.638Z",
    fill: "url(#paint336_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1067.78 347.524C1067.33 349.199 1067.96 350.938 1069.56 351.454C1070.98 351.981 1072.76 351.106 1073.19 349.642C1073.74 348.104 1072.98 346.576 1071.58 345.839C1070.06 345.417 1068.31 346.049 1067.79 347.514L1067.78 347.524Z",
    fill: "url(#paint337_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1045.32 345.954C1045.74 347.766 1047 348.988 1048.52 348.64C1050.06 348.43 1051.45 347.113 1051.32 345.469C1051.24 343.931 1049.71 342.677 1048.25 342.856C1046.51 342.962 1045.26 344.321 1045.32 345.954Z",
    fill: "url(#paint338_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1024.48 353.929C1025.32 355.183 1027.06 355.846 1028.53 355.014C1029.85 354.245 1030.4 352.507 1029.54 351.042C1028.6 349.652 1027.06 349.093 1025.53 350.031C1024.07 350.663 1023.66 352.57 1024.49 353.929H1024.48Z",
    fill: "url(#paint339_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1008.88 369.953C1010.06 370.891 1011.95 370.543 1012.82 369.184C1013.83 367.962 1013.48 366.16 1012.12 365.254C1010.7 364.348 1009.1 364.527 1008.15 365.918C1007.25 367.309 1007.56 369.089 1008.88 369.964V369.953Z",
    fill: "url(#paint340_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1001.49 391.139C1003.06 391.318 1004.42 390.233 1004.77 388.769C1005.04 387.199 1004 385.64 1002.58 385.355C1000.8 385.008 999.408 386.23 999.166 387.758C998.818 389.148 999.788 390.855 1001.49 391.139Z",
    fill: "url(#paint341_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1055.62 448.935C1055.73 447.334 1054.51 446.08 1052.8 446.006C1051.37 446.006 1049.98 447.302 1049.98 448.935C1049.98 450.568 1051.23 451.927 1053.04 451.685C1054.51 451.927 1055.82 450.6 1055.62 448.935Z",
    fill: "url(#paint342_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1077.22 442.835C1076.49 441.371 1074.92 440.918 1073.49 441.508C1072.03 442.129 1071.44 443.773 1072.03 445.406C1072.75 446.87 1074.43 447.323 1075.86 446.66C1077.54 445.996 1077.95 444.289 1077.22 442.825V442.835Z",
    fill: "url(#paint343_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1094.3 428.202C1093.05 427.117 1091.44 427.265 1090.3 428.624C1089.04 429.667 1089.5 431.616 1090.64 432.701C1091.82 433.607 1093.68 433.501 1094.58 432.311C1095.91 431.026 1095.63 429.214 1094.3 428.202Z",
    fill: "url(#paint344_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1103.42 407.753C1101.96 407.437 1100.39 408.311 1100.04 409.913C1099.56 411.377 1100.49 413.052 1102.02 413.505C1103.59 413.884 1105.3 412.842 1105.65 411.314C1106.17 409.85 1105.3 408.248 1103.41 407.764L1103.42 407.753Z",
    fill: "url(#paint345_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1103.28 385.324C1101.72 385.64 1100.57 387.168 1101.02 388.769C1101.13 390.234 1102.73 391.456 1104.3 390.929C1105.9 390.855 1106.91 389.148 1106.53 387.758C1106.29 386.156 1104.82 385.071 1103.3 385.324H1103.28Z",
    fill: "url(#paint346_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.936 481.257L211.398 214.274L482.995 324.04L480.646 329.898L224.03 226.158L342.709 478.539L336.936 481.257Z",
    fill: "url(#paint347_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.137 486.134L331.216 425.726L328.066 413.642L289.17 289.137L306.995 294.784L341.53 306.731L353.445 310.46L365.571 314.948L377.391 318.604L401.938 327.496L425.706 334.944L437.906 339.443L449.673 343.235L488.085 356.373L485.999 362.462L298.925 298.924L334.176 411.861L337.337 424.061L356.142 484.185L350.137 486.134Z",
    fill: "url(#paint348_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.215 291.16L249.117 288.094L289.962 248.45L293.028 251.548L252.215 291.16Z",
    fill: "url(#paint349_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.259 301.853L254.162 298.756L301.275 252.843L304.341 256.046L257.259 301.853Z",
    fill: "url(#paint350_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.244 312.62L259.146 309.407L312.634 257.816L315.752 261.029L262.244 312.62Z",
    fill: "url(#paint351_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.332 323.239L264.234 320.099L323.958 262.208L327.045 265.38L267.332 323.239Z",
    fill: "url(#paint352_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.316 333.932L269.219 330.772L335.179 266.708L338.277 269.773L272.316 333.932Z",
    fill: "url(#paint353_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.644 828.601L0 728.59L269.732 614.115L272.208 619.899L17.3514 728.032L279.804 822.754L277.644 828.601Z",
    fill: "url(#paint354_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.412 822.754L234.344 793.424L223.503 787.05L107.975 726.568L124.568 717.897L157.406 701.979L168.573 696.153L180.256 690.79L191.181 685.08L214.896 673.86L236.957 662.293L248.746 657.004L259.755 651.326L296.207 633.458L299.009 639.136L121.786 726.568L226.569 781.54L237.42 787.914L293.278 817.139L290.412 822.754Z",
    fill: "url(#paint355_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.3638 754.098L78.918 753.982L79.8029 697.134L84.1961 697.208L83.3638 754.098Z",
    fill: "url(#paint356_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.4559 758.163L89.9258 758.132L90.8529 692.361H95.383L94.4559 758.163Z",
    fill: "url(#paint357_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.604 762.21L101.105 762.105L102.401 687.863H106.931L105.604 762.21Z",
    fill: "url(#paint358_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.686 766.14L112.156 766.003L113.568 682.891L117.972 682.954L116.686 766.14Z",
    fill: "url(#paint359_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.79 770.121H123.312L124.661 678.118L129.044 678.149L127.79 770.121Z",
    fill: "url(#paint360_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.273 1241.79L324.039 970.068L329.929 972.438L226.21 1229.15L478.538 1110.46L481.319 1116.21L214.273 1241.79Z",
    fill: "url(#paint361_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.168 1164.04L299.219 1133.52L303.57 1121.47L310.544 1099.66L314.969 1087.5L318.603 1075.83L327.484 1051.21L334.964 1027.38L339.421 1015.19L343.256 1003.41L356.456 965.159L362.535 967.245L298.924 1154.24L411.966 1118.96L424.039 1115.72L484.216 1096.94L486.134 1102.97L425.704 1121.85L413.641 1125.09L289.168 1164.04Z",
    fill: "url(#paint362_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.605 1169.44L338.986 1146.27L342.136 1143.17L364.745 1166.31L361.605 1169.44Z",
    fill: "url(#paint363_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.14 1114.12L279.885 1084.57L283.035 1081.51L311.395 1110.99L308.14 1114.12Z",
    fill: "url(#paint364_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.288 1164.35L350.912 1142.37L354.062 1139.3L375.459 1161.28L372.288 1164.35Z",
    fill: "url(#paint365_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.964 1102.2L284.277 1073.22L287.48 1070.09L315.209 1099.07L311.964 1102.2Z",
    fill: "url(#paint366_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.252 1090.25L289.25 1062.01L292.421 1058.87L319.56 1087.16L316.252 1090.25Z",
    fill: "url(#paint367_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.065 1078.31L293.717 1050.55L296.919 1047.51L323.215 1075.24L320.065 1078.31Z",
    fill: "url(#paint368_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.47 1066.36L298.174 1039.29L301.271 1036.2L327.683 1063.22L324.47 1066.36Z",
    fill: "url(#paint369_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.895 1053.75L303.168 1027.38L306.36 1024.28L332.066 1050.68L328.895 1053.75Z",
    fill: "url(#paint370_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.677 1041.83L307.529 1016.13L310.711 1013.02L335.774 1038.74L332.677 1041.83Z",
    fill: "url(#paint371_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.426 1029.81L312.543 1004.77L315.819 1001.63L339.608 1026.79L336.426 1029.81Z",
    fill: "url(#paint372_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.852 1017.83L317.074 993.445L320.172 990.306L344.002 1014.74L340.852 1017.83Z",
    fill: "url(#paint373_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.624 1005.99L321.32 981.498L324.565 978.401L347.901 1002.88L344.624 1005.99Z",
    fill: "url(#paint374_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.308 1219.67L234.543 1197.69L237.819 1194.59L258.553 1216.6L255.308 1219.67Z",
    fill: "url(#paint375_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.718 1214.03L239.021 1186.41L242.214 1183.24L269.816 1210.92L266.718 1214.03Z",
    fill: "url(#paint376_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.326 1209.08L244.088 1174.45L247.28 1171.32L280.561 1205.94L277.326 1209.08Z",
    fill: "url(#paint377_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.103 1203.89L248.428 1163.14L251.578 1160.1L291.19 1200.79L288.103 1203.89Z",
    fill: "url(#paint378_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.785 1198.94L252.82 1151.81L256.023 1148.74L301.883 1195.81L298.785 1198.94Z",
    fill: "url(#paint379_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.502 1193.96L257.785 1140.59L261.041 1137.49L312.631 1190.86L309.502 1193.96Z",
    fill: "url(#paint380_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.068 1188.98L262.24 1129.23L265.39 1126.14L323.218 1185.85L320.068 1188.98Z",
    fill: "url(#paint381_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.867 1183.89L266.719 1117.95L269.816 1114.82L334.007 1180.79L330.867 1183.89Z",
    fill: "url(#paint382_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.37 1178.87L316.887 1153.03L320.174 1150L344.626 1175.78L341.37 1178.87Z",
    fill: "url(#paint383_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.652 1136.1L271.701 1106L274.925 1102.91L303.823 1133L300.652 1136.1Z",
    fill: "url(#paint384_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.809 1173.83L328.895 1149.38L332.066 1146.27L355.928 1170.69L352.809 1173.83Z",
    fill: "url(#paint385_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.949 1124.16L276.178 1094.57L279.275 1091.48L308.141 1121.08L304.949 1124.16Z",
    fill: "url(#paint386_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M728.57 1453L614.137 1183.48L619.942 1180.93L728.054 1435.65L822.712 1173.38L828.643 1175.43L728.57 1453Z",
    fill: "url(#paint387_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M726.59 1345.08L717.898 1328.63L701.958 1295.62L696.248 1284.61L690.791 1272.86L685.06 1262L673.935 1238.27L662.315 1216.19L656.931 1204.38L651.284 1193.45L633.543 1156.75L639.179 1154.08L668.025 1213.43L679.561 1235.38L690.738 1259.17L696.47 1270L701.958 1281.78L712.388 1302.16L726.59 1331.38L781.604 1226.49L787.947 1215.74L817.14 1159.83L822.713 1162.79L793.52 1218.76L787.114 1229.57L726.59 1345.08Z",
    fill: "url(#paint388_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M781.647 1297.77L749.209 1297.35L749.283 1292.9L781.647 1293.32V1297.77Z",
    fill: "url(#paint389_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M704.782 1296.42L663.863 1295.51L663.895 1291.12L704.792 1291.96L704.782 1296.42Z",
    fill: "url(#paint390_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M785.545 1286.69L754.93 1286.24L754.993 1281.78L785.682 1282.2L785.545 1286.69Z",
    fill: "url(#paint391_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M698.997 1285.3L658.984 1284.47L659.111 1280.04L699.102 1280.91L698.997 1285.3Z",
    fill: "url(#paint392_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.592 1273.77L654.549 1272.86L654.612 1268.48L693.666 1269.25L693.592 1273.77Z",
    fill: "url(#paint393_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M687.769 1262.69L649.568 1261.75L649.674 1257.36L687.937 1258.24L687.769 1262.69Z",
    fill: "url(#paint394_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M682.542 1251.13L644.689 1250.67L644.774 1246.29L682.574 1246.67L682.542 1251.13Z",
    fill: "url(#paint395_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M676.717 1239.1L639.812 1238.69L639.897 1234.23L676.759 1234.65L676.717 1239.1Z",
    fill: "url(#paint396_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.954 1228.06L634.955 1227.76L635.008 1223.26L670.954 1223.58V1228.06Z",
    fill: "url(#paint397_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665.107 1216.92L630.541 1215.98L630.615 1211.59L665.223 1212.52L665.107 1216.92Z",
    fill: "url(#paint398_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.83 1205.29L625.664 1204.9L625.759 1200.44L659.83 1200.79V1205.29Z",
    fill: "url(#paint399_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.003 1194.23L620.248 1193.37L620.396 1188.87L654.15 1189.67L654.003 1194.23Z",
    fill: "url(#paint400_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M742.066 1408.45L711.852 1407.61L712.041 1403.15L742.246 1403.99L742.066 1408.45Z",
    fill: "url(#paint401_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M746.113 1391.93H706.975V1396.43H746.113V1391.93Z",
    fill: "url(#paint402_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M750.115 1385.42L702.043 1384.37L702.075 1379.99L750.115 1380.93V1385.42Z",
    fill: "url(#paint403_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M754.025 1374.2L697.188 1373.26L697.219 1368.91L754.088 1369.81L754.025 1374.2Z",
    fill: "url(#paint404_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M758.133 1363.16L692.33 1362.22V1357.79L758.207 1358.73L758.133 1363.16Z",
    fill: "url(#paint405_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M762.137 1351.9L687.854 1350.76V1346.37L762.211 1347.52L762.137 1351.9Z",
    fill: "url(#paint406_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M766.003 1340.94L682.996 1339.72L683.08 1335.19L766.182 1336.41L766.003 1340.94Z",
    fill: "url(#paint407_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770.049 1329.78L678.098 1328.42L678.182 1324.04L770.186 1325.29L770.049 1329.78Z",
    fill: "url(#paint408_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M774.083 1318.68L738.537 1317.83L738.611 1313.35L774.157 1314.18L774.083 1318.68Z",
    fill: "url(#paint409_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M714.97 1317.38L673.135 1316.44L673.324 1311.91L715.139 1312.89L714.97 1317.38Z",
    fill: "url(#paint410_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M778.582 1307.14L744.332 1306.66L744.406 1302.26L778.582 1302.61V1307.14Z",
    fill: "url(#paint411_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M709.555 1305.86L668.32 1305.37L668.426 1300.87L709.639 1301.4L709.555 1305.86Z",
    fill: "url(#paint412_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1241.72 1238.8L970.068 1129.07L972.439 1123.25L1229.04 1226.88L1110.43 974.598L1116.14 971.88L1241.72 1238.8Z",
    fill: "url(#paint413_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1163.94 1163.94L1146.19 1158.36L1087.61 1138.19L1075.86 1134.46L1051.17 1125.61L1027.34 1118.16L1015.22 1113.7L1003.41 1109.93L964.979 1096.7L967.075 1090.71L1154.35 1154.32L1118.99 1041.21L1115.76 1029.05L1111.92 1017.46L1108.3 1004.7L1096.94 968.962L1103 966.971L1121.89 1027.27L1125.09 1039.43L1163.94 1163.94Z",
    fill: "url(#paint414_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1163.2 1204.66L1160.07 1201.45L1200.79 1161.91L1203.88 1165.15L1163.2 1204.66Z",
    fill: "url(#paint415_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1151.84 1200.27L1148.74 1197.06L1195.8 1151.19L1198.94 1154.5L1151.84 1200.27Z",
    fill: "url(#paint416_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1140.63 1195.29L1137.52 1192.12L1190.89 1140.45L1193.99 1143.69L1140.63 1195.29Z",
    fill: "url(#paint417_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1129.2 1190.86L1126.13 1187.62L1185.85 1129.87L1188.95 1133.11L1129.2 1190.86Z",
    fill: "url(#paint418_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1117.92 1186.44L1114.81 1183.24L1180.82 1119.07L1183.92 1122.34L1117.92 1186.44Z",
    fill: "url(#paint419_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1183.44 838.948L1180.96 833.132L1435.69 725.041L1173.38 630.53L1175.46 624.567L1453 724.546L1183.44 838.948Z",
    fill: "url(#paint420_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1156.79 819.647L1154.08 814.042L1331.38 726.568L1226.54 671.564L1215.73 665.254L1159.86 636.029L1162.79 630.456L1218.73 659.617L1229.6 665.991L1345.11 726.568L1328.6 735.207L1295.57 751.126L1284.61 756.846L1272.93 762.314L1262 768.024L1238.27 779.244L1216.22 790.801L1204.34 796.174L1193.37 801.853L1156.79 819.647Z",
    fill: "url(#paint421_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1373.33 755.899H1368.87L1369.81 699.02L1374.24 699.083L1373.33 755.899Z",
    fill: "url(#paint422_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1362.22 760.744L1357.79 760.639L1358.7 694.973L1363.16 695.047L1362.22 760.744Z",
    fill: "url(#paint423_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1350.76 765.306L1346.37 765.138L1347.48 690.97H1351.94L1350.76 765.306Z",
    fill: "url(#paint424_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1339.61 770.184L1335.22 770.047L1336.41 686.998L1340.94 687.103L1339.61 770.184Z",
    fill: "url(#paint425_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1328.46 775.093L1324.04 774.988L1325.26 682.89L1329.75 682.953L1328.46 775.093Z",
    fill: "url(#paint426_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1129.06 483.037L1123.25 480.624L1226.94 224.03L974.638 342.782L971.92 336.967L1238.79 211.388L1129.06 483.037Z",
    fill: "url(#paint427_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1096.73 488.116L1090.74 486.061L1154.35 298.925L1041.21 334.144L1029.08 337.347L1017.44 341.15L1004.63 344.837L968.918 356.268L967.043 350.105L1027.27 331.226L1039.43 328.013L1163.93 289.275L1158.32 307.006L1138.19 365.571L1134.5 377.307L1125.58 402.043L1118.12 425.726L1113.73 437.884L1109.97 449.662L1096.73 488.116Z",
    fill: "url(#paint428_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1110.94 310.007L1088.44 286.872L1091.64 283.775L1114.08 306.9L1110.94 310.007Z",
    fill: "url(#paint429_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1170.1 371.659L1141.81 342.119L1145.02 339.021L1173.3 368.562L1170.1 371.659Z",
    fill: "url(#paint430_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1099.04 313.8L1077.71 291.887L1080.99 288.758L1102.24 310.671L1099.04 313.8Z",
    fill: "url(#paint431_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1165.6 382.953L1137.91 353.971L1141.18 350.937L1168.91 379.888L1165.6 382.953Z",
    fill: "url(#paint432_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1160.69 394.205L1133.59 365.981L1136.8 362.916L1163.94 391.139L1160.69 394.205Z",
    fill: "url(#paint433_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1156.23 405.562L1129.86 377.928L1133.1 374.831L1159.54 402.559L1156.23 405.562Z",
    fill: "url(#paint434_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1151.84 416.876L1125.4 389.991L1128.61 386.851L1155.01 413.811L1151.84 416.876Z",
    fill: "url(#paint435_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1146.83 428.793L1121.02 402.497L1124.25 399.389L1150 425.727L1146.83 428.793Z",
    fill: "url(#paint436_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1142.44 440.117L1117.21 414.412L1120.49 411.304L1145.65 437.02L1142.44 440.117Z",
    fill: "url(#paint437_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1137.25 451.368L1113.49 426.358L1116.76 423.218L1140.45 448.334L1137.25 451.368Z",
    fill: "url(#paint438_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1132.96 462.831L1109.1 438.337L1112.34 435.239L1136.16 459.765L1132.96 462.831Z",
    fill: "url(#paint439_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1128.61 474.746L1105.29 450.22L1108.51 447.186L1131.78 471.712L1128.61 474.746Z",
    fill: "url(#paint440_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1215.31 258.407L1194.55 236.399L1197.69 233.396L1218.44 255.383L1215.31 258.407Z",
    fill: "url(#paint441_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1210.96 269.775L1183.33 242.247L1186.36 239.012L1214.06 266.709L1210.96 269.775Z",
    fill: "url(#paint442_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1205.91 281.785L1172.61 247.156L1175.78 244.132L1209.18 278.688L1205.91 281.785Z",
    fill: "url(#paint443_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1201.42 293.036L1161.94 252.244L1165.15 249.115L1204.65 289.907L1201.42 293.036Z",
    fill: "url(#paint444_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1197.06 304.362L1151.22 257.301L1154.48 254.13L1200.27 301.223L1197.06 304.362Z",
    fill: "url(#paint445_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1192.15 315.613L1140.45 262.21L1143.69 259.071L1195.29 312.547L1192.15 315.613Z",
    fill: "url(#paint446_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1187.59 327.076L1129.86 267.299L1133.1 264.265L1190.89 323.936L1187.59 327.076Z",
    fill: "url(#paint447_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1183.19 338.253L1119.06 272.24L1122.3 269.174L1186.47 335.187L1183.19 338.253Z",
    fill: "url(#paint448_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1132.96 303.076L1108.51 277.328L1111.71 274.263L1136.16 300.074L1132.96 303.076Z",
    fill: "url(#paint449_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1178.18 350.348L1149.41 320.102L1152.55 316.973L1181.45 347.177L1178.18 350.348Z",
    fill: "url(#paint450_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1121.01 306.9L1097.08 282.417L1100.35 279.319L1124.25 303.803L1121.01 306.9Z",
    fill: "url(#paint451_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1173.86 361.557L1145.01 332.059L1148.22 328.961L1177.03 358.534L1173.86 361.557Z",
    fill: "url(#paint452_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.541 279.804L624.557 277.644L724.599 0L838.947 269.774L833.164 272.208L725.041 17.4568L630.541 279.804Z",
    fill: "url(#paint453_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M814.011 298.998L726.59 121.681L671.575 226.538L665.223 237.441L636.03 293.246L630.436 290.423L659.65 234.344L666.044 223.472L726.59 108.059L735.197 124.578L762.315 180.172L768.025 191.182L779.245 214.833L790.739 236.957L796.175 248.619L801.885 259.702L819.721 296.249L814.011 298.998Z",
    fill: "url(#paint454_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M703.827 160.208L671.537 159.797L671.579 155.331L703.891 155.752L703.827 160.208Z",
    fill: "url(#paint455_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M789.276 161.957L748.305 161.146L748.378 156.689L789.35 157.532L789.276 161.957Z",
    fill: "url(#paint456_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M698.072 171.323L667.51 170.87L667.594 166.477L698.167 166.824L698.072 171.323Z",
    fill: "url(#paint457_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M794.08 173.135L753.889 172.197L754.026 167.772L794.186 168.636L794.08 173.135Z",
    fill: "url(#paint458_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M798.537 184.524L759.389 183.797L759.526 179.298L798.653 180.067L798.537 184.524Z",
    fill: "url(#paint459_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M803.425 195.817L765.172 194.911L765.309 190.413L803.488 191.319L803.425 195.817Z",
    fill: "url(#paint460_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M808.397 206.921L770.639 206.405V202.012L808.397 202.359V206.921Z",
    fill: "url(#paint461_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M813.274 218.878L776.422 218.52V214L813.274 214.485V218.878Z",
    fill: "url(#paint462_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M818.186 229.983L782.135 229.604V225.074L818.186 225.495V229.983Z",
    fill: "url(#paint463_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M822.442 241.551L787.887 240.687L788.024 236.157L822.579 237.158L822.442 241.551Z",
    fill: "url(#paint464_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827.529 252.697L793.279 252.244V247.819L827.529 248.272V252.697Z",
    fill: "url(#paint465_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M832.787 264.264L798.959 263.358L799.106 258.976L832.893 259.808L832.787 264.264Z",
    fill: "url(#paint466_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M741.077 49.9579L710.926 49.1151L711.021 44.6587L741.225 45.4594L741.077 49.9579Z",
    fill: "url(#paint467_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M746.115 56.5742H706.977V61.1359H746.115V56.5742Z",
    fill: "url(#paint468_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M751.098 73.1243L702.941 72.1761L703.047 67.7197L751.098 68.6258V73.1243Z",
    fill: "url(#paint469_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M755.871 84.1975L699.002 83.3336L699.107 78.9404L755.871 79.7727V84.1975Z",
    fill: "url(#paint470_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M760.674 95.3437L695.008 94.4061L695.06 89.9497L760.674 90.8557V95.3437Z",
    fill: "url(#paint471_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M765.172 106.806L690.973 105.584V101.096L765.309 102.349L765.172 106.806Z",
    fill: "url(#paint472_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770.048 117.951L687.031 116.697L687.105 112.136L770.185 113.569L770.048 117.951Z",
    fill: "url(#paint473_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M774.99 129.067L682.881 127.813L682.997 123.356L774.99 124.61V129.067Z",
    fill: "url(#paint474_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M714.541 139.76L679.037 138.822L679.111 134.397L714.678 135.303L714.541 139.76Z",
    fill: "url(#paint475_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M779.868 141.118L738.033 140.181L738.118 135.682L779.942 136.63L779.868 141.118Z",
    fill: "url(#paint476_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M708.724 150.874L674.559 150.421L674.601 146.028L708.756 146.376L708.724 150.874Z",
    fill: "url(#paint477_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M784.745 152.234L743.5 151.707L743.532 147.324L784.745 147.809V152.234Z",
    fill: "url(#paint478_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.605 300.39C405.647 300.39 404.688 300.01 403.972 299.305C304.119 204.583 426.317 10.9043 431.616 2.81325C432.785 0.92746 435.156 0.379628 436.894 1.63331C438.674 2.67629 439.191 5.12046 438.063 6.89037C436.789 8.83937 313.959 203.403 409.25 293.795C410.714 295.259 410.767 297.693 409.302 299.231C408.639 300 407.617 300.379 406.605 300.379V300.39Z",
    fill: "url(#paint479_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M664.319 184.039C662.212 184.039 660.536 182.332 660.536 180.173V179.235L659.946 178.782L659.894 177.349C651.392 54.762 437.507 9.01829 435.326 8.50206C433.345 8.1228 431.934 6.13165 432.397 4.04568C432.85 1.99133 434.536 0.632292 436.896 1.0853C445.861 2.92896 657.523 48.2829 667.426 175.822C668.122 177.318 668.122 178.961 668.122 180.173C668.122 182.332 666.394 184.039 664.319 184.039Z",
    fill: "url(#paint480_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.753 193.1C418.53 193.1 417.509 192.194 417.509 190.94C416.276 138.096 453.391 79.1198 454.972 76.6124C455.614 75.4957 457.026 75.148 458.058 75.9171C459.133 76.5492 459.439 77.9398 458.722 78.9512C458.375 79.5412 420.785 139.36 422.039 190.877C422.039 192.131 421.006 193.11 419.858 193.11H419.753V193.1Z",
    fill: "url(#paint481_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.901 140.983C571.364 140.983 570.816 140.667 570.331 140.35H570.205L569.489 139.413C537.009 97.2616 458.395 80.0893 457.668 79.9524C456.415 79.7417 455.698 78.5196 455.93 77.3396C456.204 76.086 457.426 75.496 458.574 75.6013C461.819 76.2967 538.578 93.0581 572.386 135.905H574.145V138.76C574.145 139.982 573.134 140.993 571.901 140.993V140.983Z",
    fill: "url(#paint482_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.738 220.059C389.738 220.059 388.801 175.506 402.507 133.113C408.849 111.789 418.215 91.4881 426.601 77.0655C435.661 62.9905 441.771 53.551 441.771 53.551C442.92 51.8443 445.238 51.2859 447.05 52.4343C448.735 53.551 449.283 55.9214 448.124 57.7335L448.04 57.8388L447.713 58.2602C447.713 58.2602 441.455 67.173 432.111 80.3419C423.335 94.0693 413.263 113.507 406.163 134.166C390.728 175.517 389.759 220.07 389.759 220.07L389.738 220.059Z",
    fill: "url(#paint483_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615.717 122.314C615.717 122.314 582.742 92.3937 542.16 75.1793C522.343 66.0558 501.263 60.0297 485.365 56.9218C469.288 54.6251 458.574 53.0554 458.574 53.0554L457.963 52.9817C455.93 52.6656 454.465 50.7482 454.771 48.6939C454.96 46.6079 456.931 45.1435 459.017 45.449H459.196C459.196 45.449 470.205 47.535 486.703 50.5691C502.853 54.4355 524.103 61.7469 543.856 71.7132C584.037 91.0452 615.727 122.293 615.727 122.293L615.717 122.314Z",
    fill: "url(#paint484_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.026 652.612C57.9336 652.612 8.29182 432.69 6.21639 423.219C5.7107 421.228 7.04867 419.216 9.14517 418.763C11.2206 418.341 13.1907 419.49 13.6753 421.692C14.202 423.851 64.065 644.995 193.205 644.995C194.238 644.995 194.891 645.1 196.324 644.921C198.325 644.921 200 646.554 200.085 648.682C200.169 650.737 198.504 652.549 196.355 652.612H193.026Z",
    fill: "url(#paint485_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8709 425.421C9.6383 425.421 8.39515 424.757 7.67876 423.714C6.53042 421.976 6.96237 419.606 8.77442 418.457C16.423 413.337 198.176 295.702 295.384 378.982C297.059 379.614 298.376 380.973 299.092 381.7C300.472 383.27 300.378 385.672 298.829 387.105C297.312 388.569 294.878 388.39 293.498 386.894C292.887 386.23 292.645 386.062 292.561 386.062L291.338 385.956L291.012 385.335C198.387 304.688 14.8216 423.546 12.9569 424.768C12.3248 425.189 11.5241 425.432 10.8709 425.432V425.421Z",
    fill: "url(#paint486_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.934 566.951C130.291 566.951 129.764 566.772 129.385 566.319C91.1213 529.74 75.5503 461.915 74.9392 459.028C74.6443 457.775 75.3923 456.626 76.6249 456.416C77.9629 456.1 78.9215 456.869 79.2376 458.017C79.4272 458.712 95.2089 527.486 132.472 563.147C133.325 563.99 133.325 565.339 132.472 566.319C132.093 566.698 131.46 566.951 130.944 566.951H130.934Z",
    fill: "url(#paint487_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.0356 459.797C77.2349 459.797 76.5396 459.481 76.1709 458.786C75.4756 457.774 75.7705 456.415 76.803 455.794C79.4368 454.056 136.653 417.298 188.244 417.298C192.11 417.298 196.008 417.509 199.727 417.93L200.949 416.255L203.193 418.763C204.047 419.669 204.047 421.059 203.12 421.828C202.751 422.25 202.266 422.461 201.834 422.461L201.729 422.598L200.402 422.461C147.536 415.634 79.8687 459.039 79.205 459.492C78.7836 459.766 78.4043 459.808 78.0356 459.808V459.797Z",
    fill: "url(#paint488_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.289 606.594C130.289 606.594 98.0831 575.768 77.7607 535.945C67.1834 516.539 59.3979 495.606 55.1206 479.413C51.623 463.073 49.1999 452.064 49.1999 452.064C48.8206 450.009 50.1375 448.018 52.1287 447.607C54.183 447.081 56.269 448.44 56.6588 450.536C56.6588 450.536 56.7325 450.599 56.7325 450.641L56.8063 451.231C56.8063 451.231 58.671 461.925 61.3891 477.949C64.8868 493.73 71.6293 514.664 81.2057 534.206C99.4737 574.303 130.31 606.594 130.31 606.594H130.289Z",
    fill: "url(#paint489_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.019 377.623C221.019 377.623 176.476 379.783 135.589 396.334C115.035 403.993 95.819 414.517 82.4287 423.535C69.4389 433.322 60.7263 439.802 60.7263 439.802L60.2943 440.118C58.6614 441.477 56.2699 441.055 54.9319 439.454C53.6993 437.747 54.0997 435.345 55.7326 434.092C55.7853 434.092 55.8696 434.028 55.8696 434.028C55.8696 434.028 65.0878 427.655 78.9311 418.215C93.2168 409.502 113.265 399.578 134.336 392.72C176.403 377.876 221.03 377.634 221.03 377.634L221.019 377.623Z",
    fill: "url(#paint490_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.557 1088.3C108.397 1088.3 8.60733 1025.19 2.79191 1021.46C1.03254 1020.31 0.495245 1017.94 1.64358 1016.2C2.71817 1014.42 5.10965 1014.01 6.94277 1015.02C8.83911 1016.38 203.434 1139.21 293.837 1043.94C295.196 1042.37 297.619 1042.34 299.241 1043.79C300.706 1045.26 300.811 1047.63 299.347 1049.09C272.05 1077.97 236.525 1088.31 199.578 1088.31L199.557 1088.3Z",
    fill: "url(#paint491_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.89905 1020.87C4.65674 1020.87 4.42497 1020.87 4.12998 1020.76C2.07562 1020.31 0.716584 1018.39 1.14853 1016.31C3.01325 1007.29 48.2829 795.553 175.853 785.797C179.952 783.88 184.166 785.481 184.166 788.863C184.166 790.949 182.427 792.655 180.352 792.655H178.972L177.96 793.488L177.318 793.245C54.7094 801.81 9.08152 1015.64 8.60743 1017.76C8.2071 1019.6 6.66896 1020.86 4.89905 1020.86V1020.87Z",
    fill: "url(#paint492_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.328 1035.63C136.21 1035.63 79.0254 999.715 76.6234 998.145C75.5382 997.481 75.2433 996.027 75.928 995.121C76.5075 994.036 77.9613 993.657 78.92 994.457C79.5521 994.805 137.496 1031.25 188.423 1031.25C189.244 1031.25 190.003 1031.17 190.846 1031.17C192.099 1031.17 193.111 1032.15 193.111 1033.33C193.195 1034.55 192.184 1035.6 190.951 1035.63H188.317H188.328Z",
    fill: "url(#paint493_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.751 997.28C77.6245 997.28 77.456 997.28 77.319 997.217C76.0969 996.975 75.3805 995.753 75.5912 994.573C76.2866 991.37 93.027 914.59 135.895 880.73V879.265L138.507 878.96H138.718C139.835 878.96 140.857 879.834 140.899 880.877C141.004 881.636 140.772 882.268 140.362 882.795V883.005L139.434 883.638C97.2516 916.075 80.1424 994.763 79.9317 995.458C79.721 996.575 78.7834 997.302 77.751 997.302V997.28Z",
    fill: "url(#paint494_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.144 1063.29C220.144 1063.29 175.559 1064.23 133.092 1050.55C111.895 1044.35 91.4993 1034.98 77.1083 1026.58C63.0017 1017.46 53.5411 1011.43 53.5411 1011.43C51.8133 1010.31 51.276 1007.91 52.4243 1006.17C53.5411 1004.47 55.9431 1003.91 57.7235 1005.06H57.7973L58.2503 1005.4C58.2503 1005.4 67.1841 1011.75 80.4374 1021.15C94.0383 1029.82 113.57 1039.86 134.241 1046.96C175.559 1062.4 220.144 1063.3 220.144 1063.3V1063.29Z",
    fill: "url(#paint495_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.293 837.283C122.293 837.283 92.4051 870.31 75.159 910.955C66.0987 930.846 59.9883 951.884 56.891 967.877C54.5416 983.901 53.0246 994.562 53.0246 994.562L52.9403 995.226C52.6242 997.28 50.6542 998.713 48.5893 998.429C46.5876 998.144 45.0916 996.269 45.3971 994.141V993.972C45.3971 993.972 47.5252 982.963 50.591 966.454C54.489 950.293 61.6845 929.076 71.735 909.322C90.9512 869.057 122.304 837.283 122.304 837.283H122.293Z",
    fill: "url(#paint496_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.47 1446.97C420.711 1446.97 419.141 1445.79 418.741 1443.98C418.288 1441.99 419.573 1439.91 421.722 1439.53C423.935 1439 648.418 1388.35 644.973 1257.06C644.889 1254.9 646.575 1253.09 648.65 1253.09H648.755C650.831 1253.09 652.559 1254.72 652.643 1256.77C656.193 1394.37 432.795 1444.82 423.282 1446.97H422.481H422.47Z",
    fill: "url(#paint497_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.722 1446.04C420.489 1446.04 419.246 1445.52 418.435 1444.4C413.431 1436.67 295.69 1255.11 379.076 1157.8C379.508 1156.48 380.435 1155.51 381.151 1154.6C382.51 1153.14 385.196 1152.73 386.692 1154.25C388.241 1155.61 388.557 1157.8 387.177 1159.34C386.45 1160.11 386.24 1160.39 386.06 1160.6L385.934 1161.92L385.302 1162.06C304.645 1254.9 423.618 1438.38 424.861 1440.16C426.031 1442 425.504 1444.3 423.797 1445.41C423.102 1445.87 422.386 1446.05 421.722 1446.05V1446.04Z",
    fill: "url(#paint498_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.574 1378.24C457.457 1378.24 456.551 1377.52 456.414 1376.46C456.098 1375.24 456.846 1374.06 458.047 1373.85C458.711 1373.64 527.558 1358.04 563.146 1320.79C563.978 1319.89 565.443 1319.89 566.286 1320.69C567.171 1321.53 567.223 1322.92 566.391 1323.83C529.834 1362.15 461.914 1377.55 459.027 1378.18C458.89 1378.24 458.711 1378.24 458.574 1378.24Z",
    fill: "url(#paint499_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.668 1377.3C456.846 1377.3 456.203 1376.99 455.782 1376.4C453.917 1373.54 411.45 1307.38 417.982 1253.25L416.549 1251.86L418.687 1249.87C419.562 1249.04 420.9 1249.04 421.837 1250.01C422.217 1250.43 422.449 1250.98 422.449 1251.55L422.628 1251.79L422.449 1252.8C415.485 1305.43 459.006 1373.26 459.501 1373.89C460.122 1374.93 459.817 1376.29 458.805 1376.99C458.384 1377.23 458.036 1377.3 457.657 1377.3H457.668Z",
    fill: "url(#paint500_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.572 1322.82C606.572 1322.82 575.746 1354.97 536.05 1375.31C516.612 1385.93 495.584 1393.67 479.392 1397.99C463.073 1401.47 452.063 1403.87 452.063 1403.87C450.083 1404.3 448.039 1402.94 447.565 1400.95C447.091 1398.89 448.418 1396.84 450.525 1396.42H450.704L451.21 1396.31C451.21 1396.31 461.924 1394.5 477.927 1391.81C493.74 1388.19 514.642 1381.57 534.259 1371.98C574.377 1353.63 606.583 1322.8 606.583 1322.8L606.572 1322.82Z",
    fill: "url(#paint501_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.623 1232.08C377.623 1232.08 379.804 1276.63 396.312 1317.53C403.972 1338.05 414.496 1357.28 423.588 1370.72C433.344 1383.75 439.823 1392.45 439.823 1392.45L440.139 1392.8C441.466 1394.51 441.076 1396.91 439.422 1398.21C437.737 1399.43 435.324 1399.11 434.113 1397.37C434.113 1397.37 434.028 1397.34 434.028 1397.2C434.028 1397.2 427.686 1388.1 418.226 1374.2C409.481 1359.95 399.536 1339.82 392.762 1318.77C377.834 1276.69 377.623 1232.07 377.623 1232.07V1232.08Z",
    fill: "url(#paint502_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1018.25 1452.06C1017.52 1452.06 1016.83 1451.93 1016.19 1451.54C1014.32 1450.39 1013.9 1447.99 1014.94 1446.28C1016.27 1444.26 1139.23 1249.73 1043.92 1159.34C1042.4 1157.88 1042.32 1155.51 1043.79 1154.01C1045.32 1152.44 1047.65 1152.44 1049.12 1153.77C1149.06 1248.6 1026.75 1442.17 1021.49 1450.4C1020.72 1451.48 1019.47 1452.07 1018.26 1452.07L1018.25 1452.06Z",
    fill: "url(#paint503_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1017.1 1451.96C1016.83 1451.96 1016.51 1451.96 1016.26 1451.93C1007.24 1450.08 795.639 1404.93 785.852 1277.29C785.157 1276.01 785.157 1274.47 785.051 1273.5C785.02 1271.37 786.621 1269.32 788.675 1269.26C790.456 1268.97 792.605 1270.47 792.647 1272.6C792.647 1273.5 792.647 1274.06 792.71 1274.23L793.585 1275.17L793.269 1275.97C801.771 1398.48 1015.66 1444.09 1017.72 1444.5C1019.91 1444.92 1021.17 1446.97 1020.79 1448.95C1020.44 1450.73 1018.84 1451.95 1017.1 1451.95V1451.96Z",
    fill: "url(#paint504_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M996.342 1377.55C995.857 1377.55 995.436 1377.41 995.12 1377.2C994.035 1376.54 993.761 1375.18 994.456 1374.18C994.804 1373.54 1032.39 1313.81 1031.14 1262.28C1031.14 1261.03 1032.08 1260.05 1033.34 1260.02H1033.4C1034.58 1260.02 1035.56 1260.99 1035.67 1262.13C1036.89 1315.05 999.787 1374 998.185 1376.46C997.669 1377.19 997.005 1377.55 996.342 1377.55Z",
    fill: "url(#paint505_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M995.015 1377.55C994.805 1377.55 994.668 1377.55 994.531 1377.52C991.254 1376.79 914.548 1360.13 880.751 1317.21H878.939V1314.39C878.875 1312.47 881.414 1311.64 882.773 1312.82H882.984L883.574 1313.66C916.012 1355.85 994.668 1372.95 995.437 1373.15C996.69 1373.37 997.386 1374.51 997.175 1375.77C996.933 1376.78 996.058 1377.55 995.015 1377.55Z",
    fill: "url(#paint506_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1063.29 1233.02C1063.29 1233.02 1064.27 1277.64 1050.61 1320.07C1044.34 1341.38 1034.98 1361.66 1026.58 1376.08C1017.46 1390.23 1011.39 1399.52 1011.39 1399.52C1010.34 1401.4 1007.94 1401.89 1006.1 1400.67C1004.42 1399.52 1003.91 1397.2 1005.06 1395.48V1395.37L1005.48 1394.85C1005.48 1394.85 1011.75 1386 1021.08 1372.72C1029.86 1359.1 1039.82 1339.56 1047 1318.9C1062.39 1277.62 1063.29 1232.99 1063.29 1232.99V1233.02Z",
    fill: "url(#paint507_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M837.283 1330.87C837.283 1330.87 870.374 1360.79 910.998 1378C930.857 1387.09 951.895 1393.22 967.919 1396.32C983.912 1398.59 994.605 1400.11 994.605 1400.11H995.237C997.323 1400.46 998.724 1402.41 998.514 1404.51C998.197 1406.62 996.217 1407.98 994.162 1407.77C994.057 1407.77 993.983 1407.67 993.983 1407.67C993.983 1407.67 982.974 1405.61 966.466 1402.58C950.336 1398.65 929.087 1391.51 909.333 1381.43C869.068 1362.21 837.294 1330.85 837.294 1330.85L837.283 1330.87Z",
    fill: "url(#paint508_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1443.21 1034.45C1441.4 1034.45 1439.8 1033.23 1439.45 1031.46C1438.89 1029.19 1389.01 808.121 1259.97 808.121C1258.93 808.121 1258.16 808.469 1256.84 808.121C1254.89 808.121 1253.07 806.583 1253.07 804.497C1253.07 802.411 1254.64 800.631 1256.84 800.631C1257.88 800.525 1258.92 800.525 1260.14 800.525C1395.24 800.525 1444.8 1020.45 1446.9 1029.81C1447.29 1031.94 1446.03 1033.92 1443.97 1034.37C1443.7 1034.44 1443.41 1034.44 1443.2 1034.44L1443.21 1034.45Z",
    fill: "url(#paint509_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1246.14 1103.91C1214.06 1103.91 1183.12 1095.83 1157.9 1074.23C1156.57 1073.74 1155.6 1072.9 1154.97 1072.28C1153.37 1070.89 1152.92 1068.23 1154.24 1066.71C1155.6 1065 1157.69 1064.55 1159.23 1065.83C1159.29 1065.94 1159.99 1066.53 1160.06 1066.53L1161.21 1066.71L1162.22 1067.93C1254.96 1148.26 1438.29 1029.48 1440.14 1028.33C1441.98 1027.14 1444.35 1027.59 1445.43 1029.3C1446.61 1031.04 1446.12 1033.51 1444.38 1034.55C1438.67 1038.39 1337.64 1103.91 1246.13 1103.91H1246.14Z",
    fill: "url(#paint510_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1376.05 996.859C1375.01 996.859 1374.1 996.026 1373.86 995.12C1373.68 994.457 1357.97 925.515 1320.73 890.053C1319.86 889.179 1319.79 887.756 1320.59 886.819C1321.56 886.018 1322.96 885.913 1323.8 886.819C1362.05 923.323 1377.59 991.296 1378.21 994.141C1378.42 995.363 1377.62 996.543 1376.47 996.796C1376.33 996.859 1376.16 996.859 1376.05 996.859Z",
    fill: "url(#paint511_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1251.85 1036.33L1250.01 1034.45C1249.07 1033.54 1249.07 1032.22 1250.01 1031.35C1250.39 1030.93 1250.91 1030.69 1251.55 1030.69H1251.61L1251.75 1030.55L1252.79 1030.69C1305.6 1037.97 1373.25 994.215 1373.94 993.657C1375.06 992.93 1376.24 993.235 1377.01 994.289C1377.6 995.363 1377.28 996.691 1376.39 997.386C1373.67 999.051 1316.43 1035.91 1264.84 1035.91C1260.8 1035.91 1257.03 1035.7 1253.06 1035.29L1251.84 1036.33H1251.85Z",
    fill: "url(#paint512_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1322.79 846.48C1322.79 846.48 1355.04 877.38 1375.32 917.161C1385.94 936.598 1393.68 957.574 1398.04 973.735C1401.48 990.106 1403.93 1001.01 1403.93 1001.01C1404.27 1003.1 1402.96 1005.12 1400.97 1005.57C1398.99 1005.99 1396.83 1004.77 1396.51 1002.67V1002.46L1396.3 1001.95C1396.3 1001.95 1394.52 991.286 1391.84 975.199C1388.29 959.386 1381.57 938.516 1372.02 918.836C1353.62 878.708 1322.8 846.48 1322.8 846.48H1322.79Z",
    fill: "url(#paint513_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1232.11 1075.56C1232.11 1075.56 1276.63 1073.26 1317.53 1056.81C1338.08 1049.22 1357.24 1038.63 1370.75 1029.51C1383.75 1019.86 1392.45 1013.38 1392.45 1013.38L1392.84 1012.96C1394.52 1011.73 1396.95 1012.12 1398.18 1013.73C1399.43 1015.46 1399.11 1017.77 1397.41 1019.09C1397.41 1019.09 1397.3 1019.12 1397.23 1019.12C1397.23 1019.12 1388.1 1025.49 1374.24 1034.98C1359.95 1043.72 1339.82 1053.61 1318.78 1060.44C1276.7 1075.28 1232.11 1075.56 1232.11 1075.56Z",
    fill: "url(#paint514_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1448.3 438.653C1447.61 438.653 1446.91 438.474 1446.28 438.063C1444.26 436.809 1249.81 313.8 1159.38 409.218C1157.84 410.682 1155.54 410.893 1154.04 409.281C1152.48 407.89 1152.41 405.488 1153.8 403.992C1248.56 304.182 1442.17 426.421 1450.4 431.689C1452.14 432.764 1452.66 435.166 1451.55 436.883C1450.82 438.063 1449.56 438.663 1448.31 438.663L1448.3 438.653Z",
    fill: "url(#paint515_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1273.28 668.12C1271.36 668.12 1269.35 666.487 1269.31 664.432C1269.17 662.378 1270.53 660.598 1272.62 660.492C1273.56 660.461 1274.19 660.461 1274.28 660.461L1275.22 659.618L1276.02 659.829C1398.47 651.327 1444.07 437.431 1444.46 435.24C1444.94 433.249 1446.83 431.858 1448.95 432.311C1451.07 432.701 1452.39 434.713 1451.91 436.81C1450.06 445.87 1404.92 657.458 1277.31 667.424C1275.92 668.014 1274.53 668.362 1273.26 668.12H1273.28Z",
    fill: "url(#paint516_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1375.31 459.028C1374.86 459.028 1374.59 458.849 1374.17 458.712C1373.53 458.259 1315.6 421.954 1264.64 421.954C1263.95 421.954 1263.07 421.954 1262.35 421.986H1262.21C1261.09 421.986 1260.05 420.975 1259.97 419.795C1259.97 418.615 1260.88 417.498 1262.13 417.498H1264.72C1316.9 417.498 1374.1 453.381 1376.47 454.908C1377.59 455.604 1377.89 456.963 1377.17 457.943C1376.71 458.638 1376.05 459.028 1375.32 459.028H1375.31Z",
    fill: "url(#paint517_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1317.21 574.198H1314.46C1313.21 574.198 1312.17 573.187 1312.17 571.965C1312.17 571.375 1312.41 570.785 1312.83 570.426V570.247L1313.67 569.552C1355.93 537.083 1373.03 458.459 1373.13 457.626C1373.48 456.541 1374.8 455.846 1375.78 455.888C1377.03 456.204 1377.73 457.384 1377.52 458.532C1376.79 461.809 1360.16 538.652 1317.21 572.449V574.187V574.198Z",
    fill: "url(#paint518_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1233.05 389.781C1233.05 389.781 1277.6 388.769 1320.1 402.57C1341.38 408.87 1361.69 418.205 1376.05 426.538C1390.26 435.661 1399.53 441.803 1399.53 441.803C1401.41 442.952 1401.9 445.248 1400.76 447.029C1399.53 448.767 1397.24 449.294 1395.56 448.146C1395.49 448.146 1395.38 448.04 1395.38 448.04L1394.93 447.724C1394.93 447.724 1386.02 441.487 1372.77 432.048C1359.12 423.304 1339.61 413.274 1318.92 406.1C1277.6 390.845 1233.05 389.802 1233.05 389.802V389.781Z",
    fill: "url(#paint519_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1330.87 615.834C1330.87 615.834 1360.79 582.732 1378 542.151C1387.06 522.26 1393.19 501.253 1396.29 485.303C1398.66 469.205 1400.16 458.48 1400.16 458.48V457.964C1400.47 455.878 1402.42 454.414 1404.51 454.688C1406.59 455.004 1408.03 456.879 1407.78 459.039C1407.78 459.039 1407.72 459.102 1407.72 459.218C1407.72 459.218 1405.67 470.153 1402.6 486.672C1398.7 502.907 1391.53 524.157 1381.46 543.868C1362.16 584.176 1330.88 615.844 1330.88 615.844L1330.87 615.834Z",
    fill: "url(#paint520_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M804.464 200.063C802.378 200.063 800.63 198.461 800.63 196.375C797.005 58.7439 1020.31 8.39639 1029.85 6.23668C1031.94 5.81527 1033.96 7.1427 1034.45 9.22867C1034.79 11.2514 1033.61 13.2742 1031.46 13.685C1029.22 14.2118 804.749 64.8227 808.162 196.154C808.225 198.282 806.624 199.989 804.538 200.052H804.464V200.063Z",
    fill: "url(#paint521_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1068.9 299.694C1068.02 299.694 1067.26 299.378 1066.57 298.852C1065 297.461 1064.62 295.375 1065.94 293.805C1066.74 292.899 1067.05 292.625 1067.19 292.415L1067.33 291.266L1067.96 290.961C1148.43 198.293 1029.46 14.7812 1028.32 13.0008C1027.06 11.115 1027.62 8.86044 1029.3 7.66997C1031.11 6.58485 1033.61 6.97464 1034.58 8.74455C1039.67 16.4036 1157.41 198.146 1074.15 295.27C1073.7 296.629 1072.76 297.566 1072.13 298.304C1071.36 299.241 1070.11 299.694 1068.89 299.694H1068.9Z",
    fill: "url(#paint522_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M888.377 133.112C887.851 133.112 887.292 132.933 886.881 132.448C885.975 131.648 885.944 130.183 886.776 129.351C923.354 91.0978 991.18 75.4953 994.035 74.9053C995.288 74.6946 996.331 75.3583 996.679 76.612C996.995 77.7603 996.194 78.9508 995.078 79.2247C994.382 79.4038 925.472 95.2171 890.01 132.385C889.589 132.807 888.967 133.112 888.377 133.112Z",
    fill: "url(#paint523_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1032.98 203.793C1032.35 203.793 1031.8 203.583 1031.38 203.203C1030.93 202.782 1030.79 202.266 1030.69 201.739L1030.55 201.528L1030.69 200.485C1037.59 147.641 994.14 79.8471 993.656 79.2255C992.992 78.1825 993.308 76.7919 994.277 76.1598C995.426 75.4644 996.679 75.7067 997.385 76.7919C999.166 79.5415 1041.62 145.629 1035.29 199.864L1036.62 201.117L1034.46 203.203C1034.04 203.583 1033.49 203.793 1032.99 203.793H1032.98Z",
    fill: "url(#paint524_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M846.512 130.32C846.512 130.32 877.411 98.1352 917.129 77.7496C936.63 67.1618 957.605 59.3868 973.766 55.0358C990.106 51.5908 1001.01 49.1783 1001.01 49.1783C1003.1 48.8306 1005.15 50.1159 1005.6 52.107C1005.99 54.1298 1004.77 56.2474 1002.67 56.5634C1002.57 56.5634 1002.57 56.7004 1002.46 56.7004L1001.98 56.7741C1001.98 56.7741 991.244 58.6599 975.23 61.3675C959.48 64.8125 938.515 71.5444 918.867 81.1841C878.802 99.4732 846.512 130.299 846.512 130.299V130.32Z",
    fill: "url(#paint525_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1075.56 220.996C1075.56 220.996 1073.29 176.443 1056.81 135.577C1049.22 115.023 1038.7 95.7965 1029.54 82.4168C1019.82 69.3848 1013.34 60.746 1013.34 60.746L1012.96 60.2614C1011.73 58.66 1012.11 56.258 1013.76 54.9306C1015.43 53.6769 1017.73 54.0983 1019.06 55.6575C1019.06 55.7945 1019.16 55.8682 1019.16 55.8682C1019.16 55.8682 1025.53 65.097 1034.97 78.9297C1043.72 93.1416 1053.64 113.243 1060.44 134.355C1075.35 176.369 1075.56 220.996 1075.56 220.996Z",
    fill: "url(#paint526_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M934.121 246.881C934.121 252.422 929.528 256.878 924.018 256.878C918.508 256.878 913.988 252.422 913.988 246.881C913.988 241.339 918.582 236.851 924.018 236.851C929.454 236.851 934.121 241.307 934.121 246.881Z",
    fill: "url(#paint527_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M898.521 260.639C898.521 266.255 893.886 270.711 888.387 270.711C882.887 270.711 878.389 266.255 878.389 260.639C878.389 255.024 882.919 250.568 888.387 250.568C893.854 250.568 898.521 255.066 898.521 260.639Z",
    fill: "url(#paint528_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M951.503 279.213C951.503 284.712 946.942 289.285 941.432 289.285C935.922 289.285 931.402 284.723 931.402 279.213C931.402 273.703 935.996 269.184 941.432 269.184C946.868 269.184 951.503 273.682 951.503 279.213Z",
    fill: "url(#paint529_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M866.127 279.213C866.127 284.712 861.597 289.285 856.024 289.285C850.45 289.285 845.994 284.723 845.994 279.213C845.994 273.703 850.524 269.184 856.024 269.184C861.523 269.184 866.127 273.682 866.127 279.213Z",
    fill: "url(#paint530_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M958.574 313.979C958.574 319.583 953.98 324.05 948.47 324.05C942.96 324.05 938.367 319.594 938.367 313.979C938.367 308.363 942.96 304.044 948.47 304.044C953.98 304.044 958.574 308.469 958.574 313.979Z",
    fill: "url(#paint531_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M845.573 310.039C845.573 315.539 841.011 320.111 835.501 320.111C829.991 320.111 825.43 315.549 825.43 310.039C825.43 304.529 829.991 300.01 835.501 300.01C841.011 300.01 845.573 304.498 845.573 310.039Z",
    fill: "url(#paint532_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M956.034 345.227C956.034 350.8 951.472 355.33 945.962 355.33C940.452 355.33 935.891 350.8 935.891 345.227C935.891 339.653 940.389 335.26 945.962 335.26C951.535 335.26 956.034 339.717 956.034 345.227Z",
    fill: "url(#paint533_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.081 240.614C538.031 244.512 538.031 250.885 534.081 254.826C530.14 258.755 523.714 258.755 519.847 254.826C515.897 250.885 516.002 244.512 519.847 240.614C523.714 236.853 530.14 236.716 534.081 240.614Z",
    fill: "url(#paint534_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.741 275.548C522.639 279.488 522.576 285.925 518.688 289.791C514.79 293.658 508.469 293.732 504.508 289.791C500.536 285.925 500.536 279.478 504.508 275.611C508.459 271.639 514.78 271.639 518.741 275.537V275.548Z",
    fill: "url(#paint535_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.352 251.202C573.303 255.068 573.219 261.547 569.352 265.382C565.412 269.312 559.028 269.312 555.067 265.487C551.116 261.547 551.116 255.068 555.067 251.202C559.017 247.335 565.412 247.23 569.352 251.202Z",
    fill: "url(#paint536_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.932 311.641C512.882 315.508 512.882 321.882 508.932 325.79C504.981 329.762 498.607 329.762 494.646 325.79C490.779 321.892 490.779 315.518 494.646 311.641C498.597 307.67 504.97 307.67 508.932 311.641Z",
    fill: "url(#paint537_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.88 270.881C602.799 274.747 602.747 281.121 598.754 284.988C594.919 288.959 588.566 288.959 584.605 285.019C580.718 281.121 580.718 274.747 584.637 270.881C588.556 266.941 594.908 266.835 598.87 270.881H598.88Z",
    fill: "url(#paint538_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.212 347.872C520.079 351.802 520.079 358.218 516.212 362.116C512.272 366.088 505.835 366.088 501.969 362.116C497.997 358.218 498.071 351.907 501.969 347.936C505.835 344.006 512.283 343.932 516.212 347.872Z",
    fill: "url(#paint539_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.129 294.785C623.08 298.62 623.027 305.057 619.129 308.892C615.284 312.864 608.921 312.864 604.886 308.997C601.04 305.068 601.072 298.62 604.886 294.785C608.931 290.845 615.284 290.814 619.129 294.785Z",
    fill: "url(#paint540_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.88 519.057C252.485 519.057 256.962 523.556 256.962 529.129C256.857 534.628 252.485 539.2 246.88 539.2C241.276 539.2 236.809 534.639 236.809 529.129C236.809 523.619 241.391 519.057 246.88 519.057Z",
    fill: "url(#paint541_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.744 554.655C266.212 554.655 270.742 559.217 270.742 564.758C270.742 570.3 266.212 574.788 260.744 574.788C255.276 574.788 250.609 570.258 250.641 564.758C250.641 559.217 255.097 554.655 260.744 554.655Z",
    fill: "url(#paint542_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.275 501.6C284.816 501.568 289.252 506.161 289.252 511.671C289.336 517.213 284.806 521.701 279.275 521.701C273.744 521.701 269.245 517.202 269.203 511.703C269.235 506.161 273.681 501.568 279.275 501.6Z",
    fill: "url(#paint543_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.275 586.988C284.816 586.988 289.252 591.486 289.346 597.059C289.262 602.559 284.785 607.131 279.169 607.131C273.554 607.131 269.245 602.569 269.203 597.165C269.203 591.56 273.681 586.998 279.275 586.998V586.988Z",
    fill: "url(#paint544_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.957 494.563C319.604 494.563 324.039 499.125 324.039 504.635C324.039 510.144 319.594 514.706 313.957 514.706C308.321 514.706 304.033 510.25 304.033 504.635C304.033 499.019 308.479 494.563 313.957 494.563Z",
    fill: "url(#paint545_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.017 607.637C315.612 607.637 320.068 612.019 320.068 617.666C320.068 623.313 315.612 627.769 310.017 627.769C304.423 627.769 300.072 623.176 300.072 617.603C300.072 612.03 304.518 607.637 310.017 607.637Z",
    fill: "url(#paint546_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.238 497.144C350.832 497.144 355.309 501.6 355.309 507.215C355.309 512.83 350.832 517.287 345.238 517.287C339.643 517.287 335.261 512.725 335.166 507.215C335.25 501.6 339.728 497.144 345.238 497.144Z",
    fill: "url(#paint547_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.676 918.972C244.521 915.179 250.948 915.137 254.92 918.972C258.712 923.018 258.807 929.286 254.846 933.216C250.906 937.187 244.521 937.187 240.665 933.216C236.799 929.286 236.799 923.007 240.665 918.972H240.676Z",
    fill: "url(#paint548_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.621 934.333C279.572 930.467 285.935 930.53 289.717 934.512C293.657 938.347 293.826 944.615 289.896 948.587C285.851 952.632 279.498 952.559 275.631 948.661C271.712 944.794 271.586 938.347 275.631 934.343L275.621 934.333Z",
    fill: "url(#paint549_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.234 883.711C255.101 879.813 261.527 879.95 265.288 883.89C269.334 887.694 269.334 894.099 265.467 897.997C261.422 901.969 255.101 901.969 251.234 897.997C247.315 894.099 247.284 887.757 251.234 883.711Z",
    fill: "url(#paint550_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.643 944.152C315.531 940.18 321.767 940.391 325.887 944.152C329.669 948.197 329.753 954.497 325.887 958.543C321.862 962.378 315.52 962.378 311.643 958.543C307.65 954.497 307.65 948.197 311.643 944.152Z",
    fill: "url(#paint551_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.881 854.213C274.748 850.273 281.143 850.452 285.072 854.392C288.854 858.153 289.023 864.601 285.072 868.499C281.132 872.428 274.748 872.365 270.881 868.499C266.931 864.601 266.857 858.153 270.881 854.213Z",
    fill: "url(#paint552_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.903 936.946C351.854 933.048 358.112 933.111 362.136 936.946C366.003 940.991 366.087 947.26 362.136 951.189C358.186 955.161 351.896 955.087 347.946 951.189C344.079 947.26 343.953 940.918 347.914 936.946H347.903Z",
    fill: "url(#paint553_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.68 834.006C298.62 830.066 305.046 830.066 308.913 834.006C312.863 837.799 312.863 844.247 308.913 848.25C305.046 852.148 298.62 852.043 294.753 848.25C290.908 844.247 290.813 837.799 294.68 834.006Z",
    fill: "url(#paint554_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.141 1206.12C519.141 1200.79 523.586 1196.15 529.139 1196.15C534.691 1196.15 539.21 1200.68 539.157 1206.12C539.157 1211.8 534.648 1216.3 529.139 1216.3C523.629 1216.3 519.141 1211.8 519.141 1206.12Z",
    fill: "url(#paint555_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.633 1192.36C554.633 1186.75 559.195 1182.36 564.704 1182.36C570.204 1182.39 574.776 1186.75 574.776 1192.36C574.776 1197.96 570.299 1202.43 564.799 1202.36C559.205 1202.42 554.643 1198.01 554.643 1192.36H554.633Z",
    fill: "url(#paint556_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.674 1173.83C501.568 1168.29 506.151 1163.94 511.65 1163.94C517.139 1163.73 521.722 1168.29 521.722 1173.83C521.722 1179.37 517.139 1183.99 511.724 1183.99C506.151 1183.89 501.674 1179.46 501.674 1173.83Z",
    fill: "url(#paint557_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.018 1173.83C587.018 1168.29 591.495 1163.94 597.089 1163.73C602.589 1163.94 607.171 1168.32 607.192 1173.93C607.171 1179.48 602.599 1184.01 597.142 1184.07C591.59 1183.99 587.07 1179.43 587.018 1173.83Z",
    fill: "url(#paint558_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.615 1139.12C494.615 1133.52 499.209 1129.05 504.718 1129.05C510.228 1129.05 514.748 1133.51 514.748 1139.12C514.748 1144.74 510.218 1149.09 504.592 1149.09C498.966 1149.09 494.615 1144.7 494.615 1139.12Z",
    fill: "url(#paint559_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.689 1143.17C607.604 1137.49 612.04 1133.1 617.666 1133.1C623.291 1133.1 627.737 1137.48 627.737 1143.17C627.737 1148.86 623.26 1153.03 617.581 1153.03C611.903 1153.03 607.604 1148.65 607.689 1143.17Z",
    fill: "url(#paint560_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.145 1107.88C497.145 1102.23 501.675 1097.81 507.216 1097.85C512.716 1097.82 517.288 1102.23 517.288 1107.88C517.288 1113.53 512.726 1117.8 507.216 1117.95C501.675 1117.81 497.145 1113.39 497.145 1107.88Z",
    fill: "url(#paint561_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M919.003 1212.39C915.242 1208.52 915.137 1202.12 919.003 1198.18C923.006 1194.34 929.275 1194.28 933.183 1198.21C937.197 1202.25 937.197 1208.52 933.215 1212.39C929.285 1216.29 923.006 1216.29 919.003 1212.39Z",
    fill: "url(#paint562_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M934.258 1177.41C930.497 1173.51 930.528 1167.24 934.437 1163.3C938.377 1159.51 944.645 1159.27 948.48 1163.2C952.621 1167.34 952.515 1173.58 948.691 1177.41C944.825 1181.41 938.377 1181.59 934.268 1177.41H934.258Z",
    fill: "url(#paint563_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M883.784 1201.9C879.844 1198.01 879.949 1191.66 883.889 1187.8C887.724 1183.75 894.066 1183.75 898.038 1187.72C901.968 1191.73 901.968 1198 898.038 1201.9C894.14 1205.77 887.861 1205.83 883.794 1201.9H883.784Z",
    fill: "url(#paint564_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M944.225 1141.6C940.148 1137.49 940.391 1131.33 944.225 1127.36C948.197 1123.46 954.571 1123.46 958.585 1127.29C962.42 1131.27 962.42 1137.67 958.585 1141.54C954.582 1145.4 948.197 1145.4 944.225 1141.6Z",
    fill: "url(#paint565_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M854.242 1182.36C850.239 1178.43 850.439 1171.94 854.274 1168.08C858.172 1164.24 864.588 1164.15 868.486 1168.01C872.458 1171.94 872.352 1178.43 868.486 1182.3C864.588 1186.16 858.172 1186.27 854.242 1182.36Z",
    fill: "url(#paint566_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M937.113 1105.27C933.004 1101.33 933.004 1095.06 936.976 1091.02C940.874 1087.16 947.247 1087.08 951.293 1090.95C955.159 1094.92 955.159 1101.22 951.188 1105.27C947.258 1109.06 940.874 1109.06 937.113 1105.27Z",
    fill: "url(#paint567_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M834.037 1158.53C830.107 1154.5 830.107 1148.15 834.037 1144.18C837.84 1140.32 844.246 1140.21 848.291 1144.18C852.126 1148.15 852.126 1154.5 848.291 1158.53C844.246 1162.26 837.84 1162.26 834.037 1158.53Z",
    fill: "url(#paint568_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1206.19 934.09C1200.69 934.09 1196.16 929.486 1196.16 924.018C1196.16 918.55 1200.69 913.946 1206.16 913.989C1211.84 913.989 1216.27 918.519 1216.27 923.955C1216.27 929.391 1211.84 934.09 1206.19 934.09Z",
    fill: "url(#paint569_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1192.25 898.555C1186.79 898.555 1182.36 893.888 1182.36 888.452C1182.44 882.879 1186.79 878.38 1192.25 878.38C1198.01 878.38 1202.43 882.879 1202.36 888.378C1202.43 893.878 1198.01 898.555 1192.25 898.555Z",
    fill: "url(#paint570_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1173.86 951.536C1168.29 951.536 1163.93 946.943 1163.93 941.538C1163.8 936.039 1168.29 931.372 1173.86 931.372C1179.43 931.372 1183.96 936.039 1183.96 941.402C1183.93 946.943 1179.51 951.431 1173.86 951.536Z",
    fill: "url(#paint571_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1173.89 866.159C1168.18 866.159 1163.92 861.597 1163.92 856.087C1163.92 850.578 1168.35 845.921 1173.89 845.879C1179.39 845.911 1184.02 850.441 1184.02 855.951C1183.95 861.597 1179.39 866.022 1173.89 866.159Z",
    fill: "url(#paint572_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1139.09 958.679C1133.59 958.542 1129.06 953.907 1129.06 948.365C1129.06 942.824 1133.59 938.336 1139.09 938.336C1144.59 938.336 1149.12 942.929 1149.12 948.502C1149.12 954.075 1144.73 958.532 1139.09 958.679Z",
    fill: "url(#paint573_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1143.14 845.5C1137.53 845.563 1133.11 841.149 1133.11 835.47C1133.11 829.792 1137.53 825.441 1143.14 825.367C1148.64 825.441 1153.11 829.824 1153.11 835.576C1153.11 840.907 1148.65 845.574 1143.14 845.51V845.5Z",
    fill: "url(#paint574_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1107.95 955.961C1102.24 955.961 1097.77 951.431 1097.85 945.932C1097.77 940.39 1102.23 935.902 1107.95 935.902C1113.67 935.902 1117.84 940.401 1117.98 945.932C1117.84 951.431 1113.45 955.961 1107.95 955.961Z",
    fill: "url(#paint575_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1212.49 534.101C1208.56 538.073 1202.12 538.073 1198.25 534.101C1194.35 530.13 1194.32 523.714 1198.25 519.953C1202.25 515.981 1208.56 515.981 1212.43 519.847C1216.26 523.714 1216.27 530.235 1212.49 534.101Z",
    fill: "url(#paint576_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1177.41 518.847C1173.54 522.714 1167.17 522.535 1163.26 518.742C1159.53 514.696 1159.29 508.47 1163.2 504.635C1167.31 500.59 1173.58 500.59 1177.48 504.498C1181.46 508.397 1181.59 514.707 1177.41 518.847Z",
    fill: "url(#paint577_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1201.94 569.321C1198.01 573.293 1191.62 573.187 1187.79 569.289C1183.76 565.454 1183.76 559.049 1187.73 555.077C1191.77 551.137 1198 551.243 1201.94 555.077C1205.77 559.049 1205.84 565.244 1201.94 569.321Z",
    fill: "url(#paint578_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1141.6 508.881C1137.52 513.063 1131.33 512.821 1127.39 508.881C1123.42 504.909 1123.42 498.609 1127.28 494.564C1131.21 490.803 1137.56 490.697 1141.53 494.564C1145.42 498.599 1145.42 504.909 1141.59 508.881H1141.6Z",
    fill: "url(#paint579_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1182.36 598.998C1178.42 602.833 1171.99 602.622 1168.08 598.788C1164.24 594.921 1164.15 588.548 1168.05 584.576C1171.99 580.709 1178.42 580.709 1182.29 584.681C1186.12 588.547 1186.26 594.921 1182.36 598.998Z",
    fill: "url(#paint580_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1105.3 516.055C1101.33 520.1 1095.06 520.1 1091.02 516.129C1087.19 512.231 1087.08 505.857 1090.95 501.811C1094.88 497.976 1101.26 497.977 1105.3 501.917C1109 505.857 1109.1 512.231 1105.3 516.065V516.055Z",
    fill: "url(#paint581_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1158.5 619.132C1154.49 623.104 1148.16 622.967 1144.18 619.132C1140.35 615.297 1140.21 608.923 1144.18 604.888C1148.16 601.022 1154.5 601.096 1158.5 604.888C1162.29 608.934 1162.29 615.308 1158.5 619.132Z",
    fill: "url(#paint582_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.762 593.287C617.15 589.874 596.996 567.097 596.996 540.475C596.996 510.618 620.995 486.376 650.504 486.376C680.013 486.376 703.886 510.618 703.886 540.475C703.886 553.854 699.293 565.864 690.454 575.304L685.86 570.984C693.488 562.725 697.639 552.179 697.639 540.475C697.639 514.063 676.463 492.676 650.504 492.676C624.546 492.676 603.359 514.063 603.359 540.475C603.359 563.884 621.111 583.943 644.678 586.977L643.772 593.277L643.762 593.287Z",
    fill: "url(#paint583_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.928 702.011C527.233 702.011 513.569 696.786 503.36 686.546C493.067 676.232 487.389 662.61 487.389 648.124C487.389 633.638 492.962 620.501 502.96 610.429C512.936 600.463 526.39 594.921 540.528 594.921C554.666 594.921 568.636 600.674 578.866 610.914C588.484 620.353 593.762 632.226 594.215 645.09L587.863 645.301C587.483 634.123 582.816 623.746 574.472 615.412C565.349 606.289 553.307 601.264 540.539 601.264C527.77 601.264 516.329 606.099 507.448 614.991C498.619 623.809 493.752 635.577 493.752 648.124C493.752 660.671 498.703 672.998 507.827 682.163C524.43 698.609 551.127 700.273 570.048 685.787L573.861 690.802C564.106 698.292 552.475 702.022 540.939 702.022L540.928 702.011Z",
    fill: "url(#paint584_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.444 856.088C510.64 856.088 486.398 832.089 486.398 802.653C486.398 773.218 510.64 749.208 540.444 749.208C553.929 749.208 565.939 753.77 575.315 762.514L570.964 767.181C562.852 759.586 552.243 755.551 540.444 755.551C514.148 755.551 492.667 776.663 492.667 802.653C492.667 828.644 514.148 849.714 540.444 849.714C563.927 849.714 584.007 831.983 587.073 808.469L593.362 809.375C589.822 835.955 567.108 856.088 540.444 856.088Z",
    fill: "url(#paint585_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.103 965.749C633.87 965.749 620.564 960.207 610.503 950.252C589.728 929.381 589.865 895.311 611.04 874.24C620.459 864.696 632.216 859.439 645.006 858.943L645.28 865.317C634.102 865.707 623.788 870.3 615.497 878.697C596.828 897.302 596.597 927.327 614.97 945.69C623.788 954.508 635.556 959.417 648.093 959.417C660.882 959.417 672.913 954.329 681.953 945.269C698.64 928.686 700.221 901.969 685.766 883.09L690.781 879.255C707.195 900.652 705.383 930.92 686.462 949.662C676.243 960.007 662.6 965.749 648.093 965.749H648.103Z",
    fill: "url(#paint586_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M802.654 966.791C773.219 966.686 749.209 942.445 749.209 912.693C749.209 899.282 753.876 887.124 762.515 877.79L767.256 882.141C759.586 890.327 755.551 900.852 755.551 912.693C755.551 938.957 776.727 960.418 802.654 960.523C828.644 960.523 849.641 939.031 849.641 912.662C849.82 889.21 831.984 869.151 808.501 866.012L809.344 859.712C836.029 863.262 856.088 886.05 856.025 912.662C856.025 942.55 832.121 966.791 802.654 966.791Z",
    fill: "url(#paint587_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M912.66 858.037C898.754 858.037 884.826 852.748 874.239 842.15C864.694 832.637 859.437 820.827 858.941 808.111L865.284 807.795C865.705 819.015 870.372 829.255 878.737 837.683C897.405 856.183 927.367 856.488 945.762 838.104C954.58 829.255 959.489 817.55 959.489 805.014C959.489 792.477 954.327 780.277 945.203 771.048C928.695 754.329 901.967 752.864 883.056 767.319L879.253 762.199C900.713 745.901 930.844 747.702 949.723 766.581C960.069 776.895 965.779 790.549 965.779 805.003C965.779 819.457 960.206 832.521 950.208 842.592C939.831 852.906 926.24 858.026 912.66 858.026V858.037Z",
    fill: "url(#paint588_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M912.661 703.855C899.145 703.855 887.093 699.23 877.748 690.58L882.099 685.913C890.211 693.509 900.809 697.512 912.651 697.512C938.989 697.512 960.407 676.368 960.512 650.483C960.512 624.567 938.989 603.423 912.546 603.423H912.303C888.999 603.423 869.109 621.153 866.043 644.7L859.701 643.867C863.325 617.118 885.828 597.154 912.303 597.154H912.546C942.539 597.154 966.781 621.09 966.781 650.494C966.717 679.961 942.465 703.855 912.651 703.855H912.661Z",
    fill: "url(#paint589_linear_22_220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M808.091 594.12L807.88 587.778C819.026 587.431 829.193 582.795 837.558 574.472C846.818 565.307 851.77 553.286 851.844 540.581C851.844 528.033 847.039 516.266 838.116 507.416C829.267 498.598 817.636 493.72 805.088 493.72C792.341 493.72 780.246 498.767 771.018 507.964C754.404 524.409 752.76 551.021 767.33 570.005L762.21 573.903C745.796 552.38 747.682 522.07 766.635 503.497C776.949 493.078 790.571 487.336 805.088 487.336C819.3 487.336 832.575 492.835 842.646 502.939C852.718 513.042 858.186 526.274 858.186 540.56C858.186 554.845 852.402 568.636 842.088 578.918C832.575 588.463 820.838 593.72 808.091 594.11V594.12Z",
    fill: "url(#paint590_linear_22_220)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_22_220",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(726.5 726.5) rotate(90) scale(726.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.711341,
    stopColor: "#FF6D3F",
    stopOpacity: 0.684214
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6D3F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_22_220",
    x1: 713.79,
    y1: 514.021,
    x2: 713.79,
    y2: 636.661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_22_220",
    x1: 739.429,
    y1: 514.029,
    x2: 739.429,
    y2: 636.661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_22_220",
    x1: 660.687,
    y1: 530.699,
    x2: 660.687,
    y2: 649.188,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_22_220",
    x1: 675.439,
    y1: 530.341,
    x2: 675.439,
    y2: 638.536,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_22_220",
    x1: 614.992,
    y1: 575.609,
    x2: 614.992,
    y2: 673.767,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_22_220",
    x1: 624.699,
    y1: 575.614,
    x2: 624.699,
    y2: 654.319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_22_220",
    x1: 584.507,
    y1: 643.528,
    x2: 584.507,
    y2: 708.142,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_22_220",
    x1: 589.86,
    y1: 639.463,
    x2: 589.86,
    y2: 681.942,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_22_220",
    x1: 575.34,
    y1: 723.364,
    x2: 575.34,
    y2: 755.245,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_22_220",
    x1: 575.383,
    y1: 697.689,
    x2: 575.383,
    y2: 729.718,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_22_220",
    x1: 589.976,
    y1: 771.755,
    x2: 589.976,
    y2: 813.727,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_22_220",
    x1: 584.494,
    y1: 745.147,
    x2: 584.494,
    y2: 810.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_22_220",
    x1: 624.718,
    y1: 798.794,
    x2: 624.718,
    y2: 877.474,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_22_220",
    x1: 614.978,
    y1: 779.363,
    x2: 614.978,
    y2: 877.475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_22_220",
    x1: 675.838,
    y1: 814.559,
    x2: 675.838,
    y2: 922.734,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_22_220",
    x1: 660.717,
    y1: 803.857,
    x2: 660.717,
    y2: 922.733,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_22_220",
    x1: 739.331,
    y1: 816.417,
    x2: 739.331,
    y2: 939.168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_22_220",
    x1: 713.718,
    y1: 816.416,
    x2: 713.718,
    y2: 939.168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_22_220",
    x1: 792.781,
    y1: 803.847,
    x2: 792.781,
    y2: 922.417,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_22_220",
    x1: 777.559,
    y1: 814.568,
    x2: 777.559,
    y2: 922.734,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_22_220",
    x1: 839.698,
    y1: 779.497,
    x2: 839.698,
    y2: 877.474,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_22_220",
    x1: 828.429,
    y1: 798.794,
    x2: 828.429,
    y2: 877.485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_22_220",
    x1: 868.651,
    y1: 744.98,
    x2: 868.651,
    y2: 809.554,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_22_220",
    x1: 863.32,
    y1: 771.151,
    x2: 863.32,
    y2: 813.725,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_22_220",
    x1: 877.81,
    y1: 697.881,
    x2: 877.81,
    y2: 729.708,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_22_220",
    x1: 877.833,
    y1: 723.344,
    x2: 877.833,
    y2: 755.382,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_22_220",
    x1: 863.16,
    y1: 639.396,
    x2: 863.16,
    y2: 681.941,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_22_220",
    x1: 868.63,
    y1: 642.93,
    x2: 868.63,
    y2: 708.016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_22_220",
    x1: 828.424,
    y1: 575.62,
    x2: 828.424,
    y2: 654.318,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_22_220",
    x1: 838.179,
    y1: 575.62,
    x2: 838.179,
    y2: 673.755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_22_220",
    x1: 777.269,
    y1: 530.338,
    x2: 777.269,
    y2: 638.536,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_22_220",
    x1: 792.388,
    y1: 530.36,
    x2: 792.388,
    y2: 649.166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_22_220",
    x1: 726.601,
    y1: 625.694,
    x2: 726.601,
    y2: 827.527,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_22_220",
    x1: 695.529,
    y1: 330.421,
    x2: 695.529,
    y2: 532.258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_22_220",
    x1: 758.143,
    y1: 330.427,
    x2: 758.143,
    y2: 532.258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_22_220",
    x1: 727.185,
    y1: 397.649,
    x2: 727.185,
    y2: 521.385,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_22_220",
    x1: 726.691,
    y1: 252.833,
    x2: 726.691,
    y2: 335.187,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_22_220",
    x1: 696.428,
    y1: 309.105,
    x2: 696.428,
    y2: 342.014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_22_220",
    x1: 759.606,
    y1: 309.066,
    x2: 759.606,
    y2: 342.246,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_22_220",
    x1: 725.659,
    y1: 331.774,
    x2: 725.659,
    y2: 332.996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_22_220",
    x1: 420.758,
    y1: 391.154,
    x2: 420.758,
    y2: 450.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_22_220",
    x1: 421.685,
    y1: 444.163,
    x2: 421.685,
    y2: 483.986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_22_220",
    x1: 463.221,
    y1: 394.067,
    x2: 463.221,
    y2: 456.225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_22_220",
    x1: 293.958,
    y1: 707.69,
    x2: 293.958,
    y2: 745.174,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_22_220",
    x1: 325.594,
    y1: 724.198,
    x2: 325.594,
    y2: 789.032,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_22_220",
    x1: 325.576,
    y1: 665.338,
    x2: 325.576,
    y2: 734.934,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_22_220",
    x1: 420.544,
    y1: 1003,
    x2: 420.544,
    y2: 1061.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_22_220",
    x1: 464.052,
    y1: 1002.77,
    x2: 464.052,
    y2: 1060.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_22_220",
    x1: 424.262,
    y1: 970.268,
    x2: 424.262,
    y2: 1009.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_22_220",
    x1: 726.431,
    y1: 1118.06,
    x2: 726.431,
    y2: 1200.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_22_220",
    x1: 756.719,
    y1: 1111.13,
    x2: 756.719,
    y2: 1144,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_22_220",
    x1: 699.519,
    y1: 1111.04,
    x2: 699.519,
    y2: 1144.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_22_220",
    x1: 1032.41,
    y1: 1003.27,
    x2: 1032.41,
    y2: 1062.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_22_220",
    x1: 1031.47,
    y1: 969.059,
    x2: 1031.47,
    y2: 1009.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_22_220",
    x1: 989.924,
    y1: 999.029,
    x2: 989.924,
    y2: 1058.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_22_220",
    x1: 1159.2,
    y1: 707.889,
    x2: 1159.2,
    y2: 745.415,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_22_220",
    x1: 1127.55,
    y1: 663.968,
    x2: 1127.55,
    y2: 728.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_22_220",
    x1: 1127.57,
    y1: 719.457,
    x2: 1127.57,
    y2: 787.641,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_22_220",
    x1: 1032.59,
    y1: 391.349,
    x2: 1032.59,
    y2: 450.116,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_22_220",
    x1: 989.086,
    y1: 393.12,
    x2: 989.086,
    y2: 450.294,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_22_220",
    x1: 1028.68,
    y1: 443.573,
    x2: 1028.68,
    y2: 482.901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_22_220",
    x1: 497.981,
    y1: 217.305,
    x2: 497.981,
    y2: 387.167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_22_220",
    x1: 578.527,
    y1: 217.283,
    x2: 578.527,
    y2: 319.132,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_22_220",
    x1: 273.63,
    y1: 514.215,
    x2: 273.63,
    y2: 644.911,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_22_220",
    x1: 298.344,
    y1: 476.69,
    x2: 298.344,
    y2: 521.491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_22_220",
    x1: 302.236,
    y1: 933.384,
    x2: 302.236,
    y2: 976.841,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_22_220",
    x1: 268.293,
    y1: 808.921,
    x2: 268.293,
    y2: 940.389,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_22_220",
    x1: 579.588,
    y1: 1122.42,
    x2: 579.588,
    y2: 1236.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_22_220",
    x1: 499.066,
    y1: 1073.22,
    x2: 499.066,
    y2: 1236.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_22_220",
    x1: 955.158,
    y1: 1066.03,
    x2: 955.158,
    y2: 1235.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_22_220",
    x1: 874.633,
    y1: 1133.87,
    x2: 874.633,
    y2: 1235.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_22_220",
    x1: 1179.49,
    y1: 808.238,
    x2: 1179.49,
    y2: 938.832,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_22_220",
    x1: 1154.74,
    y1: 931.724,
    x2: 1154.74,
    y2: 976.495,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_22_220",
    x1: 1150.91,
    y1: 476.219,
    x2: 1150.91,
    y2: 519.784,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_22_220",
    x1: 1183.13,
    y1: 512.713,
    x2: 1183.13,
    y2: 644.215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_22_220",
    x1: 873.584,
    y1: 216.385,
    x2: 873.584,
    y2: 330.773,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_22_220",
    x1: 954.08,
    y1: 216.911,
    x2: 954.08,
    y2: 381.068,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_22_220",
    x1: 515.081,
    y1: 445.563,
    x2: 515.081,
    y2: 600.283,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_22_220",
    x1: 523.221,
    y1: 444.95,
    x2: 523.221,
    y2: 584.754,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_22_220",
    x1: 538.178,
    y1: 493.184,
    x2: 538.178,
    y2: 581.446,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_22_220",
    x1: 431.442,
    y1: 723.291,
    x2: 431.442,
    y2: 791.707,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_22_220",
    x1: 431.393,
    y1: 660.797,
    x2: 431.393,
    y2: 729.086,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_22_220",
    x1: 459.509,
    y1: 697.871,
    x2: 459.509,
    y2: 753.981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_22_220",
    x1: 522.872,
    y1: 868.344,
    x2: 522.872,
    y2: 1007.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_22_220",
    x1: 514.875,
    y1: 852.685,
    x2: 514.875,
    y2: 1007.14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_22_220",
    x1: 537.322,
    y1: 870.736,
    x2: 537.322,
    y2: 959.059,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_22_220",
    x1: 757.545,
    y1: 920.876,
    x2: 757.545,
    y2: 1122.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_22_220",
    x1: 694.987,
    y1: 920.806,
    x2: 694.987,
    y2: 1122.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_22_220",
    x1: 725.92,
    y1: 931.867,
    x2: 725.92,
    y2: 1055.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_22_220",
    x1: 938.034,
    y1: 852.938,
    x2: 938.034,
    y2: 1007.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_22_220",
    x1: 929.911,
    y1: 868.406,
    x2: 929.911,
    y2: 1008.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_22_220",
    x1: 914.931,
    y1: 871.648,
    x2: 914.931,
    y2: 959.901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear_22_220",
    x1: 1021.67,
    y1: 661.408,
    x2: 1021.67,
    y2: 729.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear_22_220",
    x1: 1021.8,
    y1: 724.021,
    x2: 1021.8,
    y2: 792.286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear_22_220",
    x1: 993.634,
    y1: 699.156,
    x2: 993.634,
    y2: 755.245,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint96_linear_22_220",
    x1: 930.239,
    y1: 445.464,
    x2: 930.239,
    y2: 584.754,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint97_linear_22_220",
    x1: 938.328,
    y1: 445.949,
    x2: 938.328,
    y2: 600.462,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint98_linear_22_220",
    x1: 915.822,
    y1: 493.968,
    x2: 915.822,
    y2: 582.279,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint99_linear_22_220",
    x1: 616.631,
    y1: 426.154,
    x2: 616.631,
    y2: 483.553,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint100_linear_22_220",
    x1: 604.512,
    y1: 381.83,
    x2: 604.512,
    y2: 463.947,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint101_linear_22_220",
    x1: 610.263,
    y1: 401.476,
    x2: 610.263,
    y2: 471.186,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint102_linear_22_220",
    x1: 454.545,
    y1: 564.006,
    x2: 454.545,
    y2: 667.665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint103_linear_22_220",
    x1: 421.541,
    y1: 530.163,
    x2: 421.541,
    y2: 678.148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint104_linear_22_220",
    x1: 435.565,
    y1: 542.16,
    x2: 435.565,
    y2: 671.806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint105_linear_22_220",
    x1: 454.9,
    y1: 784.941,
    x2: 454.9,
    y2: 888.073,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint106_linear_22_220",
    x1: 422.85,
    y1: 774.442,
    x2: 422.85,
    y2: 922.733,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint107_linear_22_220",
    x1: 436.28,
    y1: 779.478,
    x2: 436.28,
    y2: 906.424,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint108_linear_22_220",
    x1: 615.823,
    y1: 969.865,
    x2: 615.823,
    y2: 1027.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint109_linear_22_220",
    x1: 604.199,
    y1: 988.837,
    x2: 604.199,
    y2: 1074.23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint110_linear_22_220",
    x1: 607.017,
    y1: 983.684,
    x2: 607.017,
    y2: 1051.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint111_linear_22_220",
    x1: 836.563,
    y1: 969.526,
    x2: 836.563,
    y2: 1026.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint112_linear_22_220",
    x1: 848.615,
    y1: 989.305,
    x2: 848.615,
    y2: 1071.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint113_linear_22_220",
    x1: 842.854,
    y1: 981.81,
    x2: 842.854,
    y2: 1051.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint114_linear_22_220",
    x1: 998.592,
    y1: 785.489,
    x2: 998.592,
    y2: 889.19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint115_linear_22_220",
    x1: 1031.56,
    y1: 774.948,
    x2: 1031.56,
    y2: 922.945,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint116_linear_22_220",
    x1: 1017.57,
    y1: 781.338,
    x2: 1017.57,
    y2: 910.956,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint117_linear_22_220",
    x1: 998.243,
    y1: 564.912,
    x2: 998.243,
    y2: 668.183,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint118_linear_22_220",
    x1: 1030.22,
    y1: 530.319,
    x2: 1030.22,
    y2: 678.529,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint119_linear_22_220",
    x1: 1016.78,
    y1: 546.762,
    x2: 1016.78,
    y2: 673.756,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint120_linear_22_220",
    x1: 837.276,
    y1: 425.728,
    x2: 837.276,
    y2: 483.206,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint121_linear_22_220",
    x1: 848.868,
    y1: 378.884,
    x2: 848.868,
    y2: 464.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint122_linear_22_220",
    x1: 846.128,
    y1: 401.657,
    x2: 846.128,
    y2: 469.521,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint123_linear_22_220",
    x1: 576.095,
    y1: 302.568,
    x2: 576.095,
    y2: 427.264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint124_linear_22_220",
    x1: 359.437,
    y1: 490.918,
    x2: 359.437,
    y2: 667.877,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint125_linear_22_220",
    x1: 364.905,
    y1: 792.192,
    x2: 364.905,
    y2: 961.882,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint126_linear_22_220",
    x1: 579.331,
    y1: 1032.66,
    x2: 579.331,
    y2: 1154.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint127_linear_22_220",
    x1: 877.028,
    y1: 1025.88,
    x2: 877.028,
    y2: 1150.63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint128_linear_22_220",
    x1: 1093.54,
    y1: 785.167,
    x2: 1093.54,
    y2: 962.303,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint129_linear_22_220",
    x1: 1088.24,
    y1: 491.232,
    x2: 1088.24,
    y2: 661.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint130_linear_22_220",
    x1: 873.782,
    y1: 298.5,
    x2: 873.782,
    y2: 420.364,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint131_linear_22_220",
    x1: 525.305,
    y1: 193.024,
    x2: 525.305,
    y2: 195.047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint132_linear_22_220",
    x1: 517.23,
    y1: 116.118,
    x2: 517.23,
    y2: 195.659,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint133_linear_22_220",
    x1: 484.919,
    y1: 125.473,
    x2: 484.919,
    y2: 160.661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint134_linear_22_220",
    x1: 469.849,
    y1: 151.966,
    x2: 469.849,
    y2: 198.282,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint135_linear_22_220",
    x1: 454.696,
    y1: 183.006,
    x2: 454.696,
    y2: 226.769,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint136_linear_22_220",
    x1: 452.946,
    y1: 214.727,
    x2: 452.946,
    y2: 251.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint137_linear_22_220",
    x1: 464.958,
    y1: 239.643,
    x2: 464.958,
    y2: 282.827,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint138_linear_22_220",
    x1: 479.841,
    y1: 240.085,
    x2: 479.841,
    y2: 312.546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint139_linear_22_220",
    x1: 577.956,
    y1: 219.997,
    x2: 577.956,
    y2: 261.576,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint140_linear_22_220",
    x1: 604.758,
    y1: 197.449,
    x2: 604.758,
    y2: 234.586,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint141_linear_22_220",
    x1: 574.621,
    y1: 166.084,
    x2: 574.621,
    y2: 218.036,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint142_linear_22_220",
    x1: 551.512,
    y1: 135.893,
    x2: 551.512,
    y2: 207.026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint143_linear_22_220",
    x1: 534.842,
    y1: 193.236,
    x2: 534.842,
    y2: 228.982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint144_linear_22_220",
    x1: 506.45,
    y1: 191.181,
    x2: 506.45,
    y2: 245.142,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint145_linear_22_220",
    x1: 515.932,
    y1: 197.513,
    x2: 515.932,
    y2: 240.085,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint146_linear_22_220",
    x1: 207.693,
    y1: 491.118,
    x2: 207.693,
    y2: 493.626,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint147_linear_22_220",
    x1: 171.779,
    y1: 442.625,
    x2: 171.779,
    y2: 505.962,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint148_linear_22_220",
    x1: 139.658,
    y1: 473.465,
    x2: 139.658,
    y2: 509.017,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint149_linear_22_220",
    x1: 155.13,
    y1: 501.765,
    x2: 155.13,
    y2: 542.392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint150_linear_22_220",
    x1: 165.87,
    y1: 521.474,
    x2: 165.87,
    y2: 573.366,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint151_linear_22_220",
    x1: 185.054,
    y1: 542.287,
    x2: 185.054,
    y2: 603.739,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint152_linear_22_220",
    x1: 209.038,
    y1: 542.73,
    x2: 209.038,
    y2: 621.713,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint153_linear_22_220",
    x1: 237.598,
    y1: 543.152,
    x2: 237.598,
    y2: 620.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint154_linear_22_220",
    x1: 277.622,
    y1: 469.105,
    x2: 277.622,
    y2: 503.519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint155_linear_22_220",
    x1: 272.581,
    y1: 438.274,
    x2: 272.581,
    y2: 473.662,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint156_linear_22_220",
    x1: 240.935,
    y1: 416.803,
    x2: 240.935,
    y2: 497.313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint157_linear_22_220",
    x1: 211.097,
    y1: 414.506,
    x2: 211.097,
    y2: 494.458,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint158_linear_22_220",
    x1: 226.412,
    y1: 488.36,
    x2: 226.412,
    y2: 506.394,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint159_linear_22_220",
    x1: 209.343,
    y1: 491.561,
    x2: 209.343,
    y2: 546.438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint160_linear_22_220",
    x1: 218.368,
    y1: 494.974,
    x2: 218.368,
    y2: 539.917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint161_linear_22_220",
    x1: 194.014,
    y1: 927.053,
    x2: 194.014,
    y2: 928.591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint162_linear_22_220",
    x1: 155.933,
    y1: 915.443,
    x2: 155.933,
    y2: 956.309,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint163_linear_22_220",
    x1: 143.081,
    y1: 950.525,
    x2: 143.081,
    y2: 985.955,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint164_linear_22_220",
    x1: 175.218,
    y1: 949.672,
    x2: 175.218,
    y2: 1017.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint165_linear_22_220",
    x1: 204.835,
    y1: 958.364,
    x2: 204.835,
    y2: 1038.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint166_linear_22_220",
    x1: 233.239,
    y1: 959.617,
    x2: 233.239,
    y2: 1041,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint167_linear_22_220",
    x1: 261.263,
    y1: 952.443,
    x2: 261.263,
    y2: 1023.97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint168_linear_22_220",
    x1: 276.277,
    y1: 952.623,
    x2: 276.277,
    y2: 993.899,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint169_linear_22_220",
    x1: 240.82,
    y1: 838.284,
    x2: 240.82,
    y2: 911.998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint170_linear_22_220",
    x1: 216.043,
    y1: 832.194,
    x2: 216.043,
    y2: 864.453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint171_linear_22_220",
    x1: 192.085,
    y1: 845.574,
    x2: 192.085,
    y2: 911.555,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint172_linear_22_220",
    x1: 171.463,
    y1: 873.704,
    x2: 171.463,
    y2: 929.487,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint173_linear_22_220",
    x1: 211.144,
    y1: 908.447,
    x2: 211.144,
    y2: 928.022,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint174_linear_22_220",
    x1: 218.224,
    y1: 927.601,
    x2: 218.224,
    y2: 965.822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint175_linear_22_220",
    x1: 218.8,
    y1: 914.807,
    x2: 218.8,
    y2: 959.627,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint176_linear_22_220",
    x1: 492.399,
    y1: 1245.34,
    x2: 492.399,
    y2: 1245.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint177_linear_22_220",
    x1: 474.301,
    y1: 1256.14,
    x2: 474.301,
    y2: 1306.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint178_linear_22_220",
    x1: 491.255,
    y1: 1295.77,
    x2: 491.255,
    y2: 1331.14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint179_linear_22_220",
    x1: 522.085,
    y1: 1258.3,
    x2: 522.085,
    y2: 1337.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint180_linear_22_220",
    x1: 547.446,
    y1: 1249.86,
    x2: 547.446,
    y2: 1324.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint181_linear_22_220",
    x1: 573.008,
    y1: 1240.23,
    x2: 573.008,
    y2: 1295.89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint182_linear_22_220",
    x1: 582.26,
    y1: 1223.11,
    x2: 582.26,
    y2: 1265.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint183_linear_22_220",
    x1: 581.847,
    y1: 1197.75,
    x2: 581.847,
    y2: 1233.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint184_linear_22_220",
    x1: 486.315,
    y1: 1136.93,
    x2: 486.315,
    y2: 1213.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint185_linear_22_220",
    x1: 455.967,
    y1: 1163.25,
    x2: 455.967,
    y2: 1197.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint186_linear_22_220",
    x1: 457.072,
    y1: 1194.25,
    x2: 457.072,
    y2: 1230.23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint187_linear_22_220",
    x1: 454.456,
    y1: 1220.98,
    x2: 454.456,
    y2: 1263.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint188_linear_22_220",
    x1: 497.434,
    y1: 1208.54,
    x2: 497.434,
    y2: 1244.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint189_linear_22_220",
    x1: 519.03,
    y1: 1225.28,
    x2: 519.03,
    y2: 1262.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint190_linear_22_220",
    x1: 517.442,
    y1: 1213.48,
    x2: 517.442,
    y2: 1255.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint191_linear_22_220",
    x1: 927.885,
    y1: 1258.03,
    x2: 927.885,
    y2: 1260.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint192_linear_22_220",
    x1: 935.907,
    y1: 1257.4,
    x2: 935.907,
    y2: 1337.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint193_linear_22_220",
    x1: 968.255,
    y1: 1292.38,
    x2: 968.255,
    y2: 1327.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint194_linear_22_220",
    x1: 983.353,
    y1: 1254.61,
    x2: 983.353,
    y2: 1301.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint195_linear_22_220",
    x1: 998.424,
    y1: 1226.44,
    x2: 998.424,
    y2: 1270.14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint196_linear_22_220",
    x1: 1000.29,
    y1: 1201.28,
    x2: 1000.29,
    y2: 1238.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint197_linear_22_220",
    x1: 988.193,
    y1: 1170.31,
    x2: 988.193,
    y2: 1213.43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint198_linear_22_220",
    x1: 973.294,
    y1: 1140.6,
    x2: 973.294,
    y2: 1213.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint199_linear_22_220",
    x1: 875.078,
    y1: 1191.45,
    x2: 875.078,
    y2: 1233.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint200_linear_22_220",
    x1: 848.36,
    y1: 1218.52,
    x2: 848.36,
    y2: 1255.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint201_linear_22_220",
    x1: 878.489,
    y1: 1235.12,
    x2: 878.489,
    y2: 1287.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint202_linear_22_220",
    x1: 901.605,
    y1: 1246.04,
    x2: 901.605,
    y2: 1317.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint203_linear_22_220",
    x1: 918.251,
    y1: 1224.1,
    x2: 918.251,
    y2: 1259.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint204_linear_22_220",
    x1: 946.611,
    y1: 1207.93,
    x2: 946.611,
    y2: 1261.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint205_linear_22_220",
    x1: 937.172,
    y1: 1213.12,
    x2: 937.172,
    y2: 1255.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint206_linear_22_220",
    x1: 1245.47,
    y1: 959.417,
    x2: 1245.47,
    y2: 962.061,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint207_linear_22_220",
    x1: 1281.33,
    y1: 947.164,
    x2: 1281.33,
    y2: 1010.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint208_linear_22_220",
    x1: 1313.5,
    y1: 944.12,
    x2: 1313.5,
    y2: 979.518,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint209_linear_22_220",
    x1: 1297.98,
    y1: 910.786,
    x2: 1297.98,
    y2: 951.431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint210_linear_22_220",
    x1: 1287.15,
    y1: 879.717,
    x2: 1287.15,
    y2: 931.689,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint211_linear_22_220",
    x1: 1268.06,
    y1: 849.335,
    x2: 1268.06,
    y2: 910.723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint212_linear_22_220",
    x1: 1244.09,
    y1: 831.289,
    x2: 1244.09,
    y2: 910.313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint213_linear_22_220",
    x1: 1215.66,
    y1: 832.542,
    x2: 1215.66,
    y2: 909.944,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint214_linear_22_220",
    x1: 1175.42,
    y1: 949.598,
    x2: 1175.42,
    y2: 984.006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint215_linear_22_220",
    x1: 1180.59,
    y1: 979.518,
    x2: 1180.59,
    y2: 1014.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint216_linear_22_220",
    x1: 1212.23,
    y1: 955.676,
    x2: 1212.23,
    y2: 1036.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint217_linear_22_220",
    x1: 1242.12,
    y1: 958.785,
    x2: 1242.12,
    y2: 1038.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint218_linear_22_220",
    x1: 1226.64,
    y1: 946.627,
    x2: 1226.64,
    y2: 964.674,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint219_linear_22_220",
    x1: 1243.82,
    y1: 906.678,
    x2: 1243.82,
    y2: 961.619,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint220_linear_22_220",
    x1: 1234.72,
    y1: 913.312,
    x2: 1234.72,
    y2: 958.132,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint221_linear_22_220",
    x1: 1259.09,
    y1: 524.316,
    x2: 1259.09,
    y2: 526.023,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint222_linear_22_220",
    x1: 1297.23,
    y1: 496.818,
    x2: 1297.23,
    y2: 537.726,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint223_linear_22_220",
    x1: 1310.06,
    y1: 467.157,
    x2: 1310.06,
    y2: 502.581,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint224_linear_22_220",
    x1: 1277.87,
    y1: 436.073,
    x2: 1277.87,
    y2: 503.656,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint225_linear_22_220",
    x1: 1248.29,
    y1: 414.413,
    x2: 1248.29,
    y2: 494.88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint226_linear_22_220",
    x1: 1219.81,
    y1: 412.179,
    x2: 1219.81,
    y2: 493.626,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint227_linear_22_220",
    x1: 1191.82,
    y1: 429.225,
    x2: 1191.82,
    y2: 500.696,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint228_linear_22_220",
    x1: 1176.83,
    y1: 459.199,
    x2: 1176.83,
    y2: 500.589,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint229_linear_22_220",
    x1: 1212.33,
    y1: 541.013,
    x2: 1212.33,
    y2: 614.791,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint230_linear_22_220",
    x1: 1237.08,
    y1: 588.622,
    x2: 1237.08,
    y2: 620.807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint231_linear_22_220",
    x1: 1261.03,
    y1: 541.593,
    x2: 1261.03,
    y2: 607.712,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint232_linear_22_220",
    x1: 1281.58,
    y1: 523.619,
    x2: 1281.58,
    y2: 579.424,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint233_linear_22_220",
    x1: 1241.94,
    y1: 525.073,
    x2: 1241.94,
    y2: 544.626,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint234_linear_22_220",
    x1: 1234.87,
    y1: 487.368,
    x2: 1234.87,
    y2: 525.685,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint235_linear_22_220",
    x1: 1234.35,
    y1: 493.637,
    x2: 1234.35,
    y2: 538.369,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint236_linear_22_220",
    x1: 960.772,
    y1: 207.447,
    x2: 960.772,
    y2: 207.785,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint237_linear_22_220",
    x1: 978.866,
    y1: 146.522,
    x2: 978.866,
    y2: 197.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint238_linear_22_220",
    x1: 961.815,
    y1: 121.923,
    x2: 961.815,
    y2: 157.279,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint239_linear_22_220",
    x1: 931.065,
    y1: 115.434,
    x2: 931.065,
    y2: 194.763,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint240_linear_22_220",
    x1: 905.702,
    y1: 128.645,
    x2: 905.702,
    y2: 203.202,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint241_linear_22_220",
    x1: 880.024,
    y1: 157.268,
    x2: 880.024,
    y2: 212.863,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint242_linear_22_220",
    x1: 870.823,
    y1: 188.011,
    x2: 870.823,
    y2: 230.078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint243_linear_22_220",
    x1: 871.282,
    y1: 219.71,
    x2: 871.282,
    y2: 255.309,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint244_linear_22_220",
    x1: 966.802,
    y1: 239.212,
    x2: 966.802,
    y2: 316.14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint245_linear_22_220",
    x1: 997.135,
    y1: 255.298,
    x2: 997.135,
    y2: 289.801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint246_linear_22_220",
    x1: 995.98,
    y1: 222.935,
    x2: 995.98,
    y2: 258.986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint247_linear_22_220",
    x1: 998.679,
    y1: 190.051,
    x2: 998.679,
    y2: 232.037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint248_linear_22_220",
    x1: 955.734,
    y1: 208.396,
    x2: 955.734,
    y2: 244.584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint249_linear_22_220",
    x1: 934.122,
    y1: 190.808,
    x2: 934.122,
    y2: 227.717,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint250_linear_22_220",
    x1: 935.687,
    y1: 197.123,
    x2: 935.687,
    y2: 239.632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint251_linear_22_220",
    x1: 725.004,
    y1: 195.606,
    x2: 725.004,
    y2: 316.139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint252_linear_22_220",
    x1: 724.392,
    y1: 208.385,
    x2: 724.392,
    y2: 214.201,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint253_linear_22_220",
    x1: 702.55,
    y1: 213.2,
    x2: 702.55,
    y2: 219.041,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint254_linear_22_220",
    x1: 684.763,
    y1: 226.86,
    x2: 684.763,
    y2: 232.676,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint255_linear_22_220",
    x1: 674.457,
    y1: 246.709,
    x2: 674.457,
    y2: 252.468,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint256_linear_22_220",
    x1: 673.478,
    y1: 269.084,
    x2: 673.478,
    y2: 274.847,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint257_linear_22_220",
    x1: 682.066,
    y1: 289.701,
    x2: 682.066,
    y2: 295.599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint258_linear_22_220",
    x1: 761.001,
    y1: 296.631,
    x2: 761.001,
    y2: 302.415,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint259_linear_22_220",
    x1: 773.052,
    y1: 277.782,
    x2: 773.052,
    y2: 283.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint260_linear_22_220",
    x1: 775.911,
    y1: 255.508,
    x2: 775.911,
    y2: 261.309,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint261_linear_22_220",
    x1: 769.175,
    y1: 234.203,
    x2: 769.175,
    y2: 240,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint262_linear_22_220",
    x1: 754.081,
    y1: 217.717,
    x2: 754.081,
    y2: 223.485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint263_linear_22_220",
    x1: 400.693,
    y1: 331.104,
    x2: 400.693,
    y2: 475.136,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint264_linear_22_220",
    x1: 360.653,
    y1: 360.81,
    x2: 360.653,
    y2: 366.634,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint265_linear_22_220",
    x1: 348.668,
    y1: 379.708,
    x2: 348.668,
    y2: 385.527,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint266_linear_22_220",
    x1: 345.754,
    y1: 401.846,
    x2: 345.754,
    y2: 407.756,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint267_linear_22_220",
    x1: 352.484,
    y1: 423.189,
    x2: 352.484,
    y2: 429.046,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint268_linear_22_220",
    x1: 367.568,
    y1: 439.708,
    x2: 367.568,
    y2: 445.543,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint269_linear_22_220",
    x1: 388.249,
    y1: 448.289,
    x2: 388.249,
    y2: 454.051,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint270_linear_22_220",
    x1: 448.945,
    y1: 397.376,
    x2: 448.945,
    y2: 403.089,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint271_linear_22_220",
    x1: 444.083,
    y1: 375.473,
    x2: 444.083,
    y2: 381.291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint272_linear_22_220",
    x1: 430.412,
    y1: 357.707,
    x2: 430.412,
    y2: 363.548,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint273_linear_22_220",
    x1: 410.61,
    y1: 347.361,
    x2: 410.61,
    y2: 353.249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint274_linear_22_220",
    x1: 388.219,
    y1: 346.535,
    x2: 388.219,
    y2: 352.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint275_linear_22_220",
    x1: 255.916,
    y1: 655.709,
    x2: 255.916,
    y2: 800.389,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint276_linear_22_220",
    x1: 211.229,
    y1: 725.81,
    x2: 211.229,
    y2: 731.625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint277_linear_22_220",
    x1: 216.156,
    y1: 747.666,
    x2: 216.156,
    y2: 753.462,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint278_linear_22_220",
    x1: 229.782,
    y1: 765.396,
    x2: 229.782,
    y2: 771.228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint279_linear_22_220",
    x1: 249.62,
    y1: 775.693,
    x2: 249.62,
    y2: 781.572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint280_linear_22_220",
    x1: 271.938,
    y1: 776.815,
    x2: 271.938,
    y2: 782.487,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint281_linear_22_220",
    x1: 292.682,
    y1: 768.213,
    x2: 292.682,
    y2: 773.956,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint282_linear_22_220",
    x1: 299.589,
    y1: 689.171,
    x2: 299.589,
    y2: 695.058,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint283_linear_22_220",
    x1: 280.67,
    y1: 677.236,
    x2: 280.67,
    y2: 682.961,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint284_linear_22_220",
    x1: 258.46,
    y1: 674.296,
    x2: 258.46,
    y2: 680.033,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint285_linear_22_220",
    x1: 237.123,
    y1: 681.009,
    x2: 237.123,
    y2: 686.818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint286_linear_22_220",
    x1: 220.657,
    y1: 696.116,
    x2: 220.657,
    y2: 701.935,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint287_linear_22_220",
    x1: 403.154,
    y1: 980.635,
    x2: 403.154,
    y2: 1124.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint288_linear_22_220",
    x1: 363.694,
    y1: 1089.65,
    x2: 363.694,
    y2: 1095.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint289_linear_22_220",
    x1: 382.633,
    y1: 1101.56,
    x2: 382.633,
    y2: 1107.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint290_linear_22_220",
    x1: 404.828,
    y1: 1104.49,
    x2: 404.828,
    y2: 1110.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint291_linear_22_220",
    x1: 426.1,
    y1: 1097.72,
    x2: 426.1,
    y2: 1103.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint292_linear_22_220",
    x1: 442.626,
    y1: 1082.63,
    x2: 442.626,
    y2: 1088.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint293_linear_22_220",
    x1: 451.21,
    y1: 1062.02,
    x2: 451.21,
    y2: 1067.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint294_linear_22_220",
    x1: 400.285,
    y1: 1001.32,
    x2: 400.285,
    y2: 1007.14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint295_linear_22_220",
    x1: 378.426,
    y1: 1006.14,
    x2: 378.426,
    y2: 1011.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint296_linear_22_220",
    x1: 360.66,
    y1: 1019.77,
    x2: 360.66,
    y2: 1025.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint297_linear_22_220",
    x1: 350.286,
    y1: 1039.6,
    x2: 350.286,
    y2: 1045.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint298_linear_22_220",
    x1: 349.403,
    y1: 1062,
    x2: 349.403,
    y2: 1067.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint299_linear_22_220",
    x1: 728.053,
    y1: 1136.94,
    x2: 728.053,
    y2: 1257.48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint300_linear_22_220",
    x1: 728.744,
    y1: 1239.01,
    x2: 728.744,
    y2: 1244.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint301_linear_22_220",
    x1: 750.585,
    y1: 1234.04,
    x2: 750.585,
    y2: 1239.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint302_linear_22_220",
    x1: 768.338,
    y1: 1220.41,
    x2: 768.338,
    y2: 1226.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint303_linear_22_220",
    x1: 778.633,
    y1: 1200.63,
    x2: 778.633,
    y2: 1206.47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint304_linear_22_220",
    x1: 779.654,
    y1: 1178.32,
    x2: 779.654,
    y2: 1184.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint305_linear_22_220",
    x1: 771.139,
    y1: 1157.59,
    x2: 771.139,
    y2: 1163.37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint306_linear_22_220",
    x1: 692.147,
    y1: 1150.63,
    x2: 692.147,
    y2: 1156.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint307_linear_22_220",
    x1: 680.091,
    y1: 1169.57,
    x2: 680.091,
    y2: 1175.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint308_linear_22_220",
    x1: 677.162,
    y1: 1191.8,
    x2: 677.162,
    y2: 1197.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint309_linear_22_220",
    x1: 683.892,
    y1: 1213.05,
    x2: 683.892,
    y2: 1218.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint310_linear_22_220",
    x1: 699.041,
    y1: 1229.6,
    x2: 699.041,
    y2: 1235.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint311_linear_22_220",
    x1: 1052.53,
    y1: 977.864,
    x2: 1052.53,
    y2: 1121.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint312_linear_22_220",
    x1: 1092.49,
    y1: 1086.53,
    x2: 1092.49,
    y2: 1092.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint313_linear_22_220",
    x1: 1104.46,
    y1: 1067.67,
    x2: 1104.46,
    y2: 1073.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint314_linear_22_220",
    x1: 1107.4,
    y1: 1045.32,
    x2: 1107.4,
    y2: 1051.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint315_linear_22_220",
    x1: 1100.63,
    y1: 1024.07,
    x2: 1100.63,
    y2: 1029.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint316_linear_22_220",
    x1: 1085.56,
    y1: 1007.64,
    x2: 1085.56,
    y2: 1013.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint317_linear_22_220",
    x1: 1064.91,
    y1: 999.091,
    x2: 1064.91,
    y2: 1004.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint318_linear_22_220",
    x1: 1004.27,
    y1: 1049.96,
    x2: 1004.27,
    y2: 1055.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint319_linear_22_220",
    x1: 1009.01,
    y1: 1071.81,
    x2: 1009.01,
    y2: 1077.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint320_linear_22_220",
    x1: 1022.71,
    y1: 1089.52,
    x2: 1022.71,
    y2: 1095.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint321_linear_22_220",
    x1: 1042.5,
    y1: 1099.84,
    x2: 1042.5,
    y2: 1105.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint322_linear_22_220",
    x1: 1064.95,
    y1: 1100.91,
    x2: 1064.95,
    y2: 1106.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint323_linear_22_220",
    x1: 1197.2,
    y1: 652.781,
    x2: 1197.2,
    y2: 797.292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint324_linear_22_220",
    x1: 1241.85,
    y1: 721.521,
    x2: 1241.85,
    y2: 727.274,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint325_linear_22_220",
    x1: 1237,
    y1: 699.595,
    x2: 1237,
    y2: 705.434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint326_linear_22_220",
    x1: 1223.36,
    y1: 681.841,
    x2: 1223.36,
    y2: 687.632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint327_linear_22_220",
    x1: 1203.53,
    y1: 671.585,
    x2: 1203.53,
    y2: 677.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint328_linear_22_220",
    x1: 1181.21,
    y1: 670.58,
    x2: 1181.21,
    y2: 676.289,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint329_linear_22_220",
    x1: 1160.48,
    y1: 679.126,
    x2: 1160.48,
    y2: 684.917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint330_linear_22_220",
    x1: 1153.54,
    y1: 758.032,
    x2: 1153.54,
    y2: 763.884,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint331_linear_22_220",
    x1: 1172.44,
    y1: 770.12,
    x2: 1172.44,
    y2: 775.923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint332_linear_22_220",
    x1: 1194.71,
    y1: 773.081,
    x2: 1194.71,
    y2: 778.857,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint333_linear_22_220",
    x1: 1215.98,
    y1: 766.292,
    x2: 1215.98,
    y2: 772.152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint334_linear_22_220",
    x1: 1232.5,
    y1: 751.114,
    x2: 1232.5,
    y2: 756.952,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint335_linear_22_220",
    x1: 1049.95,
    y1: 328.655,
    x2: 1049.95,
    y2: 472.492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint336_linear_22_220",
    x1: 1089.44,
    y1: 357.828,
    x2: 1089.44,
    y2: 363.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint337_linear_22_220",
    x1: 1070.5,
    y1: 345.71,
    x2: 1070.5,
    y2: 351.608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint338_linear_22_220",
    x1: 1048.32,
    y1: 342.839,
    x2: 1048.32,
    y2: 348.699,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint339_linear_22_220",
    x1: 1027.01,
    y1: 349.567,
    x2: 1027.01,
    y2: 355.384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint340_linear_22_220",
    x1: 1010.52,
    y1: 364.696,
    x2: 1010.52,
    y2: 370.48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint341_linear_22_220",
    x1: 1001.96,
    y1: 385.296,
    x2: 1001.96,
    y2: 391.159,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint342_linear_22_220",
    x1: 1052.81,
    y1: 446.006,
    x2: 1052.81,
    y2: 451.713,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint343_linear_22_220",
    x1: 1074.68,
    y1: 441.257,
    x2: 1074.68,
    y2: 446.958,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint344_linear_22_220",
    x1: 1092.5,
    y1: 427.484,
    x2: 1092.5,
    y2: 433.303,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint345_linear_22_220",
    x1: 1102.85,
    y1: 407.689,
    x2: 1102.85,
    y2: 413.583,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint346_linear_22_220",
    x1: 1103.76,
    y1: 385.288,
    x2: 1103.76,
    y2: 391.054,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint347_linear_22_220",
    x1: 347.197,
    y1: 214.274,
    x2: 347.197,
    y2: 481.257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint348_linear_22_220",
    x1: 388.627,
    y1: 289.137,
    x2: 388.627,
    y2: 486.134,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint349_linear_22_220",
    x1: 271.073,
    y1: 248.45,
    x2: 271.073,
    y2: 291.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint350_linear_22_220",
    x1: 279.252,
    y1: 252.843,
    x2: 279.252,
    y2: 301.853,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint351_linear_22_220",
    x1: 287.449,
    y1: 257.816,
    x2: 287.449,
    y2: 312.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint352_linear_22_220",
    x1: 295.64,
    y1: 262.208,
    x2: 295.64,
    y2: 323.239,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint353_linear_22_220",
    x1: 303.748,
    y1: 266.708,
    x2: 303.748,
    y2: 333.932,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint354_linear_22_220",
    x1: 139.902,
    y1: 614.115,
    x2: 139.902,
    y2: 828.601,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint355_linear_22_220",
    x1: 203.492,
    y1: 633.458,
    x2: 203.492,
    y2: 822.754,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint356_linear_22_220",
    x1: 81.557,
    y1: 697.134,
    x2: 81.557,
    y2: 754.098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint357_linear_22_220",
    x1: 92.6544,
    y1: 692.361,
    x2: 92.6544,
    y2: 758.163,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint358_linear_22_220",
    x1: 104.018,
    y1: 687.863,
    x2: 104.018,
    y2: 762.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint359_linear_22_220",
    x1: 115.064,
    y1: 682.891,
    x2: 115.064,
    y2: 766.14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint360_linear_22_220",
    x1: 126.178,
    y1: 678.118,
    x2: 126.178,
    y2: 770.121,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint361_linear_22_220",
    x1: 347.796,
    y1: 970.068,
    x2: 347.796,
    y2: 1241.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint362_linear_22_220",
    x1: 387.651,
    y1: 965.159,
    x2: 387.651,
    y2: 1164.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint363_linear_22_220",
    x1: 351.866,
    y1: 1143.17,
    x2: 351.866,
    y2: 1169.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint364_linear_22_220",
    x1: 295.64,
    y1: 1081.51,
    x2: 295.64,
    y2: 1114.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint365_linear_22_220",
    x1: 363.186,
    y1: 1139.3,
    x2: 363.186,
    y2: 1164.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint366_linear_22_220",
    x1: 299.743,
    y1: 1070.09,
    x2: 299.743,
    y2: 1102.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint367_linear_22_220",
    x1: 304.405,
    y1: 1058.87,
    x2: 304.405,
    y2: 1090.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint368_linear_22_220",
    x1: 308.466,
    y1: 1047.51,
    x2: 308.466,
    y2: 1078.31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint369_linear_22_220",
    x1: 312.928,
    y1: 1036.2,
    x2: 312.928,
    y2: 1066.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint370_linear_22_220",
    x1: 317.617,
    y1: 1024.28,
    x2: 317.617,
    y2: 1053.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint371_linear_22_220",
    x1: 321.652,
    y1: 1013.02,
    x2: 321.652,
    y2: 1041.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint372_linear_22_220",
    x1: 326.075,
    y1: 1001.63,
    x2: 326.075,
    y2: 1029.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint373_linear_22_220",
    x1: 330.538,
    y1: 990.306,
    x2: 330.538,
    y2: 1017.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint374_linear_22_220",
    x1: 334.61,
    y1: 978.401,
    x2: 334.61,
    y2: 1005.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint375_linear_22_220",
    x1: 246.548,
    y1: 1194.59,
    x2: 246.548,
    y2: 1219.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint376_linear_22_220",
    x1: 254.419,
    y1: 1183.24,
    x2: 254.419,
    y2: 1214.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint377_linear_22_220",
    x1: 262.324,
    y1: 1171.32,
    x2: 262.324,
    y2: 1209.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint378_linear_22_220",
    x1: 269.809,
    y1: 1160.1,
    x2: 269.809,
    y2: 1203.89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint379_linear_22_220",
    x1: 277.351,
    y1: 1148.74,
    x2: 277.351,
    y2: 1198.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint380_linear_22_220",
    x1: 285.208,
    y1: 1137.49,
    x2: 285.208,
    y2: 1193.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint381_linear_22_220",
    x1: 292.729,
    y1: 1126.14,
    x2: 292.729,
    y2: 1188.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint382_linear_22_220",
    x1: 300.363,
    y1: 1114.82,
    x2: 300.363,
    y2: 1183.89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint383_linear_22_220",
    x1: 330.756,
    y1: 1150,
    x2: 330.756,
    y2: 1178.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint384_linear_22_220",
    x1: 287.762,
    y1: 1102.91,
    x2: 287.762,
    y2: 1136.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint385_linear_22_220",
    x1: 342.411,
    y1: 1146.27,
    x2: 342.411,
    y2: 1173.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint386_linear_22_220",
    x1: 292.16,
    y1: 1091.48,
    x2: 292.16,
    y2: 1124.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint387_linear_22_220",
    x1: 721.39,
    y1: 1173.38,
    x2: 721.39,
    y2: 1453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint388_linear_22_220",
    x1: 728.128,
    y1: 1154.08,
    x2: 728.128,
    y2: 1345.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint389_linear_22_220",
    x1: 765.428,
    y1: 1292.9,
    x2: 765.428,
    y2: 1297.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint390_linear_22_220",
    x1: 684.328,
    y1: 1291.12,
    x2: 684.328,
    y2: 1296.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint391_linear_22_220",
    x1: 770.306,
    y1: 1281.78,
    x2: 770.306,
    y2: 1286.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint392_linear_22_220",
    x1: 679.043,
    y1: 1280.04,
    x2: 679.043,
    y2: 1285.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint393_linear_22_220",
    x1: 674.107,
    y1: 1268.48,
    x2: 674.107,
    y2: 1273.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint394_linear_22_220",
    x1: 668.753,
    y1: 1257.36,
    x2: 668.753,
    y2: 1262.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint395_linear_22_220",
    x1: 663.632,
    y1: 1246.29,
    x2: 663.632,
    y2: 1251.13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint396_linear_22_220",
    x1: 658.286,
    y1: 1234.23,
    x2: 658.286,
    y2: 1239.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint397_linear_22_220",
    x1: 652.954,
    y1: 1223.26,
    x2: 652.954,
    y2: 1228.06,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint398_linear_22_220",
    x1: 647.882,
    y1: 1211.59,
    x2: 647.882,
    y2: 1216.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint399_linear_22_220",
    x1: 642.747,
    y1: 1200.44,
    x2: 642.747,
    y2: 1205.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint400_linear_22_220",
    x1: 637.199,
    y1: 1188.87,
    x2: 637.199,
    y2: 1194.23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint401_linear_22_220",
    x1: 727.049,
    y1: 1403.15,
    x2: 727.049,
    y2: 1408.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint402_linear_22_220",
    x1: 726.544,
    y1: 1391.93,
    x2: 726.544,
    y2: 1396.43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint403_linear_22_220",
    x1: 726.079,
    y1: 1379.99,
    x2: 726.079,
    y2: 1385.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint404_linear_22_220",
    x1: 725.638,
    y1: 1368.91,
    x2: 725.638,
    y2: 1374.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint405_linear_22_220",
    x1: 725.268,
    y1: 1357.79,
    x2: 725.268,
    y2: 1363.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint406_linear_22_220",
    x1: 725.032,
    y1: 1346.37,
    x2: 725.032,
    y2: 1351.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint407_linear_22_220",
    x1: 724.589,
    y1: 1335.19,
    x2: 724.589,
    y2: 1340.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint408_linear_22_220",
    x1: 724.142,
    y1: 1324.04,
    x2: 724.142,
    y2: 1329.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint409_linear_22_220",
    x1: 756.347,
    y1: 1313.35,
    x2: 756.347,
    y2: 1318.68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint410_linear_22_220",
    x1: 694.137,
    y1: 1311.91,
    x2: 694.137,
    y2: 1317.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint411_linear_22_220",
    x1: 761.457,
    y1: 1302.26,
    x2: 761.457,
    y2: 1307.14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint412_linear_22_220",
    x1: 688.98,
    y1: 1300.87,
    x2: 688.98,
    y2: 1305.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint413_linear_22_220",
    x1: 1105.89,
    y1: 971.88,
    x2: 1105.89,
    y2: 1238.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint414_linear_22_220",
    x1: 1064.46,
    y1: 966.971,
    x2: 1064.46,
    y2: 1163.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint415_linear_22_220",
    x1: 1181.98,
    y1: 1161.91,
    x2: 1181.98,
    y2: 1204.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint416_linear_22_220",
    x1: 1173.84,
    y1: 1151.19,
    x2: 1173.84,
    y2: 1200.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint417_linear_22_220",
    x1: 1165.76,
    y1: 1140.45,
    x2: 1165.76,
    y2: 1195.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint418_linear_22_220",
    x1: 1157.54,
    y1: 1129.87,
    x2: 1157.54,
    y2: 1190.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint419_linear_22_220",
    x1: 1149.36,
    y1: 1119.07,
    x2: 1149.36,
    y2: 1186.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint420_linear_22_220",
    x1: 1313.19,
    y1: 624.567,
    x2: 1313.19,
    y2: 838.948,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint421_linear_22_220",
    x1: 1249.59,
    y1: 630.456,
    x2: 1249.59,
    y2: 819.647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint422_linear_22_220",
    x1: 1371.55,
    y1: 699.02,
    x2: 1371.55,
    y2: 755.899,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint423_linear_22_220",
    x1: 1360.47,
    y1: 694.973,
    x2: 1360.47,
    y2: 760.744,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint424_linear_22_220",
    x1: 1349.15,
    y1: 690.97,
    x2: 1349.15,
    y2: 765.306,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint425_linear_22_220",
    x1: 1338.08,
    y1: 686.998,
    x2: 1338.08,
    y2: 770.184,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint426_linear_22_220",
    x1: 1326.89,
    y1: 682.89,
    x2: 1326.89,
    y2: 775.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint427_linear_22_220",
    x1: 1105.35,
    y1: 211.388,
    x2: 1105.35,
    y2: 483.037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint428_linear_22_220",
    x1: 1065.49,
    y1: 289.275,
    x2: 1065.49,
    y2: 488.116,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint429_linear_22_220",
    x1: 1101.26,
    y1: 283.775,
    x2: 1101.26,
    y2: 310.007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint430_linear_22_220",
    x1: 1157.56,
    y1: 339.021,
    x2: 1157.56,
    y2: 371.659,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint431_linear_22_220",
    x1: 1089.98,
    y1: 288.758,
    x2: 1089.98,
    y2: 313.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint432_linear_22_220",
    x1: 1153.41,
    y1: 350.937,
    x2: 1153.41,
    y2: 382.953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint433_linear_22_220",
    x1: 1148.76,
    y1: 362.916,
    x2: 1148.76,
    y2: 394.205,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint434_linear_22_220",
    x1: 1144.7,
    y1: 374.831,
    x2: 1144.7,
    y2: 405.562,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint435_linear_22_220",
    x1: 1140.2,
    y1: 386.851,
    x2: 1140.2,
    y2: 416.876,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint436_linear_22_220",
    x1: 1135.51,
    y1: 399.389,
    x2: 1135.51,
    y2: 428.793,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint437_linear_22_220",
    x1: 1131.43,
    y1: 411.304,
    x2: 1131.43,
    y2: 440.117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint438_linear_22_220",
    x1: 1126.97,
    y1: 423.218,
    x2: 1126.97,
    y2: 451.368,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint439_linear_22_220",
    x1: 1122.63,
    y1: 435.239,
    x2: 1122.63,
    y2: 462.831,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint440_linear_22_220",
    x1: 1118.54,
    y1: 447.186,
    x2: 1118.54,
    y2: 474.746,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint441_linear_22_220",
    x1: 1206.5,
    y1: 233.396,
    x2: 1206.5,
    y2: 258.407,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint442_linear_22_220",
    x1: 1198.69,
    y1: 239.012,
    x2: 1198.69,
    y2: 269.775,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint443_linear_22_220",
    x1: 1190.89,
    y1: 244.132,
    x2: 1190.89,
    y2: 281.785,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint444_linear_22_220",
    x1: 1183.3,
    y1: 249.115,
    x2: 1183.3,
    y2: 293.036,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint445_linear_22_220",
    x1: 1175.74,
    y1: 254.13,
    x2: 1175.74,
    y2: 304.362,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint446_linear_22_220",
    x1: 1167.87,
    y1: 259.071,
    x2: 1167.87,
    y2: 315.613,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint447_linear_22_220",
    x1: 1160.38,
    y1: 264.265,
    x2: 1160.38,
    y2: 327.076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint448_linear_22_220",
    x1: 1152.77,
    y1: 269.174,
    x2: 1152.77,
    y2: 338.253,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint449_linear_22_220",
    x1: 1122.34,
    y1: 274.263,
    x2: 1122.34,
    y2: 303.076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint450_linear_22_220",
    x1: 1165.43,
    y1: 316.973,
    x2: 1165.43,
    y2: 350.348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint451_linear_22_220",
    x1: 1110.66,
    y1: 279.319,
    x2: 1110.66,
    y2: 306.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint452_linear_22_220",
    x1: 1161.02,
    y1: 328.961,
    x2: 1161.02,
    y2: 361.557,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint453_linear_22_220",
    x1: 731.752,
    y1: 0,
    x2: 731.752,
    y2: 279.804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint454_linear_22_220",
    x1: 725.078,
    y1: 108.059,
    x2: 725.078,
    y2: 298.998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint455_linear_22_220",
    x1: 687.714,
    y1: 155.331,
    x2: 687.714,
    y2: 160.208,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint456_linear_22_220",
    x1: 768.827,
    y1: 156.689,
    x2: 768.827,
    y2: 161.957,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint457_linear_22_220",
    x1: 682.838,
    y1: 166.477,
    x2: 682.838,
    y2: 171.323,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint458_linear_22_220",
    x1: 774.037,
    y1: 167.772,
    x2: 774.037,
    y2: 173.135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint459_linear_22_220",
    x1: 779.021,
    y1: 179.298,
    x2: 779.021,
    y2: 184.524,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint460_linear_22_220",
    x1: 784.33,
    y1: 190.413,
    x2: 784.33,
    y2: 195.817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint461_linear_22_220",
    x1: 789.518,
    y1: 202.012,
    x2: 789.518,
    y2: 206.921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint462_linear_22_220",
    x1: 794.848,
    y1: 214,
    x2: 794.848,
    y2: 218.878,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint463_linear_22_220",
    x1: 800.16,
    y1: 225.074,
    x2: 800.16,
    y2: 229.983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint464_linear_22_220",
    x1: 805.233,
    y1: 236.157,
    x2: 805.233,
    y2: 241.551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint465_linear_22_220",
    x1: 810.404,
    y1: 247.819,
    x2: 810.404,
    y2: 252.697,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint466_linear_22_220",
    x1: 815.926,
    y1: 258.976,
    x2: 815.926,
    y2: 264.264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint467_linear_22_220",
    x1: 726.075,
    y1: 44.6587,
    x2: 726.075,
    y2: 49.9579,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint468_linear_22_220",
    x1: 726.546,
    y1: 56.5742,
    x2: 726.546,
    y2: 61.1359,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint469_linear_22_220",
    x1: 727.02,
    y1: 67.7197,
    x2: 727.02,
    y2: 73.1243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint470_linear_22_220",
    x1: 727.436,
    y1: 78.9404,
    x2: 727.436,
    y2: 84.1975,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint471_linear_22_220",
    x1: 727.841,
    y1: 89.9497,
    x2: 727.841,
    y2: 95.3437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint472_linear_22_220",
    x1: 728.141,
    y1: 101.096,
    x2: 728.141,
    y2: 106.806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint473_linear_22_220",
    x1: 728.608,
    y1: 112.136,
    x2: 728.608,
    y2: 117.951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint474_linear_22_220",
    x1: 728.935,
    y1: 123.356,
    x2: 728.935,
    y2: 129.067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint475_linear_22_220",
    x1: 696.857,
    y1: 134.397,
    x2: 696.857,
    y2: 139.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint476_linear_22_220",
    x1: 758.988,
    y1: 135.682,
    x2: 758.988,
    y2: 141.118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint477_linear_22_220",
    x1: 691.657,
    y1: 146.028,
    x2: 691.657,
    y2: 150.874,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint478_linear_22_220",
    x1: 764.123,
    y1: 147.324,
    x2: 764.123,
    y2: 152.234,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint479_linear_22_220",
    x1: 401.758,
    y1: 0.958008,
    x2: 401.758,
    y2: 300.39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint480_linear_22_220",
    x1: 550.215,
    y1: 0.998047,
    x2: 550.215,
    y2: 184.039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint481_linear_22_220",
    x1: 438.295,
    y1: 75.5044,
    x2: 438.295,
    y2: 193.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint482_linear_22_220",
    x1: 515.016,
    y1: 75.5894,
    x2: 515.016,
    y2: 140.993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint483_linear_22_220",
    x1: 419.232,
    y1: 51.8315,
    x2: 419.232,
    y2: 220.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint484_linear_22_220",
    x1: 535.229,
    y1: 45.4087,
    x2: 535.229,
    y2: 122.314,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint485_linear_22_220",
    x1: 103.099,
    y1: 418.677,
    x2: 103.099,
    y2: 652.612,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint486_linear_22_220",
    x1: 153.553,
    y1: 349.26,
    x2: 153.553,
    y2: 425.432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint487_linear_22_220",
    x1: 103.993,
    y1: 456.344,
    x2: 103.993,
    y2: 566.951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint488_linear_22_220",
    x1: 139.809,
    y1: 416.255,
    x2: 139.809,
    y2: 459.808,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint489_linear_22_220",
    x1: 89.7225,
    y1: 447.494,
    x2: 89.7225,
    y2: 606.594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint490_linear_22_220",
    x1: 137.62,
    y1: 377.623,
    x2: 137.62,
    y2: 440.933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint491_linear_22_220",
    x1: 150.715,
    y1: 1014.48,
    x2: 150.715,
    y2: 1088.31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint492_linear_22_220",
    x1: 92.617,
    y1: 784.974,
    x2: 92.617,
    y2: 1020.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint493_linear_22_220",
    x1: 134.338,
    y1: 994.029,
    x2: 134.338,
    y2: 1035.63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint494_linear_22_220",
    x1: 108.239,
    y1: 878.96,
    x2: 108.239,
    y2: 997.302,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint495_linear_22_220",
    x1: 135.98,
    y1: 1004.45,
    x2: 135.98,
    y2: 1063.31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint496_linear_22_220",
    x1: 83.8307,
    y1: 837.283,
    x2: 83.8307,
    y2: 998.465,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint497_linear_22_220",
    x1: 535.668,
    y1: 1253.09,
    x2: 535.668,
    y2: 1446.97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint498_linear_22_220",
    x1: 387.398,
    y1: 1153.29,
    x2: 387.398,
    y2: 1446.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint499_linear_22_220",
    x1: 511.663,
    y1: 1320.1,
    x2: 511.663,
    y2: 1378.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint500_linear_22_220",
    x1: 438.185,
    y1: 1249.26,
    x2: 438.185,
    y2: 1377.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint501_linear_22_220",
    x1: 527.026,
    y1: 1322.8,
    x2: 527.026,
    y2: 1403.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint502_linear_22_220",
    x1: 409.28,
    y1: 1232.07,
    x2: 409.28,
    y2: 1398.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint503_linear_22_220",
    x1: 1051.33,
    y1: 1152.8,
    x2: 1051.33,
    y2: 1452.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint504_linear_22_220",
    x1: 902.952,
    y1: 1269.22,
    x2: 902.952,
    y2: 1451.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint505_linear_22_220",
    x1: 1014.89,
    y1: 1260.02,
    x2: 1014.89,
    y2: 1377.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint506_linear_22_220",
    x1: 938.075,
    y1: 1312.27,
    x2: 938.075,
    y2: 1377.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint507_linear_22_220",
    x1: 1033.87,
    y1: 1232.99,
    x2: 1033.87,
    y2: 1401.34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint508_linear_22_220",
    x1: 917.909,
    y1: 1330.85,
    x2: 917.909,
    y2: 1407.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint509_linear_22_220",
    x1: 1350.02,
    y1: 800.525,
    x2: 1350.02,
    y2: 1034.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint510_linear_22_220",
    x1: 1299.77,
    y1: 1027.66,
    x2: 1299.77,
    y2: 1103.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint511_linear_22_220",
    x1: 1349.14,
    y1: 886.178,
    x2: 1349.14,
    y2: 996.859,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint512_linear_22_220",
    x1: 1313.31,
    y1: 993.259,
    x2: 1313.31,
    y2: 1036.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint513_linear_22_220",
    x1: 1363.38,
    y1: 846.48,
    x2: 1363.38,
    y2: 1005.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint514_linear_22_220",
    x1: 1315.52,
    y1: 1012.24,
    x2: 1315.52,
    y2: 1075.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint515_linear_22_220",
    x1: 1302.47,
    y1: 364.911,
    x2: 1302.47,
    y2: 438.663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint516_linear_22_220",
    x1: 1360.65,
    y1: 432.225,
    x2: 1360.65,
    y2: 668.198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint517_linear_22_220",
    x1: 1318.77,
    y1: 417.498,
    x2: 1318.77,
    y2: 459.028,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint518_linear_22_220",
    x1: 1344.86,
    y1: 455.886,
    x2: 1344.86,
    y2: 574.198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint519_linear_22_220",
    x1: 1317.21,
    y1: 389.764,
    x2: 1317.21,
    y2: 448.756,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint520_linear_22_220",
    x1: 1369.34,
    y1: 454.655,
    x2: 1369.34,
    y2: 615.844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint521_linear_22_220",
    x1: 917.547,
    y1: 6.15869,
    x2: 917.547,
    y2: 200.063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint522_linear_22_220",
    x1: 1065.74,
    y1: 7.06641,
    x2: 1065.74,
    y2: 299.694,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint523_linear_22_220",
    x1: 941.462,
    y1: 74.8667,
    x2: 941.462,
    y2: 133.112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint524_linear_22_220",
    x1: 1014.96,
    y1: 75.7681,
    x2: 1014.96,
    y2: 203.793,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint525_linear_22_220",
    x1: 926.094,
    y1: 49.1216,
    x2: 926.094,
    y2: 130.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint526_linear_22_220",
    x1: 1043.9,
    y1: 54.1958,
    x2: 1043.9,
    y2: 220.996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint527_linear_22_220",
    x1: 924.055,
    y1: 236.851,
    x2: 924.055,
    y2: 256.878,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint528_linear_22_220",
    x1: 888.455,
    y1: 250.568,
    x2: 888.455,
    y2: 270.711,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint529_linear_22_220",
    x1: 941.453,
    y1: 269.184,
    x2: 941.453,
    y2: 289.285,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint530_linear_22_220",
    x1: 856.06,
    y1: 269.184,
    x2: 856.06,
    y2: 289.285,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint531_linear_22_220",
    x1: 948.47,
    y1: 304.044,
    x2: 948.47,
    y2: 324.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint532_linear_22_220",
    x1: 835.501,
    y1: 300.01,
    x2: 835.501,
    y2: 320.111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint533_linear_22_220",
    x1: 945.962,
    y1: 335.26,
    x2: 945.962,
    y2: 355.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint534_linear_22_220",
    x1: 526.984,
    y1: 237.741,
    x2: 526.984,
    y2: 257.773,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint535_linear_22_220",
    x1: 511.582,
    y1: 272.623,
    x2: 511.582,
    y2: 292.719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint536_linear_22_220",
    x1: 562.194,
    y1: 248.262,
    x2: 562.194,
    y2: 268.342,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint537_linear_22_220",
    x1: 501.82,
    y1: 308.663,
    x2: 501.82,
    y2: 328.769,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint538_linear_22_220",
    x1: 591.739,
    y1: 267.886,
    x2: 591.739,
    y2: 287.97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint539_linear_22_220",
    x1: 509.065,
    y1: 344.953,
    x2: 509.065,
    y2: 365.095,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint540_linear_22_220",
    x1: 612.043,
    y1: 291.818,
    x2: 612.043,
    y2: 311.884,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint541_linear_22_220",
    x1: 246.885,
    y1: 519.057,
    x2: 246.885,
    y2: 539.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint542_linear_22_220",
    x1: 260.691,
    y1: 554.655,
    x2: 260.691,
    y2: 574.788,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint543_linear_22_220",
    x1: 279.228,
    y1: 501.6,
    x2: 279.228,
    y2: 521.701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint544_linear_22_220",
    x1: 279.275,
    y1: 586.988,
    x2: 279.275,
    y2: 607.131,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint545_linear_22_220",
    x1: 314.036,
    y1: 494.563,
    x2: 314.036,
    y2: 514.706,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint546_linear_22_220",
    x1: 310.07,
    y1: 607.637,
    x2: 310.07,
    y2: 627.769,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint547_linear_22_220",
    x1: 345.238,
    y1: 497.144,
    x2: 345.238,
    y2: 517.287,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint548_linear_22_220",
    x1: 247.778,
    y1: 916.112,
    x2: 247.778,
    y2: 936.195,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint549_linear_22_220",
    x1: 282.702,
    y1: 931.479,
    x2: 282.702,
    y2: 951.603,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint550_linear_22_220",
    x1: 258.314,
    y1: 880.86,
    x2: 258.314,
    y2: 900.976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint551_linear_22_220",
    x1: 318.702,
    y1: 941.251,
    x2: 318.702,
    y2: 961.419,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint552_linear_22_220",
    x1: 277.932,
    y1: 851.346,
    x2: 277.932,
    y2: 871.422,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint553_linear_22_220",
    x1: 355.031,
    y1: 934.046,
    x2: 355.031,
    y2: 954.141,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint554_linear_22_220",
    x1: 301.85,
    y1: 831.051,
    x2: 301.85,
    y2: 851.134,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint555_linear_22_220",
    x1: 529.149,
    y1: 1196.15,
    x2: 529.149,
    y2: 1216.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint556_linear_22_220",
    x1: 564.704,
    y1: 1182.36,
    x2: 564.704,
    y2: 1202.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint557_linear_22_220",
    x1: 511.697,
    y1: 1163.93,
    x2: 511.697,
    y2: 1183.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint558_linear_22_220",
    x1: 597.105,
    y1: 1163.73,
    x2: 597.105,
    y2: 1184.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint559_linear_22_220",
    x1: 504.682,
    y1: 1129.05,
    x2: 504.682,
    y2: 1149.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint560_linear_22_220",
    x1: 617.712,
    y1: 1133.1,
    x2: 617.712,
    y2: 1153.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint561_linear_22_220",
    x1: 507.216,
    y1: 1097.85,
    x2: 507.216,
    y2: 1117.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint562_linear_22_220",
    x1: 926.17,
    y1: 1195.28,
    x2: 926.17,
    y2: 1215.31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint563_linear_22_220",
    x1: 941.522,
    y1: 1160.35,
    x2: 941.522,
    y2: 1180.48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint564_linear_22_220",
    x1: 890.933,
    y1: 1184.75,
    x2: 890.933,
    y2: 1204.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint565_linear_22_220",
    x1: 951.359,
    y1: 1124.43,
    x2: 951.359,
    y2: 1144.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint566_linear_22_220",
    x1: 861.372,
    y1: 1165.16,
    x2: 861.372,
    y2: 1185.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint567_linear_22_220",
    x1: 944.097,
    y1: 1088.08,
    x2: 944.097,
    y2: 1108.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint568_linear_22_220",
    x1: 841.129,
    y1: 1141.24,
    x2: 841.129,
    y2: 1161.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint569_linear_22_220",
    x1: 1206.21,
    y1: 913.988,
    x2: 1206.21,
    y2: 934.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint570_linear_22_220",
    x1: 1192.36,
    y1: 878.38,
    x2: 1192.36,
    y2: 898.555,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint571_linear_22_220",
    x1: 1173.95,
    y1: 931.372,
    x2: 1173.95,
    y2: 951.536,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint572_linear_22_220",
    x1: 1173.97,
    y1: 845.879,
    x2: 1173.97,
    y2: 866.159,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint573_linear_22_220",
    x1: 1139.09,
    y1: 938.336,
    x2: 1139.09,
    y2: 958.679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint574_linear_22_220",
    x1: 1143.11,
    y1: 825.367,
    x2: 1143.11,
    y2: 845.511,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint575_linear_22_220",
    x1: 1107.91,
    y1: 935.902,
    x2: 1107.91,
    y2: 955.961,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint576_linear_22_220",
    x1: 1205.31,
    y1: 516.96,
    x2: 1205.31,
    y2: 537.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint577_linear_22_220",
    x1: 1170.44,
    y1: 501.584,
    x2: 1170.44,
    y2: 521.668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint578_linear_22_220",
    x1: 1194.8,
    y1: 552.162,
    x2: 1194.8,
    y2: 572.256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint579_linear_22_220",
    x1: 1134.43,
    y1: 491.703,
    x2: 1134.43,
    y2: 511.927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint580_linear_22_220",
    x1: 1175.19,
    y1: 581.689,
    x2: 1175.19,
    y2: 601.771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint581_linear_22_220",
    x1: 1098.1,
    y1: 498.948,
    x2: 1098.1,
    y2: 519.098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint582_linear_22_220",
    x1: 1151.3,
    y1: 602.016,
    x2: 1151.3,
    y2: 622.06,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint583_linear_22_220",
    x1: 650.441,
    y1: 486.376,
    x2: 650.441,
    y2: 593.287,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint584_linear_22_220",
    x1: 540.802,
    y1: 594.921,
    x2: 540.802,
    y2: 702.022,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint585_linear_22_220",
    x1: 539.88,
    y1: 749.208,
    x2: 539.88,
    y2: 856.088,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint586_linear_22_220",
    x1: 648.505,
    y1: 858.943,
    x2: 648.505,
    y2: 965.749,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint587_linear_22_220",
    x1: 802.617,
    y1: 859.712,
    x2: 802.617,
    y2: 966.791,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint588_linear_22_220",
    x1: 912.36,
    y1: 751.097,
    x2: 912.36,
    y2: 858.037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint589_linear_22_220",
    x1: 913.241,
    y1: 597.154,
    x2: 913.241,
    y2: 703.855,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint590_linear_22_220",
    x1: 804.62,
    y1: 487.336,
    x2: 804.62,
    y2: 594.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994226"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackimg);
export default __webpack_public_path__ + "static/media/backimg.29e05be9d4aaacf74b17cdb982609c7d.svg";
export { ForwardRef as ReactComponent };